// This file is auto-generated by @hey-api/openapi-ts

/**
 * Defining a User Schema for user with Ninja
 *
 * See: https://django-ninja.dev/guides/response/django-pydantic/
 */
export type UserSchema = {
  id?: number | null;
  email: string;
  first_name?: string | null;
  last_name?: string | null;
  role?: string | null;
};

/**
 * Defining an Agency Schema for user with Ninja
 */
export type AgencyWithStatesSchema = {
  agencyId: string;
  name: string;
  authorizedStates: Array<UsStateEnum>;
  canRefer: boolean;
};

/**
 * Current user schema that includes user details and
 * associated agencies (all if underwriter, only agent's if agent)
 */
export type CurrentUserSchema = {
  id: number;
  email: string;
  firstName: string;
  lastName: string;
  role: UserRoleType;
  agentData?: Array<AgencyWithStatesSchema> | null;
  underwriterData?: Array<AgencyWithStatesSchema> | null;
};

export type UsStateEnum =
  | 'AK'
  | 'AL'
  | 'AR'
  | 'AZ'
  | 'CA'
  | 'CO'
  | 'CT'
  | 'DC'
  | 'DE'
  | 'FL'
  | 'GA'
  | 'HI'
  | 'IA'
  | 'ID'
  | 'IL'
  | 'IN'
  | 'KS'
  | 'KY'
  | 'LA'
  | 'MA'
  | 'MD'
  | 'ME'
  | 'MI'
  | 'MN'
  | 'MO'
  | 'MS'
  | 'MT'
  | 'NC'
  | 'ND'
  | 'NE'
  | 'NH'
  | 'NJ'
  | 'NM'
  | 'NV'
  | 'NY'
  | 'OH'
  | 'OK'
  | 'OR'
  | 'PR'
  | 'PA'
  | 'RI'
  | 'SC'
  | 'SD'
  | 'TN'
  | 'TX'
  | 'UT'
  | 'VA'
  | 'VI'
  | 'VT'
  | 'WA'
  | 'WI'
  | 'WV'
  | 'WY';

export const UsStateEnum = {
  AK: 'AK',
  AL: 'AL',
  AR: 'AR',
  AZ: 'AZ',
  CA: 'CA',
  CO: 'CO',
  CT: 'CT',
  DC: 'DC',
  DE: 'DE',
  FL: 'FL',
  GA: 'GA',
  HI: 'HI',
  IA: 'IA',
  ID: 'ID',
  IL: 'IL',
  IN: 'IN',
  KS: 'KS',
  KY: 'KY',
  LA: 'LA',
  MA: 'MA',
  MD: 'MD',
  ME: 'ME',
  MI: 'MI',
  MN: 'MN',
  MO: 'MO',
  MS: 'MS',
  MT: 'MT',
  NC: 'NC',
  ND: 'ND',
  NE: 'NE',
  NH: 'NH',
  NJ: 'NJ',
  NM: 'NM',
  NV: 'NV',
  NY: 'NY',
  OH: 'OH',
  OK: 'OK',
  OR: 'OR',
  PR: 'PR',
  PA: 'PA',
  RI: 'RI',
  SC: 'SC',
  SD: 'SD',
  TN: 'TN',
  TX: 'TX',
  UT: 'UT',
  VA: 'VA',
  VI: 'VI',
  VT: 'VT',
  WA: 'WA',
  WI: 'WI',
  WV: 'WV',
  WY: 'WY',
} as const;

export type UserRoleType =
  | 'agent'
  | 'underwriter'
  | 'underwriting_admin'
  | 'system_admin';

export const UserRoleType = {
  AGENT: 'agent',
  UNDERWRITER: 'underwriter',
  UNDERWRITING_ADMIN: 'underwriting_admin',
  SYSTEM_ADMIN: 'system_admin',
} as const;

/**
 * Get all related agents for a user, grouped by agency
 */
export type RelatedAgentsSchema = {
  agency: {
    [key: string]: Array<RelatedUsersAgentUserSchema>;
  };
  agencies: {
    [key: string]: string;
  };
};

/**
 * Copy of AgentUserSchema, used for related users endpoint
 */
export type RelatedUsersAgentUserSchema = {
  id: number;
  email: string;
  firstName: string;
  lastName: string;
  role: string;
};

export type ResetPasswordResponse = {
  message: string;
};

export type ForgotPasswordSchema = {
  email: string;
};

export type ResetPasswordSchema = {
  user_id: number;
  token: string;
  new_password: string;
};

export type AccountsReceivableCoverage = 'standard' | 'higher' | 'none';

export const AccountsReceivableCoverage = {
  STANDARD: 'standard',
  HIGHER: 'higher',
  NONE: 'none',
} as const;

export type AdditionalInsured = {
  effectiveDate?: Date | null;
  expirationDate?: Date | null;
  createdOnTransactionNumber?: number | null;
  deletedOnTransactionNumber?: number | null;
  pk: string;
  entityName?: string | null;
  entityDba?: YesNoEnum | null;
  attachedForms?: Array<AttachedForm>;
  readonly isDeleted: boolean;
  readonly allTemplateFormsComplete: boolean;
};

export type AgeOfRoofResponse = {
  results?: Array<AgeOfRoofResults> | string | null;
};

export type AgeOfRoofResults = {
  ageOfRoof?: number | string | null;
  roofYear?: number | string | null;
};

export type AllFormLevels =
  | PolicyFormLevels
  | LocationFormLevels
  | PracticeLocationFormLevels
  | DentistFormLevels
  | EntityFormLevels
  | GlAdditionalInsuredFormLevels
  | PlAdditionalInsuredFormLevels
  | MissionOfMercyEventFormLevels;

export type AttachedDocumentType =
  | 'new_business_application'
  | 'renewal_application'
  | 'part_time_supplement'
  | 'roster'
  | 'schedule_of_values'
  | 'holistic_questionnaire'
  | 'elective_cosmetic_questionnaire'
  | 'gap_in_practice_questionnaire'
  | 'employment_practices_liability_application'
  | 'oral_surgeon_supplemental_application'
  | 'dental_anesthesiologist_supplemental_application'
  | 'loss_runs'
  | 'claims_narrative'
  | 'license_verification'
  | 'corporation_verification'
  | 'board_action_documents'
  | 'endorsement_request'
  | 'cancellation_request'
  | 'email'
  | 'erp_request_to_issue'
  | 'bind_order'
  | 'underwriting_information'
  | 'inspection'
  | 'appeal'
  | 'proof_of_risk_management'
  | 'prior_carrier_declarations'
  | 'lost_policy_release'
  | 'coi'
  | 'contract'
  | 'physician_statement'
  | 'financials'
  | 'debit_credit_worksheet'
  | 'irpm_worksheet'
  | 'insured_correspondence'
  | 'non_renewal_notice'
  | 'cancellation_notice'
  | 'premium_notice'
  | 'conditional_renewal_notice'
  | 'premium_renewal_notice'
  | 'premium_statement'
  | 'quote_proposal'
  | 'policy_specimen'
  | 'policy_bundle'
  | 'user_uploaded'
  | 'other'
  | 'rescind_notice';

export const AttachedDocumentType = {
  NEW_BUSINESS_APPLICATION: 'new_business_application',
  RENEWAL_APPLICATION: 'renewal_application',
  PART_TIME_SUPPLEMENT: 'part_time_supplement',
  ROSTER: 'roster',
  SCHEDULE_OF_VALUES: 'schedule_of_values',
  HOLISTIC_QUESTIONNAIRE: 'holistic_questionnaire',
  ELECTIVE_COSMETIC_QUESTIONNAIRE: 'elective_cosmetic_questionnaire',
  GAP_IN_PRACTICE_QUESTIONNAIRE: 'gap_in_practice_questionnaire',
  EMPLOYMENT_PRACTICES_LIABILITY_APPLICATION:
    'employment_practices_liability_application',
  ORAL_SURGEON_SUPPLEMENTAL_APPLICATION:
    'oral_surgeon_supplemental_application',
  DENTAL_ANESTHESIOLOGIST_SUPPLEMENTAL_APPLICATION:
    'dental_anesthesiologist_supplemental_application',
  LOSS_RUNS: 'loss_runs',
  CLAIMS_NARRATIVE: 'claims_narrative',
  LICENSE_VERIFICATION: 'license_verification',
  CORPORATION_VERIFICATION: 'corporation_verification',
  BOARD_ACTION_DOCUMENTS: 'board_action_documents',
  ENDORSEMENT_REQUEST: 'endorsement_request',
  CANCELLATION_REQUEST: 'cancellation_request',
  EMAIL: 'email',
  ERP_REQUEST_TO_ISSUE: 'erp_request_to_issue',
  BIND_ORDER: 'bind_order',
  UNDERWRITING_INFORMATION: 'underwriting_information',
  INSPECTION: 'inspection',
  APPEAL: 'appeal',
  PROOF_OF_RISK_MANAGEMENT: 'proof_of_risk_management',
  PRIOR_CARRIER_DECLARATIONS: 'prior_carrier_declarations',
  LOST_POLICY_RELEASE: 'lost_policy_release',
  COI: 'coi',
  CONTRACT: 'contract',
  PHYSICIAN_STATEMENT: 'physician_statement',
  FINANCIALS: 'financials',
  DEBIT_CREDIT_WORKSHEET: 'debit_credit_worksheet',
  IRPM_WORKSHEET: 'irpm_worksheet',
  INSURED_CORRESPONDENCE: 'insured_correspondence',
  NON_RENEWAL_NOTICE: 'non_renewal_notice',
  CANCELLATION_NOTICE: 'cancellation_notice',
  PREMIUM_NOTICE: 'premium_notice',
  CONDITIONAL_RENEWAL_NOTICE: 'conditional_renewal_notice',
  PREMIUM_RENEWAL_NOTICE: 'premium_renewal_notice',
  PREMIUM_STATEMENT: 'premium_statement',
  QUOTE_PROPOSAL: 'quote_proposal',
  POLICY_SPECIMEN: 'policy_specimen',
  POLICY_BUNDLE: 'policy_bundle',
  USER_UPLOADED: 'user_uploaded',
  OTHER: 'other',
  RESCIND_NOTICE: 'rescind_notice',
} as const;

export type AttachedForm = {
  id: string;
  uniqueAttachmentId: string;
  versionNumber: number;
  documentType: DocumentTypeEnum;
  name: string;
  formId: string;
  isTemplate: boolean;
  file: DocumentOdtFile;
  activeFrom: Date | null;
  deprecationDate: Date | null;
  dropOnRenewal: boolean;
  attachedBy: 'system' | UserObject;
  userVariables?: {
    [key: string]: unknown;
  };
  formLevel?: AllFormLevels | null;
  intentDescription?: string;
  attachmentDescription?: string;
  transactionNumber: number;
};

export type Bcegs =
  | 'one'
  | 'two'
  | 'three'
  | 'four'
  | 'five'
  | 'six'
  | 'seven'
  | 'eight'
  | 'nine'
  | 'ten'
  | 'ungraded'
  | 'non_participating';

export const Bcegs = {
  ONE: 'one',
  TWO: 'two',
  THREE: 'three',
  FOUR: 'four',
  FIVE: 'five',
  SIX: 'six',
  SEVEN: 'seven',
  EIGHT: 'eight',
  NINE: 'nine',
  TEN: 'ten',
  UNGRADED: 'ungraded',
  NON_PARTICIPATING: 'non_participating',
} as const;

export type BasicEarthquakeLimits = 'Not Eligible' | '$50,000';

export const BasicEarthquakeLimits = {
  NOT_ELIGIBLE: 'Not Eligible',
  $50_000: '$50,000',
} as const;

export type BlackBagCoverage = {
  bagType: BlackBagTypeEnum;
  totalLimit: number;
  description?: string | null;
};

export type BlackBagCoverageDict = {
  bagType: BlackBagTypeEnum;
  totalLimit: number;
  description?: string | null;
  practiceLocationPk: string;
};

export type BlackBagTypeEnum = 'standard' | 'higher';

export const BlackBagTypeEnum = {
  STANDARD: 'standard',
  HIGHER: 'higher',
} as const;

export type BuildingInflationGuard =
  | '0.3%'
  | '0.4%'
  | '0.5%'
  | '1.0%'
  | '1.5%'
  | '2.0%'
  | '2.5%'
  | '3.0%'
  | '3.5%'
  | '4.0%'
  | '4.5%'
  | '5.0%';

export const BuildingInflationGuard = {
  _0_3_: '0.3%',
  _0_4_: '0.4%',
  _0_5_: '0.5%',
  _1_0_: '1.0%',
  _1_5_: '1.5%',
  _2_0_: '2.0%',
  _2_5_: '2.5%',
  _3_0_: '3.0%',
  _3_5_: '3.5%',
  _4_0_: '4.0%',
  _4_5_: '4.5%',
  _5_0_: '5.0%',
} as const;

export type BundledPropertyEnhancementEndorsement =
  | 'gold'
  | 'none'
  | 'platinum';

export const BundledPropertyEnhancementEndorsement = {
  GOLD: 'gold',
  NONE: 'none',
  PLATINUM: 'platinum',
} as const;

export type CancelTypeEnum = 'flat_cancel' | 'pro_rata' | 'short';

export const CancelTypeEnum = {
  FLAT_CANCEL: 'flat_cancel',
  PRO_RATA: 'pro_rata',
  SHORT: 'short',
} as const;

export type CancellationReasonEnum =
  | 'due_to_non_payment'
  | 'requested_by_insured'
  | 'failure_to_renew'
  | 'requested_by_company';

export const CancellationReasonEnum = {
  DUE_TO_NON_PAYMENT: 'due_to_non_payment',
  REQUESTED_BY_INSURED: 'requested_by_insured',
  FAILURE_TO_RENEW: 'failure_to_renew',
  REQUESTED_BY_COMPANY: 'requested_by_company',
} as const;

export type CommercialCertification =
  | 'bronze'
  | 'silver'
  | 'gold'
  | 'not_applicable';

export const CommercialCertification = {
  BRONZE: 'bronze',
  SILVER: 'silver',
  GOLD: 'gold',
  NOT_APPLICABLE: 'not_applicable',
} as const;

export type CommercialProperty = {
  effectiveDate?: Date | null;
  expirationDate?: Date | null;
  createdOnTransactionNumber?: number | null;
  deletedOnTransactionNumber?: number | null;
  insuranceLineKey?: InsuranceLinesEnum | null;
  locations?: Array<Location>;
  coverage?: Coverage;
  coveragePart?: CoveragePart;
  veriskRawResponse?: VeriskBusinessOwnerResponse | null;
  corelogicRawResponse?: CoreLogicAllApiResponses | null;
  readonly isDeleted: boolean;
};

export type ComponentSociety = {
  name?: string | null;
  priorActs?: Date | null;
};

export type ConsentType = 'na' | 'first_named_insured' | 'insured_dentist';

export const ConsentType = {
  NA: 'na',
  FIRST_NAMED_INSURED: 'first_named_insured',
  INSURED_DENTIST: 'insured_dentist',
} as const;

export type ConstructionType =
  | 'frame'
  | 'jointed_masonry'
  | 'non_combustible'
  | 'masonry_non_combustible'
  | 'modified_fire_resistive'
  | 'fire_resistive';

export const ConstructionType = {
  FRAME: 'frame',
  JOINTED_MASONRY: 'jointed_masonry',
  NON_COMBUSTIBLE: 'non_combustible',
  MASONRY_NON_COMBUSTIBLE: 'masonry_non_combustible',
  MODIFIED_FIRE_RESISTIVE: 'modified_fire_resistive',
  FIRE_RESISTIVE: 'fire_resistive',
} as const;

export type CoreLogicAllApiResponses = {
  flood_risk_response?: FloodRiskScoreResponse | null;
  us_earthquake_hazard_response?: UsEarthquakeHazardResponse | null;
  distance_to_shore_response?: DistanceToShoreResponse | null;
  wild_fire_risk_response?: WildfireRiskResponse | null;
  hail_risk_response?: HailRiskResponse | null;
  non_weather_water_risk?: NonWeatherRiskScoreResponse | null;
  wind_risk_score?: WindRiskScoreResponse | null;
  crime_risk_score?: CrimeRiskScoreResponse | null;
  major_system_permits?: MajorSystemPermitsResponse | null;
  roof_age?: AgeOfRoofResponse | null;
};

export type Coverage = {
  bundledPropertyEnhancementEndorsements?: BundledPropertyEnhancementEndorsement | null;
  employeeDishonestyCoverageDesired?: YesNoEnum | null;
  employeeDishonestyCoverage?: EmployeeDishonestyCoverage | null;
  employeeDishonestyCoverageChoice?: StandardOrHigher | null;
  floridaSinkholeCoverageDesired?: YesNoEnum | null;
  fungiCoverageDesired?: YesNoEnum | null;
  propertyClaim?: YesNoEnum | null;
  currentlyResidence?: YesNoEnum | null;
  mostlyVacant?: YesNoEnum | null;
  trailerHome?: YesNoEnum | null;
  increasedWelfareLimitsDesired?: YesNoEnum | null;
  increasedWelfareLimits?: number | null;
};

export type CoverageAmount = {
  writtenAmount?: number;
  annualAmount?: number;
  billedAmount?: number;
  amountType?: 'premium' | 'tax';
};

export type amountType = 'premium' | 'tax';

export const amountType = {
  PREMIUM: 'premium',
  TAX: 'tax',
} as const;

export type CoverageBasis = 'claims' | 'occurrence';

export const CoverageBasis = {
  CLAIMS: 'claims',
  OCCURRENCE: 'occurrence',
} as const;

export type CoveragePart = {
  writtenPolicyPremium?: number;
  annualPolicyPremium?: number;
  billedPolicyPremium?: number;
  premiumDetail?: {
    [key: string]: unknown;
  };
};

export type CrimeRiskScoreResponse = {
  riskIndex: number | string | null;
};

export type Deductible = '2500' | '5000';

export const Deductible = {
  _2500: '2500',
  _5000: '5000',
} as const;

export type DefenseDeductibleDesired =
  | 'none'
  | 'limit_2_5k'
  | 'limit_5k'
  | 'limit_10k'
  | 'limit_15k'
  | 'limit_25k'
  | 'limit_50k'
  | 'limit_75k'
  | 'limit_100k'
  | 'limit_250k';

export const DefenseDeductibleDesired = {
  NONE: 'none',
  LIMIT_2_5K: 'limit_2_5k',
  LIMIT_5K: 'limit_5k',
  LIMIT_10K: 'limit_10k',
  LIMIT_15K: 'limit_15k',
  LIMIT_25K: 'limit_25k',
  LIMIT_50K: 'limit_50k',
  LIMIT_75K: 'limit_75k',
  LIMIT_100K: 'limit_100k',
  LIMIT_250K: 'limit_250k',
} as const;

export type Dentist = {
  pk?: string;
  information?: DentistInformation;
  additionalPricing?: DentistAdditionalPricing;
  procedures?: DentistProcedures;
  underwritingQuestions?: DentistUnderwritingQuestions;
  ratedPrice?: number | null;
  finalRatedClassification?: string | null;
  attachedForms?: Array<AttachedForm>;
  premiums?: {
    [key: string]: CoverageAmount;
  };
  taxes?: {
    [key: string]: CoverageAmount;
  };
  premiumDetail?: {
    [key: string]: unknown;
  };
  readonly isDeleted: boolean;
  readonly expirationDate: Date | null;
  readonly effectiveDate: Date | null;
  readonly allTemplateFormsComplete: boolean;
};

export type DentistAdditionalPricing = {
  claimsClosed?: YesNoEnum | null;
  experienceRatingFactor?: number | null;
  yearOfLastClaim?: number | null;
  dentistFlatPremiumAdjustment?: number | null;
  lossPreventionMod?: number | null;
  treatmentUnderIvSedation?: YesNoEnum | null;
  treatmentUnderOralSedation?: YesNoEnum | null;
  treatmentByAnother?: YesNoEnum | null;
  procedureMix?: number | null;
  procedureMixExplanation?: string | null;
  completeHistory?: YesNoEnum | null;
  cbctImaging?: YesNoEnum | null;
  residencyCompleted?: YesNoEnum | null;
  boardCertified?: YesNoEnum | null;
  exposureMod?: number | null;
  exposureModExplanation?: string | null;
  electiveCosmeticProcedures?: YesNoEnum | null;
  holisticServices?: YesNoEnum | null;
  locumTenens?: YesNoEnum | null;
  teledentistry?: YesNoEnum | null;
  tempStaffingAgency?: YesNoEnum | null;
  unusualRiskCharacteristics?: number | null;
  additionalUnusualRiskCharacteristicsExplanation?: UnusualRiskExplanation | null;
  unusualRiskCharacteristicsExplanation?: string | null;
  underwritingSpecificRiskCharacteristics?: number | null;
  underwritingSpecificRiskCharacteristicsExplanation?: string | null;
  totalScheduleRatingForDentistPl?: number | null;
};

export type DentistFormLevels =
  | 'INSURED_DENTIST'
  | 'INSURED_DENTIST_AND_OWNED_ENTITY';

export const DentistFormLevels = {
  INSURED_DENTIST: 'INSURED_DENTIST',
  INSURED_DENTIST_AND_OWNED_ENTITY: 'INSURED_DENTIST_AND_OWNED_ENTITY',
} as const;

export type DentistInformation = {
  erpEnabled?: boolean;
  erpEffectiveDate?: Date | null;
  erpType?: ErpType | null;
  erpDuration?: ErpDuration | null;
  civilRegulatoryErpEnabled?: boolean | null;
  effectiveDate?: Date | null;
  expirationDate?: Date | null;
  createdOnTransactionNumber?: number | null;
  deletedOnTransactionNumber?: number | null;
  dentistId: string;
  firstName?: string;
  middleName?: string | null;
  lastName?: string;
  professionalDesignation?: Array<
    'BDS' | 'DDS' | 'DMD' | 'MD' | 'MS' | 'MSD' | 'DDM'
  >;
  numHoursPerWeek?: WeeklyPracticeHours | null;
  practiceSpecialty?: PracticeSpecialty | null;
  primaryPracticeLocation?: string | null;
  yearsInPractice?: YearsPracticing | null;
  yearsWithAspen?: number | null;
  boardCertified?: YesNoEnum | null;
  dateOfBirth?: Date | null;
  datePcfPremiumReceived?: Date | null;
  differentLimitDesired?: YesNoEnum | null;
  emailAddress?: string | null;
  inPcfCertificateNumber?: string | null;
  inPcfFundParticipation?: InpcfParticipation | null;
  inPcfProviderId?: string | null;
  inPcfSurchargeAmount?: number | null;
  laPcfFundParticipation?: YesNoEnum | null;
  leaveOfAbsence?: LeaveOfAbsence | null;
  licenses?: Array<DentistLicense>;
  memberOfSda?: YesNoEnum | null;
  nameOfDentalSchool?: string | null;
  yearMonthGraduation?: YearMonth | null;
  firstTimePractice?: YesNoEnum | null;
  newDentistType?: NewDentistType | null;
  noseCoverage?: YesNoEnum | null;
  noseCoverageLiabilityLimits?: LimitsEnum | null;
  noseCoveragePriorActsDate?: Date | null;
  numYearsDuration?: DurationYears | null;
  npiNumber?: number | null;
  optinForRiskNewsletter?: YesNoEnum | null;
  practiceProfile?: PracticeProfile | null;
  priorActsDate?: Date | null;
  professionalLiabilityLimit?: LimitsEnum | null;
  renumeration?: YesNoEnum | null;
  residencyCompleted?: YesNoEnum | null;
  riskManagementSeminar?: YesNoEnum | null;
  secondaryPracticeLocations?: Array<string>;
  volunteerServices?: string | null;
  workScheduleAvailable?: YesNoEnum | null;
  yearOfAttendance?: number | null;
  yearsWithoutClaim?: YearsNoClaims | null;
  reviewRequired?: YesNoEnum | null;
  agreedRepresentationsAndFraud?: YesNoEnum | null;
  signature?: string | null;
  signatureDate?: Date | null;
  /**
   * Calculate ERP expiration date by adding erp_duration to erp_effective_date
   */
  readonly erpExpirationDate: Date | null;
  readonly isDeleted: boolean;
};

export type DentistLicense = {
  licenseNumber?: string | null;
  licenseState?: UsStateEnum | null;
  licenseStatus?: string | null;
  priorDisciplinaryAction?: YesNoEnum | null;
};

export type DentistProcedures = {
  generalAnesthesia?: YesNoEnum | null;
  procedures?: Array<Procedure>;
  noProcedures?: boolean;
  completeHealthHistory?: YesNoEnum | null;
  patientRecordNoted?: YesNoEnum | null;
  professionalServices?: Array<ProfessionalService>;
  whoAdministersAnesthesia?: WhoAdministersAnesthesia | null;
};

export type DentistSchedule = {
  pk: string;
  priorActsDate: Date | null;
};

export type DentistUnderwritingQuestions = {
  coveredByAnotherPolicy?: YesNoEnum | null;
  currentCarrier?: string | null;
  hasAbsence?: YesNoEnum | null;
  hasMaintainedCoverage?: YesNoEnum | null;
  hasMalpracticeClaim?: YesNoEnum | null;
  hasPendingClaims?: YesNoEnum | null;
  hasReportedSituation?: YesNoEnum | null;
  negativeEventExplanation?: string | null;
  negativeEvents?: {
    [key: string]: YesNoEnum | null;
  };
  whereServicesRendered?: Array<RendersService>;
  yearsContinuousCoverage?: number | null;
  treatmentOfSleepApnea?: YesNoEnum | null;
};

export type Details = {
  entityName?: string | null;
  associatedDba?: string | null;
  entityCoverage?: EntityCoverage | null;
  entityFein?: string | null;
  stateOfDomicile?: UsStateEnum | null;
  dentistsSchedule?: Array<string>;
  firstNamedInsuredIndicator?: YesNoEnum | null;
  businessPurpose?: string | null;
  priorActsDate?: Date | null;
  inPcfFundParticipation?: InpcfParticipation | null;
  inPcfProviderId?: string | null;
  inPcfCertificateNumber?: string | null;
  datePcfPremiumReceived?: Date | null;
  inPcfSurchargeAmount?: number | null;
};

export type DistanceAttributes = {
  distancefeet?: number | null;
};

export type DistanceToCoast = {
  distance?: number | null;
  unit?: DistanceUnit | null;
};

export type DistanceToShoreResponse = {
  attributes: DistanceAttributes | MessageAttributes;
};

export type DistanceUnit = 'feet' | 'miles';

export const DistanceUnit = {
  FEET: 'feet',
  MILES: 'miles',
} as const;

export type DocumentOdtFile = {
  cmsS3FilePath: string;
  fileType: string;
  fileHash: string;
};

export type DocumentTypeEnum =
  | 'ENDORSEMENT'
  | 'AMENDATORY'
  | 'STAMPS'
  | 'NOTICE'
  | 'COVERAGE_POLICY_FORM'
  | 'POLICY_DECLARATIONS'
  | 'COVER_PAGE'
  | 'POLICY_FORM_TOC'
  | 'QUOTE_DECLARATIONS'
  | 'GTC_POLICY_FORM';

export const DocumentTypeEnum = {
  ENDORSEMENT: 'ENDORSEMENT',
  AMENDATORY: 'AMENDATORY',
  STAMPS: 'STAMPS',
  NOTICE: 'NOTICE',
  COVERAGE_POLICY_FORM: 'COVERAGE_POLICY_FORM',
  POLICY_DECLARATIONS: 'POLICY_DECLARATIONS',
  COVER_PAGE: 'COVER_PAGE',
  POLICY_FORM_TOC: 'POLICY_FORM_TOC',
  QUOTE_DECLARATIONS: 'QUOTE_DECLARATIONS',
  GTC_POLICY_FORM: 'GTC_POLICY_FORM',
} as const;

export type DurationYears = '1' | '2' | '3';

export const DurationYears = {
  _1: '1',
  _2: '2',
  _3: '3',
} as const;

export type EpliCoverageType =
  | 'no_coverage'
  | 'defense'
  | 'indemnity_defense_standard'
  | 'indemnity_defense_enhanced';

export const EpliCoverageType = {
  NO_COVERAGE: 'no_coverage',
  DEFENSE: 'defense',
  INDEMNITY_DEFENSE_STANDARD: 'indemnity_defense_standard',
  INDEMNITY_DEFENSE_ENHANCED: 'indemnity_defense_enhanced',
} as const;

export type ErisaAndEmployeeBenefits = {
  erpEnabled?: boolean;
  erpEffectiveDate?: Date | null;
  erpType?: ErpType | null;
  erpDuration?: ErpDuration | null;
  civilRegulatoryErpEnabled?: boolean | null;
  effectiveDate?: Date | null;
  expirationDate?: Date | null;
  createdOnTransactionNumber?: number | null;
  deletedOnTransactionNumber?: number | null;
  insuranceLineKey?: InsuranceLinesEnum | null;
  limitOfInsurance?: ErisaLimitOfInsurance | null;
  priorActsDate?: Date | null;
  totalEmployees?: number | null;
  anyLosses?: YesNoEnum | null;
  coveragePart?: CoveragePart;
  /**
   * Calculate ERP expiration date by adding erp_duration to erp_effective_date
   */
  readonly erpExpirationDate: Date | null;
  readonly isDeleted: boolean;
};

export type ErisaLimitOfInsurance =
  | '25k'
  | '100k'
  | '101k'
  | '250k'
  | '500k'
  | '750k'
  | '1m';

export const ErisaLimitOfInsurance = {
  _25K: '25k',
  _100K: '100k',
  _101K: '101k',
  _250K: '250k',
  _500K: '500k',
  _750K: '750k',
  _1M: '1m',
} as const;

/**
 * ERP Duration
 */
export type ErpDuration =
  | '1 Year'
  | '2 Years'
  | '3 Years'
  | '5 Years'
  | 'Unlimited';

/**
 * ERP Duration
 */
export const ErpDuration = {
  _1_YEAR: '1 Year',
  _2_YEARS: '2 Years',
  _3_YEARS: '3 Years',
  _5_YEARS: '5 Years',
  UNLIMITED: 'Unlimited',
} as const;

export type ErpType = 'Prepaid' | 'Free';

export const ErpType = {
  PREPAID: 'Prepaid',
  FREE: 'Free',
} as const;

export type EarthquakeBuildingClassification =
  | 'A1'
  | 'B1'
  | 'C1'
  | 'D1'
  | 'D2'
  | 'D3'
  | 'E1'
  | 'E2'
  | 'E3';

export const EarthquakeBuildingClassification = {
  A1: 'A1',
  B1: 'B1',
  C1: 'C1',
  D1: 'D1',
  D2: 'D2',
  D3: 'D3',
  E1: 'E1',
  E2: 'E2',
  E3: 'E3',
} as const;

export type EarthquakeCoverage =
  | 'standard'
  | 'higher'
  | 'not_eligible'
  | 'none'
  | 'desired';

export const EarthquakeCoverage = {
  STANDARD: 'standard',
  HIGHER: 'higher',
  NOT_ELIGIBLE: 'not_eligible',
  NONE: 'none',
  DESIRED: 'desired',
} as const;

export type ElectronicEquipCoverage = 'standard' | 'higher' | 'none';

export const ElectronicEquipCoverage = {
  STANDARD: 'standard',
  HIGHER: 'higher',
  NONE: 'none',
} as const;

export type Employee = {
  employeeType?: EmployeeType | null;
  numFulltime?: number | null;
  numParttime?: number | null;
};

export type EmployeeDishonestyCoverage =
  | '$100,000'
  | '$50,000'
  | '$75,000'
  | '$35,000';

export const EmployeeDishonestyCoverage = {
  $100_000: '$100,000',
  $50_000: '$50,000',
  $75_000: '$75,000',
  $35_000: '$35,000',
} as const;

export type EmployeeType =
  | 'dental_anesthesiologists'
  | 'dentists'
  | 'oral_surgeons';

export const EmployeeType = {
  DENTAL_ANESTHESIOLOGISTS: 'dental_anesthesiologists',
  DENTISTS: 'dentists',
  ORAL_SURGEONS: 'oral_surgeons',
} as const;

export type EmploymentPracticesLiability = {
  erpEnabled?: boolean;
  erpEffectiveDate?: Date | null;
  erpType?: ErpType | null;
  erpDuration?: ErpDuration | null;
  civilRegulatoryErpEnabled?: boolean | null;
  effectiveDate?: Date | null;
  expirationDate?: Date | null;
  createdOnTransactionNumber?: number | null;
  deletedOnTransactionNumber?: number | null;
  insuranceLineKey?: InsuranceLinesEnum | null;
  epliCoverageType?: EpliCoverageType | null;
  dentistsSchedule?: Array<DentistSchedule>;
  entitiesSchedule?: Array<EntitySchedule>;
  epliPriorActsDate?: Date | null;
  numNonDentistEmployees?: number | null;
  numIndependentDentists?: number | null;
  numEmployeeDentists?: number | null;
  numIndependentHygienists?: number | null;
  limitOfInsurance?: LimitOfInsurance | null;
  deductible?: Deductible | null;
  sublimitedCoverageDesired?: YesNoEnum | null;
  negativeEvents?: Array<GlacierPolicyDomainTypeDictsNegativeEvent> | null;
  negativeEventsExplanation?: string | null;
  natureOfOperations?: number | null;
  natureOfWorkforce?: number | null;
  salaries?: number | null;
  writtenProcedures?: number | null;
  electronicCommunicationPolicies?: number | null;
  experienceRatingValue?: number | null;
  coveragePart?: CoveragePart;
  /**
   * Calculate ERP expiration date by adding erp_duration to erp_effective_date
   */
  readonly erpExpirationDate: Date | null;
  readonly isDeleted: boolean;
  readonly totalIndividuals: number;
  readonly totalScheduleRating: number;
};

export type EntityCoverage =
  | 'none'
  | 'separate'
  | 'shared'
  | 'share_first_name';

export const EntityCoverage = {
  NONE: 'none',
  SEPARATE: 'separate',
  SHARED: 'shared',
  SHARE_FIRST_NAME: 'share_first_name',
} as const;

export type EntityFormLevels = 'INSURED_DENTIST_AND_OWNED_ENTITY';

export type EntitySchedule = {
  pk: string;
  priorActsDate: Date | null;
};

/**
 * Entity Shared Limits Type options
 */
export type EntitySharedLimitsType =
  | 'shared_with_member_dentists'
  | 'shared_with_other_entities';

/**
 * Entity Shared Limits Type options
 */
export const EntitySharedLimitsType = {
  SHARED_WITH_MEMBER_DENTISTS: 'shared_with_member_dentists',
  SHARED_WITH_OTHER_ENTITIES: 'shared_with_other_entities',
} as const;

export type EntityType = 'association' | 'testing_board';

export const EntityType = {
  ASSOCIATION: 'association',
  TESTING_BOARD: 'testing_board',
} as const;

export type EquipmentBreakdownDeductible =
  | '500'
  | '1000'
  | '2500'
  | '5000'
  | '10000';

export const EquipmentBreakdownDeductible = {
  _500: '500',
  _1000: '1000',
  _2500: '2500',
  _5000: '5000',
  _10000: '10000',
} as const;

export type FileDocument = {
  createdBy: UserObject | null;
  replacedBy?: UserObject | null;
  createdAt: Date;
  lastReplacedAt?: Date | null;
  createdAtTransaction: number;
  documentType: AttachedDocumentType;
  systemGenerated: boolean;
  originalSequenceNumber: number;
  file: ImmutableFile;
  description?: string;
  subcategory?: string;
  fileHistory?: Array<ImmutableFile>;
};

export type FireWaterLimit = '500k' | '750k' | '1m';

export const FireWaterLimit = {
  _500K: '500k',
  _750K: '750k',
  _1M: '1m',
} as const;

export type FirstNamedInsuredType =
  | 'corporation'
  | 'individual'
  | 'llc'
  | 'llp'
  | 'other'
  | 'partnership'
  | 'pc_pa'
  | 'multi_individual';

export const FirstNamedInsuredType = {
  CORPORATION: 'corporation',
  INDIVIDUAL: 'individual',
  LLC: 'llc',
  LLP: 'llp',
  OTHER: 'other',
  PARTNERSHIP: 'partnership',
  PC_PA: 'pc_pa',
  MULTI_INDIVIDUAL: 'multi_individual',
} as const;

export type FloodCoverage = 'standard' | 'higher' | 'not_eligible';

export const FloodCoverage = {
  STANDARD: 'standard',
  HIGHER: 'higher',
  NOT_ELIGIBLE: 'not_eligible',
} as const;

export type FloodRiskScoreResponse = {
  baseRiskScore: string | null;
  baseRiskRating: string | null;
  floodZone: string | null;
};

export type FormulasForUi = {
  subcoverage_key: string;
  subcoverage_display: string;
  level: PremiumFormulaLevelEnum;
  reference_id: string;
  annual_premium: number;
  billed_premium: number;
  written_premium: number;
  formula: string;
  formula_text: string;
  effective_date: Date;
  expiration_date: Date;
  grouping?: PremiumFormulaGroupingEnum;
  amount_type?: 'premium' | 'tax';
  annual_amount?: number;
  billed_amount?: number;
  written_amount?: number;
};

export type amount_type = 'premium' | 'tax';

export const amount_type = {
  PREMIUM: 'premium',
  TAX: 'tax',
} as const;

export type GeneralLiability = {
  effectiveDate?: Date | null;
  expirationDate?: Date | null;
  createdOnTransactionNumber?: number | null;
  deletedOnTransactionNumber?: number | null;
  insuranceLineKey?: InsuranceLinesEnum | null;
  limitOfInsurance?: LimitsEnum | null;
  separateAggregate?: YesNoEnum | null;
  hiredAutoDamage?: YesNoEnum | null;
  fireWaterLegalLimit?: FireWaterLimit | null;
  losses?: YesNoEnum | null;
  locationIdsGlNotCharged?: Array<string>;
  stopGapCoverageDesired?: YesNoEnum | null;
  stopGapLimit?: StopGapLimit | null;
  additionalInsured?: Array<GeneralLiabilityAdditionalInsured>;
  flatPremiumAdjustment?: number | null;
  coveragePart?: CoveragePart;
  readonly isDeleted: boolean;
};

export type GeneralLiabilityAdditionalInsured = {
  effectiveDate?: Date | null;
  expirationDate?: Date | null;
  createdOnTransactionNumber?: number | null;
  deletedOnTransactionNumber?: number | null;
  pk: string;
  fallbackPk?: string | null;
  typeOfContract?: TypeOfContract | null;
  entityName?: string | null;
  entityAddress?: UsAddress | null;
  newEntityAddress?: string | null;
  insuredLocation?: string | null;
  description?: string | null;
  attachedForms?: Array<AttachedForm>;
  readonly isDeleted: boolean;
  readonly allTemplateFormsComplete: boolean;
};

export type GlAdditionalInsuredFormLevels =
  | 'GL_ADDITIONAL_INSURED'
  | 'GL_ADDITIONAL_INSURED_OR_LOCATION';

export const GlAdditionalInsuredFormLevels = {
  GL_ADDITIONAL_INSURED: 'GL_ADDITIONAL_INSURED',
  GL_ADDITIONAL_INSURED_OR_LOCATION: 'GL_ADDITIONAL_INSURED_OR_LOCATION',
} as const;

export type HailRiskResponse = {
  riskScore: string | null;
};

export type HoldHarmlessClause = 'yes' | 'no' | 'unsure';

export const HoldHarmlessClause = {
  YES: 'yes',
  NO: 'no',
  UNSURE: 'unsure',
} as const;

export type InpcfParticipation = 'no' | 'refer' | 'yes';

export const InpcfParticipation = {
  NO: 'no',
  REFER: 'refer',
  YES: 'yes',
} as const;

export type ImmutableFile = {
  pk: string;
  name: string;
  contentType: string;
  hash: string;
  size: number;
  isRendered?: boolean;
  pdfContext?: Array<Odt2PdfContext>;
  readonly downloadUrl: string;
};

export type InflationGuard =
  | 'N/A'
  | '0.3%'
  | '0.4%'
  | '0.5%'
  | '1.0%'
  | '1.5%'
  | '2.0%'
  | '2.5%'
  | '3.0%'
  | '3.5%'
  | '4.0%'
  | '4.5%'
  | '5.0%';

export const InflationGuard = {
  N_A: 'N/A',
  _0_3_: '0.3%',
  _0_4_: '0.4%',
  _0_5_: '0.5%',
  _1_0_: '1.0%',
  _1_5_: '1.5%',
  _2_0_: '2.0%',
  _2_5_: '2.5%',
  _3_0_: '3.0%',
  _3_5_: '3.5%',
  _4_0_: '4.0%',
  _4_5_: '4.5%',
  _5_0_: '5.0%',
} as const;

export type Information = {
  accountsReceivableCoverage?: AccountsReceivableCoverage | null;
  blanketDentalPracticePersonalPropertyDesired?: YesNoEnum | null;
  accountsReceivableLimit?: number | null;
  appurtenantStructureDesired?: YesNoEnum | null;
  appurtenantStructureLimit?: number | null;
  appurtenantStructureDescription?: string | null;
  roofSurfactingLimitationsDesired?: YesNoEnum | null;
  electronicEquipSurgeProtectors?: YesNoEnum | null;
  equipmentBreakdownDeductible?: EquipmentBreakdownDeductible | null;
  basicEarthquakeLimits?: BasicEarthquakeLimits | null;
  basicFloodLimits?: number | null;
  buildingAllowableRange?: number | null;
  buildingCoverageDesired?: YesNoEnum | null;
  buildingInflationGuard?: BuildingInflationGuard | null;
  buildingLeasedToOthers?: YesNoEnum | null;
  buildingLimit?: number | null;
  buildingReplacementCost?: number | null;
  contentsInflationGuard?: InflationGuard | null;
  contentsLimit?: number | null;
  earthquakeBuildingClass?: EarthquakeBuildingClassification | null;
  ordinanceIncreaseLimitDesired?: OrdinanceLimit | null;
  demolitionIncreasedLimitDesired?: OrdinanceLimit | null;
  demolitionLimit?: number | null;
  electronicEquipCoverage?: ElectronicEquipCoverage | null;
  totalElectronicEquipLimit?: number | null;
  equipmentBreakdownCoverageDesired?: YesNoEnum | null;
  grossAnnualizedRevenue?: number | null;
  higherLossAssessmentLimit?: number | null;
  incomeDocumentationReceived?: YesNoEnum | null;
  insuredIsFirstTimePracticeOwner?: YesNoEnum | null;
  locationFlatDeductible?: number | null;
  lossAssessment?: LossAssessment | null;
  mineSubsidenceDesired?: YesNoEnum | null;
  mineSubsidenceLimit?: number | null;
  namedStormDeductible?: NamedStormDeductible | null;
  numberOfDaysOpenPerWeek?: number | null;
  percentageLeasedToOthers?: number | null;
  practiceIncomeWaitingPeriod?: PracticeIncomeWaitingPeriod | null;
  rentsCoverageDesired?: YesNoEnum | null;
  rentsLimitOfInsurance?: number | null;
  valuedDailyLimitDays?: number | null;
  windhailCoverage?: WindHailCoverage | null;
  sewerBackupCoverage?: SewerBackupCoverage | null;
  totalSewerBackupLimit?: number | null;
  pollutionLimitCoverage?: StandardOrHigher | null;
  totalPollutionLimit?: number | null;
  floodCoverage?: FloodCoverage | null;
  totalFloodLimit?: number | null;
  earthquakeCoverage?: EarthquakeCoverage | null;
  totalEarthquakeLimit?: number | null;
  lossAssessmentCoverage?: LossAssessment | null;
  totalLossAssessmentLimit?: number | null;
  offPremCoverage?: OffPremCoverage | null;
  totalOffPremLimit?: number | null;
  signsCoverage?: StandardOrHigher | null;
  totalSignsLimit?: number | null;
};

export type InformedConsentType = 'written' | 'oral' | 'none';

export const InformedConsentType = {
  WRITTEN: 'written',
  ORAL: 'oral',
  NONE: 'none',
} as const;

/**
 * Insurance Lines/Coverages
 */
export type InsuranceLinesEnum = 'pl' | 'epli' | 'gl' | 'erisa' | 'cp';

/**
 * Insurance Lines/Coverages
 */
export const InsuranceLinesEnum = {
  PL: 'pl',
  EPLI: 'epli',
  GL: 'gl',
  ERISA: 'erisa',
  CP: 'cp',
} as const;

export type InvoicePreference = 'direct' | 'agency';

export const InvoicePreference = {
  DIRECT: 'direct',
  AGENCY: 'agency',
} as const;

export type JsonValue = unknown;

export type LeaveOfAbsence =
  | 'initiate_military'
  | 'initiate_regular'
  | 'none'
  | 'reinstate_military'
  | 'reinstate_regular';

export const LeaveOfAbsence = {
  INITIATE_MILITARY: 'initiate_military',
  INITIATE_REGULAR: 'initiate_regular',
  NONE: 'none',
  REINSTATE_MILITARY: 'reinstate_military',
  REINSTATE_REGULAR: 'reinstate_regular',
} as const;

export type LimitOfInsurance =
  | '25k'
  | '50k'
  | '75k'
  | '100k'
  | '101k'
  | '250k'
  | '500k'
  | '750k'
  | '1m';

export const LimitOfInsurance = {
  _25K: '25k',
  _50K: '50k',
  _75K: '75k',
  _100K: '100k',
  _101K: '101k',
  _250K: '250k',
  _500K: '500k',
  _750K: '750k',
  _1M: '1m',
} as const;

export type LimitsEnum =
  | 'limit_1m_1m'
  | 'limit_1m_2m'
  | 'limit_1m_3m'
  | 'limit_2m_3m'
  | 'limit_2m_4m'
  | 'limit_2m_6m'
  | 'limit_3m_3m'
  | 'limit_3m_6m'
  | 'limit_4m_4m'
  | 'limit_5m_5m'
  | 'limit_5m_6m'
  | 'limit_5m_8m'
  | 'limit_2m_2m'
  | 'limit_3m_9m'
  | 'limit_500k_1m'
  | 'limit_500k_1500k'
  | 'limit_100k_300k'
  | 'limit_250k_500k'
  | 'limit_250k_750k'
  | 'limit_1300k_3900k'
  | 'limit_1925k_5775k'
  | 'limit_2050k_6150k'
  | 'limit_2100k_6300k'
  | 'limit_2150k_6450k'
  | 'limit_2200k_6600k'
  | 'limit_2250k_6750k'
  | 'limit_2300k_6900k'
  | 'limit_2350k_7050k'
  | 'limit_2400k_7200k'
  | 'limit_2450k_7350k'
  | 'limit_2500k_7500k'
  | 'limit_2550k_7650k'
  | 'limit_2600k_7800k'
  | 'limit_2650k_7950k'
  | 'limit_2700k_8100k'
  | 'limit_2750k_8250k'
  | 'limit_2800k_8400k'
  | 'limit_2850k_8550k'
  | 'limit_2900k_8700k'
  | 'limit_2950k_8850k';

export const LimitsEnum = {
  LIMIT_1M_1M: 'limit_1m_1m',
  LIMIT_1M_2M: 'limit_1m_2m',
  LIMIT_1M_3M: 'limit_1m_3m',
  LIMIT_2M_3M: 'limit_2m_3m',
  LIMIT_2M_4M: 'limit_2m_4m',
  LIMIT_2M_6M: 'limit_2m_6m',
  LIMIT_3M_3M: 'limit_3m_3m',
  LIMIT_3M_6M: 'limit_3m_6m',
  LIMIT_4M_4M: 'limit_4m_4m',
  LIMIT_5M_5M: 'limit_5m_5m',
  LIMIT_5M_6M: 'limit_5m_6m',
  LIMIT_5M_8M: 'limit_5m_8m',
  LIMIT_2M_2M: 'limit_2m_2m',
  LIMIT_3M_9M: 'limit_3m_9m',
  LIMIT_500K_1M: 'limit_500k_1m',
  LIMIT_500K_1500K: 'limit_500k_1500k',
  LIMIT_100K_300K: 'limit_100k_300k',
  LIMIT_250K_500K: 'limit_250k_500k',
  LIMIT_250K_750K: 'limit_250k_750k',
  LIMIT_1300K_3900K: 'limit_1300k_3900k',
  LIMIT_1925K_5775K: 'limit_1925k_5775k',
  LIMIT_2050K_6150K: 'limit_2050k_6150k',
  LIMIT_2100K_6300K: 'limit_2100k_6300k',
  LIMIT_2150K_6450K: 'limit_2150k_6450k',
  LIMIT_2200K_6600K: 'limit_2200k_6600k',
  LIMIT_2250K_6750K: 'limit_2250k_6750k',
  LIMIT_2300K_6900K: 'limit_2300k_6900k',
  LIMIT_2350K_7050K: 'limit_2350k_7050k',
  LIMIT_2400K_7200K: 'limit_2400k_7200k',
  LIMIT_2450K_7350K: 'limit_2450k_7350k',
  LIMIT_2500K_7500K: 'limit_2500k_7500k',
  LIMIT_2550K_7650K: 'limit_2550k_7650k',
  LIMIT_2600K_7800K: 'limit_2600k_7800k',
  LIMIT_2650K_7950K: 'limit_2650k_7950k',
  LIMIT_2700K_8100K: 'limit_2700k_8100k',
  LIMIT_2750K_8250K: 'limit_2750k_8250k',
  LIMIT_2800K_8400K: 'limit_2800k_8400k',
  LIMIT_2850K_8550K: 'limit_2850k_8550k',
  LIMIT_2900K_8700K: 'limit_2900k_8700k',
  LIMIT_2950K_8850K: 'limit_2950k_8850k',
} as const;

export type Location = {
  effectiveDate?: Date | null;
  expirationDate?: Date | null;
  createdOnTransactionNumber?: number | null;
  deletedOnTransactionNumber?: number | null;
  pk?: string;
  information?: Information;
  rating?: Rating;
  ratedPrice?: number;
  premiumDetail?: {
    [key: string]: unknown;
  };
  readonly isDeleted: boolean;
};

export type LocationFormLevels = 'LOCATION';

export type LossAssessment =
  | 'higher'
  | 'no'
  | 'one_k'
  | 'ten_k'
  | 'five_k'
  | 'twenty_five_k'
  | 'fifty_k'
  | 'one_hundred_k';

export const LossAssessment = {
  HIGHER: 'higher',
  NO: 'no',
  ONE_K: 'one_k',
  TEN_K: 'ten_k',
  FIVE_K: 'five_k',
  TWENTY_FIVE_K: 'twenty_five_k',
  FIFTY_K: 'fifty_k',
  ONE_HUNDRED_K: 'one_hundred_k',
} as const;

export type MajorSystemPermitsResponse = {
  plbgPermitLastDate: Date | string | null;
  elecPermitLastDate: Date | string | null;
};

export type MajorityOwned = 'N/A' | 'Yes' | 'No';

export const MajorityOwned = {
  N_A: 'N/A',
  YES: 'Yes',
  NO: 'No',
} as const;

/**
 * we added message field to handle the case when the distance is not available
 */
export type MessageAttributes = {
  message?: string | null;
};

export type MissionOfMercyEvent = {
  pk: string;
  eventBeginningDate?: Date | null;
  eventEndDate?: Date | null;
  eventName?: string | null;
  eventType?: MissionOfMercyEventType | null;
  attachedForms?: Array<AttachedForm>;
  readonly allTemplateFormsComplete: boolean;
};

export type MissionOfMercyEventFormLevels = 'MOM_EVENT';

export type MissionOfMercyEventType = 'all' | 'assistants_only';

export const MissionOfMercyEventType = {
  ALL: 'all',
  ASSISTANTS_ONLY: 'assistants_only',
} as const;

export type NamedStormDeductible = 'none' | 'one_pct' | 'two_pct' | '5%';

export const NamedStormDeductible = {
  NONE: 'none',
  ONE_PCT: 'one_pct',
  TWO_PCT: 'two_pct',
  _5_: '5%',
} as const;

export type NegativeEvents = 'aware' | 'claim' | 'declined' | 'involved';

export const NegativeEvents = {
  AWARE: 'aware',
  CLAIM: 'claim',
  DECLINED: 'declined',
  INVOLVED: 'involved',
} as const;

export type NewDentistType = 'foreign' | 'military' | 'new_grad' | 'public';

export const NewDentistType = {
  FOREIGN: 'foreign',
  MILITARY: 'military',
  NEW_GRAD: 'new_grad',
  PUBLIC: 'public',
} as const;

export type NonWeatherRiskScoreResponse = {
  nonWeatherWaterRiskScore: number | string | null;
};

export type Odt2PdfContext = {
  formId: string;
  s3Key: string;
  s3Bucket?: string | null;
  s3Region?: string | null;
  fileHash: string;
  context: {
    [key: string]: unknown;
  };
};

export type OffPremCoverage = 'standard' | 'higher' | 'none';

export const OffPremCoverage = {
  STANDARD: 'standard',
  HIGHER: 'higher',
  NONE: 'none',
} as const;

export type OrdinanceLimit = 'standard' | 'higher';

export const OrdinanceLimit = {
  STANDARD: 'standard',
  HIGHER: 'higher',
} as const;

export type OwnedEntity = {
  erpEnabled?: boolean;
  erpEffectiveDate?: Date | null;
  erpType?: ErpType | null;
  erpDuration?: ErpDuration | null;
  civilRegulatoryErpEnabled?: boolean | null;
  effectiveDate?: Date | null;
  expirationDate?: Date | null;
  createdOnTransactionNumber?: number | null;
  deletedOnTransactionNumber?: number | null;
  pk?: string;
  details?: Details;
  questions?: Questions;
  attachedForms?: Array<AttachedForm>;
  premiums?: {
    [key: string]: CoverageAmount;
  };
  taxes?: {
    [key: string]: CoverageAmount;
  };
  premiumDetail?: {
    [key: string]: unknown;
  };
  /**
   * Calculate ERP expiration date by adding erp_duration to erp_effective_date
   */
  readonly erpExpirationDate: Date | null;
  readonly isDeleted: boolean;
  readonly allTemplateFormsComplete: boolean;
};

export type OwnerDentistNotInsured = {
  name?: string | null;
  ownershipPercentageOutsideAspen?: number | null;
};

/**
 * "Non Large Group (1 TO 9 Dentist(s))",
 * "Large Group (10 Or More Dentists)",
 * "Dental Association / Society",
 * "Testing Board",
 * "Volunteer Only",
 * "Faculty Only (Non Intramural)",
 * "Moonlighting",
 * "2 Year New Grad Policy"
 */
export type PlSubTypeEnum =
  | 'dental_association'
  | 'faculty_only'
  | 'large_group'
  | 'moonlighting'
  | 'new_grad'
  | 'non_large_dentist'
  | 'testing_board'
  | 'volunteer_only'
  | 'entity_only';

/**
 * "Non Large Group (1 TO 9 Dentist(s))",
 * "Large Group (10 Or More Dentists)",
 * "Dental Association / Society",
 * "Testing Board",
 * "Volunteer Only",
 * "Faculty Only (Non Intramural)",
 * "Moonlighting",
 * "2 Year New Grad Policy"
 */
export const PlSubTypeEnum = {
  DENTAL_ASSOCIATION: 'dental_association',
  FACULTY_ONLY: 'faculty_only',
  LARGE_GROUP: 'large_group',
  MOONLIGHTING: 'moonlighting',
  NEW_GRAD: 'new_grad',
  NON_LARGE_DENTIST: 'non_large_dentist',
  TESTING_BOARD: 'testing_board',
  VOLUNTEER_ONLY: 'volunteer_only',
  ENTITY_ONLY: 'entity_only',
} as const;

export type PlAdditionalInsuredFormLevels = 'PL_ADDITIONAL_INSURED';

export type Policy = {
  pk?: string;
  policyNumber?: string;
  boundPolicyNumber?: string;
  sequenceNumber?: number;
  isIssued?: boolean;
  producer?: UserObject | null;
  underwriter?: UserObject | null;
  assignedTo?: UserObject | null;
  transactions?: Array<Transaction>;
  documentWarehouse?: Array<FileDocument>;
  additionalMessage?: string;
  readonly latestTransaction: Transaction;
  readonly details: PolicyDetails;
  readonly firstNamedInsured: string;
  readonly hasPolicyNumber: boolean;
  readonly displayNumber: string;
  readonly dentists: Array<Dentist>;
  readonly locations: Array<PracticeLocation>;
  readonly professionalLiability: ProfessionalLiability;
  readonly commercialProperty: CommercialProperty;
  readonly ownedEntities: Array<OwnedEntity>;
  readonly generalLiability: GeneralLiability;
  readonly employmentPracticesLiability: EmploymentPracticesLiability;
  readonly erisaAndEmployeeBenefits: ErisaAndEmployeeBenefits;
  readonly annualPremium: number;
  readonly writtenPremium: number;
  readonly formulasForUi: Array<FormulasForUi>;
  readonly coverageParts: {
    [key: string]: CoveragePart;
  };
  readonly writtenTax: number;
  readonly billedTax: number;
  readonly billedPremium: number;
  readonly attachedForms: Array<AttachedForm>;
  readonly hasEpliWageAndHour: YesNoEnum;
  readonly allTemplateFormsComplete: boolean;
  /**
   * Determines if the policy can be quoted based on the current transaction's premium values.
   *
   * A policy can be quoted if any of the following premiums are greater than zero:
   * - Written premium
   * - Billed premium
   * - Annual premium
   *
   * Returns:
   * bool: True if the policy can be quoted, False otherwise.
   */
  readonly canBeQuoted: boolean;
  readonly transactionId: string;
};

export type PolicyDetails = {
  writingCompany?: WritingCompanyEnum | null;
  writingCompanyId?: string | null;
  writingCompanyName?: string | null;
  agency?: string | null;
  producer?: string | null;
  producerName?: string | null;
  policyType?: PolicyTypeEnum | null;
  rolloverExpiringPolicyNumber?: string | null;
  rolloverExpiringPolicyPremium?: number | null;
  priorAspenPolicyNumber?: string | null;
  quoteType?: QuoteTypeEnum | null;
  policyEffectiveDate?: Date | null;
  policyExpirationDate?: Date | null;
  insuranceLinesDesired?: Array<InsuranceLinesEnum>;
  plSubType?: PlSubTypeEnum | null;
  scheduleOnFile?: YesNoEnum | null;
  scheduleFile?: ScheduleFile | null;
  firstNamedInsuredType?: FirstNamedInsuredType | null;
  ownedEntityId?: string | null;
  otherEntityType?: string | null;
  entityName?: string | null;
  firstName?: string | null;
  middleName?: string | null;
  lastName?: string | null;
  professionalDesignation?: Array<
    'BDS' | 'DDS' | 'DMD' | 'MD' | 'MS' | 'MSD' | 'DDM'
  >;
  firstNamedInsuredDentistId?: string | null;
  policyContractState?: UsStateEnum | null;
  mailingAddress?: UsAddress | null;
  billingAddress?: UsAddress | null;
  officePhoneNumber?: string | null;
  cellPhoneNumber?: string | null;
  billingContactFirstName?: string | null;
  billingContactLastName?: string | null;
  billingContactEmail?: string | null;
  billingContactPhone?: string | null;
  emailAddress?: string | null;
  practiceWebsite?: string | null;
  electronicDeliveryAcceptance?: YesNoEnum | null;
  minimumEarnedPremium?: '0%' | '25%' | '50%' | '100%' | null;
  paymentPlan?: PolicyPaymentPlanEnum | null;
  brokerCommissionOverride?: number | null;
  overridePdf?: YesNoEnum | null;
  agencyPk?: number | null;
  producerPk?: number | null;
  initialTransactionSource?: SourceSystemEnum | null;
  lastQuotedAt?: Date | null;
  applyAsicMinimumPremium?: YesNoEnum | null;
  readonly agencyName: string;
  readonly invoicePreference: InvoicePreference;
  /**
   * Get the applicable commission for a policy in a single query
   */
  readonly brokerCommission: number | null;
};

export type PolicyFormLevels =
  | 'POLICY'
  | 'GL'
  | 'ERISA'
  | 'EPL'
  | 'COMMON'
  | 'POLICY_PROPERTY'
  | 'POLICY PROPERTY'
  | 'NONE';

export const PolicyFormLevels = {
  POLICY: 'POLICY',
  GL: 'GL',
  ERISA: 'ERISA',
  EPL: 'EPL',
  COMMON: 'COMMON',
  POLICY_PROPERTY: 'POLICY PROPERTY',
  NONE: 'NONE',
} as const;

export type PolicyPaymentPlanEnum = 'full' | 'quarterly';

export const PolicyPaymentPlanEnum = {
  FULL: 'full',
  QUARTERLY: 'quarterly',
} as const;

export type PolicyTypeEnum =
  | 'cancel_rewrite'
  | 'new_business'
  | 'renewal'
  | 'roll_over';

export const PolicyTypeEnum = {
  CANCEL_REWRITE: 'cancel_rewrite',
  NEW_BUSINESS: 'new_business',
  RENEWAL: 'renewal',
  ROLL_OVER: 'roll_over',
} as const;

export type PracticeIncomeWaitingPeriod =
  | 'zero'
  | 'twenty_four'
  | 'forty_eight'
  | 'seventy_two'
  | 'ninety_six'
  | 'one_twenty'
  | 'one_fourty_four'
  | 'one_sixty_eight'
  | 'one_ninety_six'
  | 'two_sixteen'
  | 'two_forty'
  | 'three_sixty'
  | 'four_eighty'
  | 'six_hundred';

export const PracticeIncomeWaitingPeriod = {
  ZERO: 'zero',
  TWENTY_FOUR: 'twenty_four',
  FORTY_EIGHT: 'forty_eight',
  SEVENTY_TWO: 'seventy_two',
  NINETY_SIX: 'ninety_six',
  ONE_TWENTY: 'one_twenty',
  ONE_FOURTY_FOUR: 'one_fourty_four',
  ONE_SIXTY_EIGHT: 'one_sixty_eight',
  ONE_NINETY_SIX: 'one_ninety_six',
  TWO_SIXTEEN: 'two_sixteen',
  TWO_FORTY: 'two_forty',
  THREE_SIXTY: 'three_sixty',
  FOUR_EIGHTY: 'four_eighty',
  SIX_HUNDRED: 'six_hundred',
} as const;

export type PracticeLocation = {
  effectiveDate?: Date | null;
  expirationDate?: Date | null;
  createdOnTransactionNumber?: number | null;
  deletedOnTransactionNumber?: number | null;
  pk: string;
  address: UsAddress | null;
  sequenceNumber: number;
  latitude?: number | null;
  longitude?: number | null;
  primary?: boolean;
  attachedForms?: Array<AttachedForm>;
  premiums?: {
    [key: string]: CoverageAmount;
  };
  taxes?: {
    [key: string]: CoverageAmount;
  };
  blackBagCoverage?: BlackBagCoverage | null;
  readonly isDeleted: boolean;
  readonly allTemplateFormsComplete: boolean;
  /**
   * Returns list of where this location is referenced in the policy.
   * This property requires the location to be loaded within a Policy context.
   */
  readonly referencedIn: Array<string>;
  /**
   * Determines if this practice location can be deleted.
   * Returns False if the location is being used elsewhere in the policy.
   * This property requires the location to be loaded within a Policy context.
   */
  readonly canDelete: boolean;
};

export type PracticeLocationFormLevels = 'PRACTICE_LOCATION';

export type PracticeOwner = {
  firstNameInsuredIsOwner?: YesNoEnum | null;
  insuredIsFirstTimePracticeOwner?: YesNoEnum | null;
  contractsWithProviders?: YesNoEnum | null;
  employeeDentistsInsured?: YesNoEnum | null;
  employees?: Array<Employee>;
  employsDentists?: YesNoEnum | null;
  feeBasedRevenue?: number | null;
  holdHarmlessClause?: HoldHarmlessClause | null;
  medicaid?: number | null;
  medicare?: number | null;
  operateDentalLab?: YesNoEnum | null;
  outsideReferralsAccepted?: YesNoEnum | null;
  ownerDentists?: Array<OwnerDentistNotInsured>;
  ownerDentistsInsured?: YesNoEnum | null;
  privateInsurance?: number | null;
  proofOfInsurance?: YesNoEnum | null;
  radiologyServices?: YesNoEnum | null;
  servicesRenderedWeekly?: number | null;
  writtenContracts?: YesNoEnum | null;
  authorizedDentist?: string | null;
  onFileProofOfInsurance?: YesNoEnum | null;
  /**
   * Calculates sum of all individuals covered by vicarious liability insurance.
   * Depending on answers to related questions (employs_dentists and employee_dentists_insured),
   * this may return 0.
   */
  readonly totalIndividuals: number;
};

export type PracticeProfile =
  | 'employee'
  | 'faculty'
  | 'contractor'
  | 'owner'
  | 'volunteer';

export const PracticeProfile = {
  EMPLOYEE: 'employee',
  FACULTY: 'faculty',
  CONTRACTOR: 'contractor',
  OWNER: 'owner',
  VOLUNTEER: 'volunteer',
} as const;

export type PracticeSpecialty =
  | 'oral_surgery'
  | 'anesthesiologist'
  | 'endodontics'
  | 'general'
  | 'pediatric'
  | 'periodontics'
  | 'prosthodontics'
  | 'public'
  | 'oral_medicine'
  | 'forensic'
  | 'orthodontics'
  | 'oral_radiology'
  | 'orofacial'
  | 'oral_pathology'
  | 'anesthesiologist_deep_sedation';

export const PracticeSpecialty = {
  ORAL_SURGERY: 'oral_surgery',
  ANESTHESIOLOGIST: 'anesthesiologist',
  ENDODONTICS: 'endodontics',
  GENERAL: 'general',
  PEDIATRIC: 'pediatric',
  PERIODONTICS: 'periodontics',
  PROSTHODONTICS: 'prosthodontics',
  PUBLIC: 'public',
  ORAL_MEDICINE: 'oral_medicine',
  FORENSIC: 'forensic',
  ORTHODONTICS: 'orthodontics',
  ORAL_RADIOLOGY: 'oral_radiology',
  OROFACIAL: 'orofacial',
  ORAL_PATHOLOGY: 'oral_pathology',
  ANESTHESIOLOGIST_DEEP_SEDATION: 'anesthesiologist_deep_sedation',
} as const;

export type PremisesAndEquipmentExplanation =
  | 'credit_monitored_system'
  | 'credit_good_neighbor'
  | 'credit_easily_accessible'
  | 'credit_third_party'
  | 'credit_experienced_management'
  | 'debit_no_monitored_system'
  | 'debit_bad_neighbor'
  | 'debit_vacant'
  | 'debit_inexperienced_management';

export const PremisesAndEquipmentExplanation = {
  CREDIT_MONITORED_SYSTEM: 'credit_monitored_system',
  CREDIT_GOOD_NEIGHBOR: 'credit_good_neighbor',
  CREDIT_EASILY_ACCESSIBLE: 'credit_easily_accessible',
  CREDIT_THIRD_PARTY: 'credit_third_party',
  CREDIT_EXPERIENCED_MANAGEMENT: 'credit_experienced_management',
  DEBIT_NO_MONITORED_SYSTEM: 'debit_no_monitored_system',
  DEBIT_BAD_NEIGHBOR: 'debit_bad_neighbor',
  DEBIT_VACANT: 'debit_vacant',
  DEBIT_INEXPERIENCED_MANAGEMENT: 'debit_inexperienced_management',
} as const;

export type PremiumFormulaGroupingEnum =
  | 'Property'
  | 'Entity'
  | 'EPL/EPLI'
  | 'ERISA'
  | 'Professional Liability'
  | 'Policy'
  | 'Tax'
  | 'General Liability'
  | 'Black Bag';

export const PremiumFormulaGroupingEnum = {
  PROPERTY: 'Property',
  ENTITY: 'Entity',
  EPL_EPLI: 'EPL/EPLI',
  ERISA: 'ERISA',
  PROFESSIONAL_LIABILITY: 'Professional Liability',
  POLICY: 'Policy',
  TAX: 'Tax',
  GENERAL_LIABILITY: 'General Liability',
  BLACK_BAG: 'Black Bag',
} as const;

export type PremiumFormulaLevelEnum =
  | 'Policy'
  | 'Location'
  | 'Entity'
  | 'Dentist'
  | 'Property'
  | 'General Liability'
  | 'Additional Insured'
  | 'Additional Insured PL'
  | 'Additional Insured GL'
  | 'Mission of Mercy Event';

export const PremiumFormulaLevelEnum = {
  POLICY: 'Policy',
  LOCATION: 'Location',
  ENTITY: 'Entity',
  DENTIST: 'Dentist',
  PROPERTY: 'Property',
  GENERAL_LIABILITY: 'General Liability',
  ADDITIONAL_INSURED: 'Additional Insured',
  ADDITIONAL_INSURED_PL: 'Additional Insured PL',
  ADDITIONAL_INSURED_GL: 'Additional Insured GL',
  MISSION_OF_MERCY_EVENT: 'Mission of Mercy Event',
} as const;

export type Procedure = {
  applies?: boolean;
  procedure?: ProcedureType | null;
  informedConsentTypes?: Array<InformedConsentType>;
  trainings?: Array<Training>;
};

export type ProcedureType =
  | 'full_arch'
  | 'impacted_molar'
  | 'endodontics'
  | 'other_implants'
  | 'tmj';

export const ProcedureType = {
  FULL_ARCH: 'full_arch',
  IMPACTED_MOLAR: 'impacted_molar',
  ENDODONTICS: 'endodontics',
  OTHER_IMPLANTS: 'other_implants',
  TMJ: 'tmj',
} as const;

export type ProfessionalLiability = {
  effectiveDate?: Date | null;
  expirationDate?: Date | null;
  createdOnTransactionNumber?: number | null;
  deletedOnTransactionNumber?: number | null;
  insuranceLineKey?: InsuranceLinesEnum | null;
  coverage?: ProfessionalLiabilityCoverageSection;
  practiceOwners?: PracticeOwner;
  coveragePart?: CoveragePart;
  readonly isDeleted: boolean;
};

export type ProfessionalLiabilityCoverageSection = {
  consentType?: ConsentType | null;
  coverageBasis?: CoverageBasis | null;
  entityName?: string | null;
  entityType?: EntityType | null;
  limitsDesired?: LimitsEnum | null;
  missionOfMercyApplies?: YesNoEnum | null;
  civilRegulatoryProceed?: YesNoEnum | null;
  componentSocieties?: Array<ComponentSociety>;
  componentSocietiesNeedScheduling?: YesNoEnum | null;
  defenseDeductibleDesired?: DefenseDeductibleDesired | null;
  entityPriorActs?: Date | null;
  largeGroupExposureModification?: number | null;
  largeGroupExposureModificationExplanation?: string | null;
  largeGroupProcedureMix?: number | null;
  largeGroupProcedureMixExplanation?: string | null;
  largeGroupUnusualRisk?: number | null;
  largeGroupUnusualRiskExplanation?: string | null;
  entitySharedLimitsType?: EntitySharedLimitsType | null;
  numMissionMercyAll?: number | null;
  numMissionMercyHygienists?: number | null;
  missionOfMercyEvents?: Array<MissionOfMercyEvent>;
  numConventions?: number | null;
  numTestingBoardExaminers?: number | null;
  optinIncreaseLimitsMatchCap?: YesNoEnum | null;
  policyFlatAdjustment?: number | null;
  additionalInsured?: Array<AdditionalInsured>;
  carrierCommissionOverride?: number | null;
  brokerCommissionOverride?: number | null;
  blackBagCoverage?: Array<BlackBagCoverageDict>;
};

export type ProfessionalService =
  | 'alternative'
  | 'cbct'
  | 'elective'
  | 'locum_tenens'
  | 'iv_sedation'
  | 'oral_sedation'
  | 'apnea'
  | 'tele'
  | 'temp';

export const ProfessionalService = {
  ALTERNATIVE: 'alternative',
  CBCT: 'cbct',
  ELECTIVE: 'elective',
  LOCUM_TENENS: 'locum_tenens',
  IV_SEDATION: 'iv_sedation',
  ORAL_SEDATION: 'oral_sedation',
  APNEA: 'apnea',
  TELE: 'tele',
  TEMP: 'temp',
} as const;

export type ProtectionClass =
  | 'one'
  | 'two'
  | 'three'
  | 'four'
  | 'five'
  | 'six'
  | 'seven'
  | 'eight'
  | 'nine'
  | 'ten';

export const ProtectionClass = {
  ONE: 'one',
  TWO: 'two',
  THREE: 'three',
  FOUR: 'four',
  FIVE: 'five',
  SIX: 'six',
  SEVEN: 'seven',
  EIGHT: 'eight',
  NINE: 'nine',
  TEN: 'ten',
} as const;

export type Questions = {
  explanation?: string | null;
  majorityOwned?: MajorityOwned | null;
  solelyForDentistry?: YesNoEnum | null;
};

export type QuoteTypeEnum =
  | 'bindable_quote'
  | 'preliminary_indication'
  | 'policy';

export const QuoteTypeEnum = {
  BINDABLE_QUOTE: 'bindable_quote',
  PRELIMINARY_INDICATION: 'preliminary_indication',
  POLICY: 'policy',
} as const;

export type Rating = {
  automaticBuildingValve?: YesNoEnum | null;
  bcegs?: Bcegs | null;
  buildingFeatures?: number | null;
  buildingFeaturesExplanation?: string | null;
  centralFireAlarm?: YesNoEnum | null;
  contentsFlatAdjustment?: number | null;
  buildingFlatAdjustment?: number | null;
  distanceToCoast?: DistanceToCoast | null;
  earthquakeClass?: string | null;
  earthquakeDistanceToFault?: string | null;
  earthquakeRiskScore?: string | null;
  floodRiskRating?: string | null;
  floodRiskScore?: string | null;
  floodZone?: string | null;
  publicProtectionClass?: ProtectionClass | null;
  smokeDetectors?: SmokeDetectors | null;
  userSprinklerStatus?: YesNoEnum | null;
  userConstructionType?: ConstructionType | null;
  userYearBuilt?: number | null;
  userRoofYear?: number | null;
  veriskConstructionType?: ConstructionType | null;
  veriskYearBuilt?: number | null;
  veriskSprinklerStatus?: YesNoEnum | null;
  veriskRoofYear?: number | null;
  wildfireRiskScore?: string | null;
  roofType?: RoofType | null;
  fortifiedCommercialCertification?: CommercialCertification | null;
  hailProbabilityRiskScore?: string | null;
  corelogicNonWeatherRiskScore?: number | null;
  corelogicStraightLineWindScore?: number | null;
  irpmLocation?: number | null;
  irpmLocationExplanation?: string | null;
  corelogicPlumbingAge?: number | null;
  corelogicElectricalAge?: number | null;
  roofAge?: number | null;
  irpmBuildingFeatures?: number | null;
  irpmBuildingFeaturesExplanation?: string | null;
  irpmPremisesAndEquipment?: number | null;
  irpmPremisesAndEquipmentExplanation?: string | null;
  irpmPremisesAndEquipmentExplanationV2?: PremisesAndEquipmentExplanation | null;
  irpmUnderwriterCreditsDebits?: number | null;
  activatedWaterSensor?: YesNoEnum | null;
  crimeRiskScore?: number | null;
  irpmProtection?: number | null;
  irpmProtectionExplanation?: string | null;
};

export type RatingAttempt = {
  requestHash: string;
  ratingRequestId: string;
  readonly request: JsonValue;
  readonly response: JsonValue;
};

/**
 * Select Any Setting Where The Insured Renders Professional Services Now Or Has In The Last
 * 5 Years
 */
export type RendersService =
  | 'correctional'
  | 'hospital'
  | 'mobile'
  | 'nursing_home'
  | 'school'
  | 'spa'
  | 'none';

/**
 * Select Any Setting Where The Insured Renders Professional Services Now Or Has In The Last
 * 5 Years
 */
export const RendersService = {
  CORRECTIONAL: 'correctional',
  HOSPITAL: 'hospital',
  MOBILE: 'mobile',
  NURSING_HOME: 'nursing_home',
  SCHOOL: 'school',
  SPA: 'spa',
  NONE: 'none',
} as const;

export type RoofType = 'metal' | 'other';

export const RoofType = {
  METAL: 'metal',
  OTHER: 'other',
} as const;

export type ScheduleFile = 'large_group' | 'no' | 'entity_only';

export const ScheduleFile = {
  LARGE_GROUP: 'large_group',
  NO: 'no',
  ENTITY_ONLY: 'entity_only',
} as const;

export type SewerBackupCoverage = 'standard' | 'higher' | '50k' | '100k';

export const SewerBackupCoverage = {
  STANDARD: 'standard',
  HIGHER: 'higher',
  _50K: '50k',
  _100K: '100k',
} as const;

export type SmokeDetectors = 'central' | 'local' | 'no';

export const SmokeDetectors = {
  CENTRAL: 'central',
  LOCAL: 'local',
  NO: 'no',
} as const;

export type SourceSystemEnum = 'mountaineer' | 'new_grad_app';

export const SourceSystemEnum = {
  MOUNTAINEER: 'mountaineer',
  NEW_GRAD_APP: 'new_grad_app',
} as const;

export type StandardOrHigher = 'standard' | 'higher';

export const StandardOrHigher = {
  STANDARD: 'standard',
  HIGHER: 'higher',
} as const;

export type StopGapLimit = '300k' | '500k' | '1m';

export const StopGapLimit = {
  _300K: '300k',
  _500K: '500k',
  _1M: '1m',
} as const;

export type Training = 'ce' | 'school' | 'post_grad';

export const Training = {
  CE: 'ce',
  SCHOOL: 'school',
  POST_GRAD: 'post_grad',
} as const;

export type Transaction = {
  transactionNumber: number;
  startSequenceNumber: number;
  endSequenceNumber: number | null;
  status: TransactionStatus;
  transactionType: TransactionType;
  effectiveDate: Date | null;
  createdAt: Date;
  statusMessage: string;
  billedPremium: number;
  writtenPremium: number;
  annualPremium: number;
  formulasForUi: Array<FormulasForUi>;
  latestAttempt: RatingAttempt | null;
  allAttempts: Array<RatingAttempt>;
  previousTransactionNumber?: number | null;
  nextTransactionNumber?: number | null;
  billedTax?: number;
  writtenTax?: number;
  annualTax?: number;
  coverageParts?: {
    [key: string]: CoveragePart;
  };
  transactionMetadata?: TransactionMetadata;
};

export type TransactionMetadata = {
  reasonForChange?: string | null;
  cancellationReason?: CancellationReasonEnum | null;
  cancelType?: CancelTypeEnum | null;
  noticeGenerationDate?: Date | null;
  cancellationProcessDate?: Date | null;
};

export type TransactionStatus =
  | 'in_progress'
  | 'active'
  | 'expired'
  | 'declined'
  | 'cancelled'
  | 'pending_reversion'
  | 'reverted'
  | 'discarded'
  | 'not_taken';

export const TransactionStatus = {
  IN_PROGRESS: 'in_progress',
  ACTIVE: 'active',
  EXPIRED: 'expired',
  DECLINED: 'declined',
  CANCELLED: 'cancelled',
  PENDING_REVERSION: 'pending_reversion',
  REVERTED: 'reverted',
  DISCARDED: 'discarded',
  NOT_TAKEN: 'not_taken',
} as const;

export type TransactionType =
  | 'policy_bound'
  | 'policy_endorsement'
  | 'policy_cancelled'
  | 'policy_reinstated'
  | 'erp';

export const TransactionType = {
  POLICY_BOUND: 'policy_bound',
  POLICY_ENDORSEMENT: 'policy_endorsement',
  POLICY_CANCELLED: 'policy_cancelled',
  POLICY_REINSTATED: 'policy_reinstated',
  ERP: 'erp',
} as const;

export type TypeOfContract =
  | 'Landlord'
  | 'Equipment Lease'
  | 'Loss Payee'
  | 'Other';

export const TypeOfContract = {
  LANDLORD: 'Landlord',
  EQUIPMENT_LEASE: 'Equipment Lease',
  LOSS_PAYEE: 'Loss Payee',
  OTHER: 'Other',
} as const;

export type UnusualRiskExplanation =
  | 'documented_plan'
  | 'comprehensive_infection_control'
  | 'welldesigned_system'
  | 'trained_practice_manager'
  | 'continuing_education'
  | 'no_risk_manager'
  | 'no_protocols'
  | 'no_training';

export const UnusualRiskExplanation = {
  DOCUMENTED_PLAN: 'documented_plan',
  COMPREHENSIVE_INFECTION_CONTROL: 'comprehensive_infection_control',
  WELLDESIGNED_SYSTEM: 'welldesigned_system',
  TRAINED_PRACTICE_MANAGER: 'trained_practice_manager',
  CONTINUING_EDUCATION: 'continuing_education',
  NO_RISK_MANAGER: 'no_risk_manager',
  NO_PROTOCOLS: 'no_protocols',
  NO_TRAINING: 'no_training',
} as const;

export type UsAddress = {
  line1: string;
  line2: string | null;
  city: string;
  county: string | null;
  state: UsStateEnum | null;
  zipCode: string;
};

export type UsEarthquakeHazardResponse = {
  USAEarthquakeRiskScore: string | null;
  DistanceToControllingFault: string | null;
  MagnitudeOfControllingFault: string | null;
};

export type UserObject = {
  userId: number;
  firstName: string | null;
  middleName: string | null;
  lastName: string | null;
  email: string;
};

/**
 * We had to None as default value for some fields because sometimes the API returns None
 */
export type VeriskBusinessOwnerResponse = {
  BusinessName: string | null;
  Address: {
    [key: string]: unknown;
  } | null;
  Risks?: Array<{
    [key: string]: unknown;
  }> | null;
  BuildingFireConstructionCodeList?: Array<{
    [key: string]: unknown;
  }> | null;
  YearBuiltList?: Array<{
    [key: string]: unknown;
  }> | null;
  PpcList?: Array<{
    [key: string]: unknown;
  }> | null;
  SprinkleredList?: Array<{
    [key: string]: unknown;
  }> | null;
  SprinklerCreditValueList?: Array<{
    [key: string]: unknown;
  }> | null;
  BcegsList?: Array<{
    [key: string]: unknown;
  }> | null;
  ReplacementCostReport?: Array<{
    [key: string]: unknown;
  }> | null;
  RoofYear: string | null;
  ReplacementData: {
    [key: string]: unknown;
  } | null;
  OccupancyDetails?: Array<{
    [key: string]: unknown;
  }> | null;
};

export type WeeklyPracticeHours = 'fulltime' | 'parttime' | 'moonlighting';

export const WeeklyPracticeHours = {
  FULLTIME: 'fulltime',
  PARTTIME: 'parttime',
  MOONLIGHTING: 'moonlighting',
} as const;

export type WhoAdministersAnesthesia = 'another' | 'insured';

export const WhoAdministersAnesthesia = {
  ANOTHER: 'another',
  INSURED: 'insured',
} as const;

export type WildfireRiskResponse = {
  riskScore: string | null;
};

export type WindHailCoverage =
  | 'location_fixed_deductible'
  | 'one_pct'
  | '2%'
  | 'five_pct'
  | 'excluded';

export const WindHailCoverage = {
  LOCATION_FIXED_DEDUCTIBLE: 'location_fixed_deductible',
  ONE_PCT: 'one_pct',
  _2_: '2%',
  FIVE_PCT: 'five_pct',
  EXCLUDED: 'excluded',
} as const;

export type WindRiskScoreResponse = {
  straightLineScore: number | string | null;
};

export type WritingCompanyEnum = 'aaic' | 'asic';

export const WritingCompanyEnum = {
  AAIC: 'aaic',
  ASIC: 'asic',
} as const;

export type YearMonth = {
  year: number;
  month: number;
};

export type YearsNoClaims =
  | 'y0'
  | 'y1'
  | 'y2'
  | 'y3'
  | 'y4'
  | 'y5'
  | 'y6'
  | 'y7'
  | 'y8'
  | 'y9'
  | 'gte10';

export const YearsNoClaims = {
  Y0: 'y0',
  Y1: 'y1',
  Y2: 'y2',
  Y3: 'y3',
  Y4: 'y4',
  Y5: 'y5',
  Y6: 'y6',
  Y7: 'y7',
  Y8: 'y8',
  Y9: 'y9',
  GTE10: 'gte10',
} as const;

export type YearsPracticing = 'y0' | 'y1' | 'y2' | 'y3' | 'gte4';

export const YearsPracticing = {
  Y0: 'y0',
  Y1: 'y1',
  Y2: 'y2',
  Y3: 'y3',
  GTE4: 'gte4',
} as const;

export type YesNoEnum = 'No' | 'Yes';

export const YesNoEnum = {
  NO: 'No',
  YES: 'Yes',
} as const;

/**
 * Select Any That Apply To The Insured Dentist In The Last Five Years
 */
export type CounterpartAspenEnumsNegativeEvent =
  | 'allegations'
  | 'canceled'
  | 'convicted'
  | 'medicaid_fraud'
  | 'drugs'
  | 'privileges_revoked'
  | 'investigations'
  | 'pl_refused'
  | 'illness'
  | 'not_including'
  | 'practiced_without_coverage'
  | 'suspended'
  | 'alcoholism';

/**
 * Select Any That Apply To The Insured Dentist In The Last Five Years
 */
export const CounterpartAspenEnumsNegativeEvent = {
  ALLEGATIONS: 'allegations',
  CANCELED: 'canceled',
  CONVICTED: 'convicted',
  MEDICAID_FRAUD: 'medicaid_fraud',
  DRUGS: 'drugs',
  PRIVILEGES_REVOKED: 'privileges_revoked',
  INVESTIGATIONS: 'investigations',
  PL_REFUSED: 'pl_refused',
  ILLNESS: 'illness',
  NOT_INCLUDING: 'not_including',
  PRACTICED_WITHOUT_COVERAGE: 'practiced_without_coverage',
  SUSPENDED: 'suspended',
  ALCOHOLISM: 'alcoholism',
} as const;

export type GlacierPolicyDomainTypeDictsNegativeEvent = {
  negativeEvent: NegativeEvents | null;
  answer: YesNoEnum | null;
};

export type CreatePolicyRequest = {
  accountId?: string;
};

export type AgencySchema2 = {
  phoneNumber: string;
  agencyId?: string;
  name: string;
};

/**
 * This is actually returns mostly of the data from the User model, but the initial
 * intent is to display agent data for endpoint related_users
 */
export type AgentUserSchema = {
  email: string;
  firstName: string;
  lastName: string;
  role: string;
  id?: number | null;
};

export type PolicySummaryData = {
  agent?: AgentUserSchema | null;
  assignedTo?: UserSchema2 | null;
  agency?: AgencySchema2 | null;
  id?: string | null;
  quoteNumber?: string;
  policyNumber?: string;
  rolloverExpiringPolicyNumber?: string | null;
  firstNamedInsured?: string;
  quoteType?: string;
  billedPremium?: number;
  transactionStatus?: string;
  transactionType?: string;
  policyEffectiveDate?: Date | null;
  policyExpirationDate?: Date | null;
  primaryPracticeState?: string | null;
  agencyName?: string | null;
};

export type UserSchema2 = {
  name: string;
  email: string;
  id?: number | null;
  firstName?: string | null;
  lastName?: string | null;
  role?: string | null;
};

export type PolicyPrintQueueList = {
  filesPrinted: boolean;
  id?: string | null;
  transactionId: string;
  accountName?: string;
  policyId: string;
  transactionNumber: number;
  policyStageEffectiveDate?: Date | null;
  downloadDocumentsDate?: Date | null;
  transactionDate?: Date | null;
  transactionType: string;
  transactionStatus: string;
  primaryPracticeState?: string | null;
  billedPremium?: number;
};

export type AccountsToPrintRequest = {
  print_queue_ids: Array<string>;
};

export type FastPolicy = {
  pk?: string;
  policyNumber?: string;
  boundPolicyNumber?: string;
  sequenceNumber?: number;
  isIssued?: boolean;
  producer?: UserObject | null;
  underwriter?: UserObject | null;
  assignedTo?: UserObject | null;
  transactions?: Array<Transaction>;
  documentWarehouse?: Array<FileDocument>;
  additionalMessage?: string;
  readonly latestTransaction: Transaction;
  readonly details: PolicyDetails;
  readonly firstNamedInsured: string;
  readonly hasPolicyNumber: boolean;
  readonly displayNumber: string;
  readonly dentists: Array<Dentist>;
  readonly locations: Array<PracticeLocation>;
  readonly professionalLiability: ProfessionalLiability;
  readonly commercialProperty: CommercialProperty;
  readonly ownedEntities: Array<OwnedEntity>;
  readonly generalLiability: GeneralLiability;
  readonly employmentPracticesLiability: EmploymentPracticesLiability;
  readonly erisaAndEmployeeBenefits: ErisaAndEmployeeBenefits;
  readonly annualPremium: number;
  readonly writtenPremium: number;
  readonly formulasForUi: Array<FormulasForUi>;
  readonly coverageParts: {
    [key: string]: CoveragePart;
  };
  readonly writtenTax: number;
  readonly billedTax: number;
  readonly billedPremium: number;
  readonly attachedForms: Array<AttachedForm>;
  readonly hasEpliWageAndHour: YesNoEnum;
  readonly allTemplateFormsComplete: boolean;
  /**
   * Determines if the policy can be quoted based on the current transaction's premium values.
   *
   * A policy can be quoted if any of the following premiums are greater than zero:
   * - Written premium
   * - Billed premium
   * - Annual premium
   *
   * Returns:
   * bool: True if the policy can be quoted, False otherwise.
   */
  readonly canBeQuoted: boolean;
  readonly transactionId: string;
};

export type TransactionSummaryData = {
  currentTransactionStatus: TransactionStatus;
  currentTransactionType: TransactionType;
  currentTransactionEffectiveDate: Date | null;
  availableActions?: Array<string>;
};

export type ValidatorTypeEnum =
  | 'policy_template_forms'
  | 'policy_details'
  | 'practice_locations'
  | 'professional_liability_coverage'
  | 'dentists'
  | 'commercial_property_locations'
  | 'owned_entities'
  | 'commercial_property_policy_coverage'
  | 'epli'
  | 'erisa'
  | 'practice_owners'
  | 'general_liability';

export const ValidatorTypeEnum = {
  POLICY_TEMPLATE_FORMS: 'policy_template_forms',
  POLICY_DETAILS: 'policy_details',
  PRACTICE_LOCATIONS: 'practice_locations',
  PROFESSIONAL_LIABILITY_COVERAGE: 'professional_liability_coverage',
  DENTISTS: 'dentists',
  COMMERCIAL_PROPERTY_LOCATIONS: 'commercial_property_locations',
  OWNED_ENTITIES: 'owned_entities',
  COMMERCIAL_PROPERTY_POLICY_COVERAGE: 'commercial_property_policy_coverage',
  EPLI: 'epli',
  ERISA: 'erisa',
  PRACTICE_OWNERS: 'practice_owners',
  GENERAL_LIABILITY: 'general_liability',
} as const;

export type Error = {
  fieldName: string;
  htmlComponent: string;
  message: string;
  objectId?: string | null;
};

export type Result = {
  passed: boolean;
  messages?: Array<Error>;
  timestamp?: Date;
};

export type UserId = {
  userId: number;
};

export type DentistSummary = {
  pk: string;
  effectiveDate?: Date | null;
  expirationDate?: Date | null;
  createdOnTransactionNumber?: number | null;
  deletedOnTransactionNumber?: number | null;
  name?: string;
  readonly isDeleted: boolean;
};

export type OwnedEntitySummary = {
  pk: string;
  effectiveDate?: Date | null;
  expirationDate?: Date | null;
  createdOnTransactionNumber?: number | null;
  deletedOnTransactionNumber?: number | null;
  entityName?: string | null;
  readonly isDeleted: boolean;
};

export type PolicyWithSummaries = {
  pk: string;
  details: PolicyDetails;
  professionalLiability?: ProfessionalLiability;
  locations?: Array<PracticeLocationSummary>;
  dentistsSummary?: Array<DentistSummary>;
  ownedEntitiesSummary?: Array<OwnedEntitySummary>;
};

export type PracticeLocationSummary = {
  pk: string;
  effectiveDate?: Date | null;
  expirationDate?: Date | null;
  createdOnTransactionNumber?: number | null;
  deletedOnTransactionNumber?: number | null;
  address?: UsAddress | null;
  primary?: boolean;
  blackBagCoverage?: BlackBagCoverage | null;
  readonly isDeleted: boolean;
};

export type DeclineReason = {
  reason: string;
};

export type AddLocationRequest = {
  locationId?: string;
  address?: UsAddress | null;
  latitude?: LatitudeUnionFloatNoneType;
  longitude?: LongitudeUnionFloatNoneType;
  primary?: boolean;
};

export type LatitudeUnionFloatNoneType = number | null;

export type LongitudeUnionFloatNoneType = number | null;

export type MakePrimarySchema = {
  locationId: string;
};

export type UpdateLocationRequest = {
  address: UsAddress | null;
  latitude?: LatitudeUnionFloatNoneType;
  longitude?: LongitudeUnionFloatNoneType;
  primary?: boolean;
};

/**
 * Select Any That Apply To The Insured Dentist In The Last Five Years
 */
export type NegativeEvent =
  | 'allegations'
  | 'canceled'
  | 'convicted'
  | 'medicaid_fraud'
  | 'drugs'
  | 'privileges_revoked'
  | 'investigations'
  | 'pl_refused'
  | 'illness'
  | 'not_including'
  | 'practiced_without_coverage'
  | 'suspended'
  | 'alcoholism';

/**
 * Select Any That Apply To The Insured Dentist In The Last Five Years
 */
export const NegativeEvent = {
  ALLEGATIONS: 'allegations',
  CANCELED: 'canceled',
  CONVICTED: 'convicted',
  MEDICAID_FRAUD: 'medicaid_fraud',
  DRUGS: 'drugs',
  PRIVILEGES_REVOKED: 'privileges_revoked',
  INVESTIGATIONS: 'investigations',
  PL_REFUSED: 'pl_refused',
  ILLNESS: 'illness',
  NOT_INCLUDING: 'not_including',
  PRACTICED_WITHOUT_COVERAGE: 'practiced_without_coverage',
  SUSPENDED: 'suspended',
  ALCOHOLISM: 'alcoholism',
} as const;

export type CreateDentistRequestSchema = {
  pk?: string;
  firstName?: string;
  middleName?: string | null;
  lastName?: string;
  professionalDesignation?: Array<
    'BDS' | 'DDS' | 'DMD' | 'MD' | 'MS' | 'MSD' | 'DDM'
  >;
};

export type UpdateBasicDentistRequestSchema = {
  firstName?: string;
  middleName?: string | null;
  lastName?: string;
  professionalDesignation?: Array<
    'BDS' | 'DDS' | 'DMD' | 'MD' | 'MS' | 'MSD' | 'DDM'
  >;
};

export type DentistInformationSchema = {
  dentistId: string;
  answers: DentistInformationUpdatedDict;
};

export type DentistInformationUpdatedDict = {
  firstName?: string;
  middleName?: string | null;
  lastName?: string;
  professionalDesignation?: Array<
    'BDS' | 'DDS' | 'DMD' | 'MD' | 'MS' | 'MSD' | 'DDM'
  >;
  numHoursPerWeek?: WeeklyPracticeHours | null;
  practiceSpecialty?: PracticeSpecialty | null;
  primaryPracticeLocation?: string | null;
  yearsInPractice?: YearsPracticing | null;
  yearsWithAspen?: number | null;
  boardCertified?: YesNoEnum | null;
  dateOfBirth?: Date | null;
  datePcfPremiumReceived?: Date | null;
  differentLimitDesired?: YesNoEnum | null;
  emailAddress?: string | null;
  inPcfCertificateNumber?: string | null;
  inPcfFundParticipation?: InpcfParticipation | null;
  inPcfProviderId?: string | null;
  inPcfSurchargeAmount?: number | null;
  laPcfFundParticipation?: YesNoEnum | null;
  leaveOfAbsence?: LeaveOfAbsence | null;
  licenses?: Array<DentistLicense>;
  memberOfSda?: YesNoEnum | null;
  nameOfDentalSchool?: string | null;
  yearMonthGraduation?: YearMonth | null;
  firstTimePractice?: YesNoEnum | null;
  newDentistType?: NewDentistType | null;
  noseCoverage?: YesNoEnum | null;
  noseCoverageLiabilityLimits?: LimitsEnum | null;
  noseCoveragePriorActsDate?: Date | null;
  numYearsDuration?: DurationYears | null;
  npiNumber?: number | null;
  optinForRiskNewsletter?: YesNoEnum | null;
  practiceProfile?: PracticeProfile | null;
  priorActsDate?: Date | null;
  professionalLiabilityLimit?: LimitsEnum | null;
  renumeration?: YesNoEnum | null;
  residencyCompleted?: YesNoEnum | null;
  riskManagementSeminar?: YesNoEnum | null;
  secondaryPracticeLocations?: Array<string>;
  volunteerServices?: string | null;
  workScheduleAvailable?: YesNoEnum | null;
  yearOfAttendance?: number | null;
  yearsWithoutClaim?: YearsNoClaims | null;
  reviewRequired?: YesNoEnum | null;
  agreedRepresentationsAndFraud?: YesNoEnum | null;
  signature?: string | null;
  signatureDate?: Date | null;
};

/**
 * Professional Liability Practice Owner
 */
export type PracticeOwnerSchema = {
  firstNameInsuredIsOwner?: YesNoEnum | null;
  insuredIsFirstTimePracticeOwner?: YesNoEnum | null;
  contractsWithProviders?: YesNoEnum | null;
  employeeDentistsInsured?: YesNoEnum | null;
  employees?: Array<Employee>;
  employsDentists?: YesNoEnum | null;
  feeBasedRevenue?: number | null;
  holdHarmlessClause?: HoldHarmlessClause | null;
  medicaid?: number | null;
  medicare?: number | null;
  operateDentalLab?: YesNoEnum | null;
  outsideReferralsAccepted?: YesNoEnum | null;
  ownerDentists?: Array<OwnerDentistNotInsured>;
  ownerDentistsInsured?: YesNoEnum | null;
  privateInsurance?: number | null;
  proofOfInsurance?: YesNoEnum | null;
  radiologyServices?: YesNoEnum | null;
  servicesRenderedWeekly?: number | null;
  writtenContracts?: YesNoEnum | null;
  authorizedDentist?: string | null;
  onFileProofOfInsurance?: YesNoEnum | null;
};

export type ProfessionalLiabilityCoverageSectionRequestDict = {
  consentType?: ConsentType | null;
  coverageBasis?: CoverageBasis | null;
  entityName?: string | null;
  entityType?: EntityType | null;
  limitsDesired?: LimitsEnum | null;
  missionOfMercyApplies?: YesNoEnum | null;
  civilRegulatoryProceed?: YesNoEnum | null;
  componentSocieties?: Array<ComponentSociety>;
  componentSocietiesNeedScheduling?: YesNoEnum | null;
  defenseDeductibleDesired?: DefenseDeductibleDesired | null;
  entityPriorActs?: Date | null;
  largeGroupExposureModification?: number | null;
  largeGroupExposureModificationExplanation?: string | null;
  largeGroupProcedureMix?: number | null;
  largeGroupProcedureMixExplanation?: string | null;
  largeGroupUnusualRisk?: number | null;
  largeGroupUnusualRiskExplanation?: string | null;
  entitySharedLimitsType?: EntitySharedLimitsType | null;
  numMissionMercyAll?: number | null;
  numMissionMercyHygienists?: number | null;
  missionOfMercyEvents?: Array<MissionOfMercyEvent>;
  numConventions?: number | null;
  numTestingBoardExaminers?: number | null;
  optinIncreaseLimitsMatchCap?: YesNoEnum | null;
  policyFlatAdjustment?: number | null;
  additionalInsured?: Array<AdditionalInsured>;
  blackBagCoverage?: Array<BlackBagCoverageDict>;
};

export type ProfessionalLiabilityCoverageSectionRequestSchema = {
  answers: ProfessionalLiabilityCoverageSectionRequestDict;
};

export type PolicyDetailsSchema = {
  writingCompany?: WritingCompanyEnum | null;
  writingCompanyId?: string | null;
  writingCompanyName?: string | null;
  agency?: string | null;
  producer: string | null;
  producerName?: string | null;
  policyType: PolicyTypeEnum | null;
  rolloverExpiringPolicyNumber?: string | null;
  rolloverExpiringPolicyPremium?: number | null;
  priorAspenPolicyNumber?: string | null;
  quoteType?: QuoteTypeEnum | null;
  policyEffectiveDate?: Date | null;
  policyExpirationDate?: Date | null;
  insuranceLinesDesired?: Array<InsuranceLinesEnum> | null;
  plSubType?: PlSubTypeEnum | null;
  scheduleOnFile?: YesNoEnum | null;
  scheduleFile?: ScheduleFile | null;
  firstNamedInsuredType?: FirstNamedInsuredType | null;
  firstNamedInsuredDentistId?: string | null;
  firstName?: string;
  middleName?: string | null;
  lastName?: string;
  professionalDesignation?: Array<
    'BDS' | 'DDS' | 'DMD' | 'MD' | 'MS' | 'MSD' | 'DDM'
  >;
  ownedEntityId?: string | null;
  otherEntityType?: string | null;
  entityName?: string | null;
  policyContractState?: UsStateEnum | null;
  mailingAddress?: UsAddress | null;
  billingAddress?: UsAddress | null;
  officePhoneNumber?: string | null;
  cellPhoneNumber?: string | null;
  emailAddress?: string | null;
  billingContactFirstName?: string | null;
  billingContactLastName?: string | null;
  billingContactEmail?: string | null;
  billingContactPhone?: string | null;
  practiceWebsite?: string | null;
  electronicDeliveryAcceptance?: YesNoEnum | null;
  minimumEarnedPremium?: '0%' | '25%' | '50%' | '100%' | null;
  paymentPlan?: PolicyPaymentPlanEnum | null;
  brokerCommissionOverride?: number | null;
  overridePdf?: YesNoEnum | null;
  agencyPk?: number | null;
  producerPk?: number | null;
  applyAsicMinimumPremium?: YesNoEnum | null;
  initialTransactionSource?: SourceSystemEnum | null;
};

export type AddPropertyCoverageSchema = {
  locations?: Array<string> | null;
};

export type DistanceToCoastSchema = {
  distance?: number | null;
  unit?: DistanceUnit | null;
};

export type InformationSchema = {
  accountsReceivableCoverage?: AccountsReceivableCoverage | null;
  blanketDentalPracticePersonalPropertyDesired?: YesNoEnum | null;
  accountsReceivableLimit?: number | null;
  appurtenantStructureDesired?: YesNoEnum | null;
  appurtenantStructureLimit?: number | null;
  appurtenantStructureDescription?: string | null;
  roofSurfactingLimitationsDesired?: YesNoEnum | null;
  electronicEquipSurgeProtectors?: YesNoEnum | null;
  equipmentBreakdownDeductible?: EquipmentBreakdownDeductible | null;
  basicEarthquakeLimits?: BasicEarthquakeLimits | null;
  basicFloodLimits?: number | null;
  buildingAllowableRange?: number | null;
  buildingCoverageDesired?: YesNoEnum | null;
  buildingInflationGuard?: BuildingInflationGuard | null;
  buildingLeasedToOthers?: YesNoEnum | null;
  buildingLimit?: number | null;
  buildingReplacementCost?: number | null;
  contentsInflationGuard?: InflationGuard | null;
  contentsLimit?: number | null;
  demolitionIncreasedLimitDesired?: OrdinanceLimit | null;
  demolitionLimit?: number | null;
  earthquakeBuildingClass?: EarthquakeBuildingClassification | null;
  equipmentBreakdownCoverageDesired?: YesNoEnum | null;
  electronicEquipmentLimit?: number | null;
  grossAnnualizedRevenue?: number | null;
  higherLossAssessmentLimit?: number | null;
  incomeDocumentationReceived?: YesNoEnum | null;
  insuredIsFirstTimePracticeOwner?: YesNoEnum | null;
  locationFlatDeductible?: number | null;
  lossAssessment?: LossAssessment | null;
  mineSubsidenceDesired?: YesNoEnum | null;
  mineSubsidenceLimit?: number | null;
  namedStormDeductible?: NamedStormDeductible | null;
  numberOfDaysOpenPerWeek?: number | null;
  ordinanceIncreaseLimitDesired?: OrdinanceLimit | null;
  percentageLeasedToOthers?: number | null;
  practiceIncomeWaitingPeriod?: PracticeIncomeWaitingPeriod | null;
  rentsCoverageDesired?: YesNoEnum | null;
  rentsLimitOfInsurance?: number | null;
  valuedDailyLimitDays?: number | null;
  totalElectronicEquipLimit?: number | null;
  windhailCoverage?: WindHailCoverage | null;
  sewerBackupCoverage?: SewerBackupCoverage | null;
  totalSewerBackupLimit?: number | null;
  pollutionLimitCoverage?: StandardOrHigher | null;
  totalPollutionLimit?: number | null;
  floodCoverage?: FloodCoverage | null;
  totalFloodLimit?: number | null;
  earthquakeCoverage?: EarthquakeCoverage | null;
  totalEarthquakeLimit?: number | null;
  totalSignsLimit?: number | null;
  lossAssessmentCoverage?: LossAssessment | null;
  totalLossAssessmentLimit?: number | null;
  offPremCoverage?: OffPremCoverage | null;
  totalOffPremLimit?: number | null;
  signsCoverage?: StandardOrHigher | null;
  electronicEquipCoverage?: ElectronicEquipCoverage | null;
};

export type RatingSchema = {
  automaticBuildingValve?: YesNoEnum | null;
  bcegs?: Bcegs | null;
  buildingFeatures?: number | null;
  buildingFeaturesExplanation?: string | null;
  centralFireAlarm?: YesNoEnum | null;
  contentsFlatAdjustment?: number | null;
  buildingFlatAdjustment?: number | null;
  distanceToCoast?: DistanceToCoastSchema | null;
  earthquakeClass?: string | null;
  earthquakeDistanceToFault?: string | null;
  earthquakeRiskScore?: string | null;
  floodRiskRating?: string | null;
  floodRiskScore?: string | null;
  floodZone?: string | null;
  publicProtectionClass?: ProtectionClass | null;
  smokeDetectors?: SmokeDetectors | null;
  userSprinklerStatus?: YesNoEnum | null;
  userConstructionType?: ConstructionType | null;
  userYearBuilt?: number | null;
  userRoofYear?: number | null;
  veriskConstructionType?: ConstructionType | null;
  veriskYearBuilt?: number | null;
  veriskSprinklerStatus?: YesNoEnum | null;
  veriskRoofYear?: number | null;
  wildfireRiskScore?: string | null;
  roofType?: RoofType | null;
  fortifiedCommercialCertification?: CommercialCertification | null;
  hailProbabilityRiskScore?: string | null;
  corelogicNonWeatherRiskScore?: number | null;
  corelogicStraightLineWindScore?: number | null;
  irpmLocation?: number | null;
  irpmLocationExplanation?: string | null;
  corelogicPlumbingAge?: number | null;
  corelogicElectricalAge?: number | null;
  roofAge?: number | null;
  irpmBuildingFeatures?: number | null;
  irpmBuildingFeaturesExplanation?: string | null;
  irpmPremisesAndEquipment?: number | null;
  irpmPremisesAndEquipmentExplanation?: string | null;
  irpmPremisesAndEquipmentExplanationV2?: PremisesAndEquipmentExplanation | null;
  irpmUnderwriterCreditsDebits?: number | null;
  activatedWaterSensor?: YesNoEnum | null;
  crimeRiskScore?: number | null;
  irpmProtection?: number | null;
  irpmProtectionExplanation?: string | null;
};

export type UpdateLocationSchema = {
  rating?: RatingSchema | null;
  information?: InformationSchema | null;
};

export type CommercialPropertyCoverageUpdatedDict = {
  bundledPropertyEnhancementEndorsements?: BundledPropertyEnhancementEndorsement | null;
  employeeDishonestyCoverageDesired?: YesNoEnum | null;
  employeeDishonestyCoverage?: EmployeeDishonestyCoverage | null;
  employeeDishonestyCoverageChoice?: StandardOrHigher | null;
  floridaSinkholeCoverageDesired?: YesNoEnum | null;
  fungiCoverageDesired?: YesNoEnum | null;
  propertyClaim?: YesNoEnum | null;
  currentlyResidence?: YesNoEnum | null;
  mostlyVacant?: YesNoEnum | null;
  trailerHome?: YesNoEnum | null;
  increasedWelfareLimitsDesired?: YesNoEnum | null;
  increasedWelfareLimits?: number | null;
};

export type UpdateCoverageSchema = {
  coverage: CommercialPropertyCoverageUpdatedDict;
};

export type FieldValidationError = {
  field: string;
  message: string;
  view: FormView;
  tab?: FormViewTab | null;
  object_id?: string | null;
  object_name?: string | null;
};

export type FieldValidationErrors = {
  errors: Array<FieldValidationError>;
  status?: 422;
};

/**
 * Enum for each form view which is used in the BackEnd Validator.
 * The values of the enum are used as the URL path to the form view in the FrontEnd.
 */
export type FormView =
  | 'policy-details'
  | 'practice-locations'
  | 'prof-liability-coverage'
  | 'prof-liability-dentist'
  | 'prof-liability-practice-owners'
  | 'owned-entities'
  | 'epli'
  | 'general-liability'
  | 'erisa-fiduciary-and-employee-benefits'
  | 'commercial-property-locations'
  | 'commercial-property-coverages';

/**
 * Enum for each form view which is used in the BackEnd Validator.
 * The values of the enum are used as the URL path to the form view in the FrontEnd.
 */
export const FormView = {
  POLICY_DETAILS: 'policy-details',
  PRACTICE_LOCATIONS: 'practice-locations',
  PROF_LIABILITY_COVERAGE: 'prof-liability-coverage',
  PROF_LIABILITY_DENTIST: 'prof-liability-dentist',
  PROF_LIABILITY_PRACTICE_OWNERS: 'prof-liability-practice-owners',
  OWNED_ENTITIES: 'owned-entities',
  EPLI: 'epli',
  GENERAL_LIABILITY: 'general-liability',
  ERISA_FIDUCIARY_AND_EMPLOYEE_BENEFITS:
    'erisa-fiduciary-and-employee-benefits',
  COMMERCIAL_PROPERTY_LOCATIONS: 'commercial-property-locations',
  COMMERCIAL_PROPERTY_COVERAGES: 'commercial-property-coverages',
} as const;

/**
 * Enum for the tabs which is used in the BackEnd Validator.
 * Some form views have multiple tabs, and this enum is used to identify them.
 */
export type FormViewTab =
  | 'insuredDentistInformation'
  | 'proceduresAndAnesthesia'
  | 'underwritingQuestions'
  | 'additionalPricingDetails'
  | 'details'
  | 'locationDetails'
  | 'locationRating';

/**
 * Enum for the tabs which is used in the BackEnd Validator.
 * Some form views have multiple tabs, and this enum is used to identify them.
 */
export const FormViewTab = {
  INSURED_DENTIST_INFORMATION: 'insuredDentistInformation',
  PROCEDURES_AND_ANESTHESIA: 'proceduresAndAnesthesia',
  UNDERWRITING_QUESTIONS: 'underwritingQuestions',
  ADDITIONAL_PRICING_DETAILS: 'additionalPricingDetails',
  DETAILS: 'details',
  LOCATION_DETAILS: 'locationDetails',
  LOCATION_RATING: 'locationRating',
} as const;

export type MissingRequiredFieldErrorTypedDict = {
  path: Array<string>;
  attribute: string;
  code: 'REQUIRED';
  message: string;
};

export type MultipleMissingRequiredFieldErrorTypedDict = {
  errors: Array<MissingRequiredFieldErrorTypedDict>;
  status: 400;
};

export type OwnedEntityCreationSchema = {
  id: string;
};

export type OwnedEntityDetailsUpdatedDict = {
  entityName?: string | null;
  associatedDba?: string | null;
  entityCoverage?: EntityCoverage | null;
  entityFein?: string | null;
  stateOfDomicile?: UsStateEnum | null;
  dentistsSchedule?: Array<string>;
  firstNamedInsuredIndicator?: YesNoEnum | null;
  businessPurpose?: string | null;
  priorActsDate?: Date | null;
  inPcfFundParticipation?: InpcfParticipation | null;
  inPcfProviderId?: string | null;
  inPcfCertificateNumber?: string | null;
  datePcfPremiumReceived?: Date | null;
  inPcfSurchargeAmount?: number | null;
};

export type OwnedEntityQuestionsUpdatedDict = {
  explanation?: string | null;
  majorityOwned?: MajorityOwned | null;
  solelyForDentistry?: YesNoEnum | null;
};

export type OwnedEntityUpdateSchema = {
  details?: OwnedEntityDetailsUpdatedDict | null;
  questions?: OwnedEntityQuestionsUpdatedDict | null;
};

export type GeneralLiabilityAdditionalInsuredRequest = {
  pk: string;
  fallbackPk?: string | null;
  typeOfContract?: TypeOfContract | null;
  entityName?: string | null;
  insuredLocation?: string | null;
  description?: string | null;
  effectiveDate?: null;
  expirationDate?: null;
  entityAddress?: UsAddress | null;
  newEntityAddress?: string | null;
};

export type GeneralLiabilityRequestDict = {
  limitOfInsurance?: LimitsEnum | null;
  separateAggregate?: YesNoEnum | null;
  hiredAutoDamage?: YesNoEnum | null;
  fireWaterLegalLimit?: FireWaterLimit | null;
  losses?: YesNoEnum | null;
  locationIdsGlNotCharged?: Array<string>;
  stopGapCoverageDesired?: YesNoEnum | null;
  stopGapLimit?: StopGapLimit | null;
  flatPremiumAdjustment?: number | null;
  additionalInsured?: Array<GeneralLiabilityAdditionalInsuredRequest>;
};

export type GeneralLiabilityRequestSchema = {
  answers: GeneralLiabilityRequestDict;
};

export type EmploymentPracticesLiabilityRequestDict = {
  epliCoverageType?: EpliCoverageType | null;
  dentistsSchedule?: Array<DentistSchedule>;
  entitiesSchedule?: Array<EntitySchedule>;
  epliPriorActsDate?: Date | null;
  numNonDentistEmployees?: number | null;
  numIndependentDentists?: number | null;
  numEmployeeDentists?: number | null;
  numIndependentHygienists?: number | null;
  limitOfInsurance?: LimitOfInsurance | null;
  deductible?: Deductible | null;
  sublimitedCoverageDesired?: YesNoEnum | null;
  negativeEvents?: Array<NegativeEvent> | null;
  negativeEventsExplanation?: string | null;
  natureOfOperations?: number | null;
  natureOfWorkforce?: number | null;
  salaries?: number | null;
  writtenProcedures?: number | null;
  electronicCommunicationPolicies?: number | null;
  experienceRatingValue?: number | null;
};

export type EmploymentPracticesLiabilityRequestSchema = {
  answers: EmploymentPracticesLiabilityRequestDict;
};

export type ErisaAndEmployeBenefitsRequestDict = {
  limitOfInsurance?: ErisaLimitOfInsurance | null;
  priorActsDate?: Date | null;
  totalEmployees?: number | null;
  anyLosses?: YesNoEnum | null;
};

export type ErisaAndEmployeeBenefitsSchema = {
  answers: ErisaAndEmployeBenefitsRequestDict;
};

export type CreateMidtermTransactionRequest = {
  effective_date: Date;
  transaction_type: TransactionType;
  metadata?: TransactionMetadataDict;
};

export type TransactionMetadataDict = {
  reason_for_change?: string | null;
  cancellation_reason?: CancellationReasonEnum | null;
  cancel_type?: CancelTypeEnum | null;
  notice_generation_date?: Date | null;
  cancellation_process_date?: Date | null;
};

export type SetReasonForChangeRequest = {
  reasonForChange: string;
};

export type MidtermPreviewResponse = {
  canFinalizeMidterm: boolean;
  formulasForUi: Array<FormulasForUi>;
  reasonForChange?: string | null;
};

export type AgentAuthorityResponse = {
  issueQuote: boolean;
  issuePolicy: boolean;
  canSubmitMidterms: boolean;
};

export type FinalizeMidtermChange = {
  reasonForChange?: string | null;
};

export type DentistUnderwritingQuestionsSchema = {
  coveredByAnotherPolicy?: YesNoEnum | null;
  currentCarrier?: string | null;
  hasAbsence?: YesNoEnum | null;
  hasMaintainedCoverage?: YesNoEnum | null;
  hasMalpracticeClaim?: YesNoEnum | null;
  hasPendingClaims?: YesNoEnum | null;
  hasReportedSituation?: YesNoEnum | null;
  negativeEventExplanation?: string | null;
  negativeEvents?: {
    [key: string]: YesNoEnum | null;
  };
  whereServicesRendered?: Array<RendersService>;
  yearsContinuousCoverage?: number | null;
  treatmentOfSleepApnea?: YesNoEnum | null;
};

export type SpecialForms =
  | 'quote_proposal'
  | 'policy_specimen'
  | 'premium_statement'
  | 'policy_bundle';

export const SpecialForms = {
  QUOTE_PROPOSAL: 'quote_proposal',
  POLICY_SPECIMEN: 'policy_specimen',
  PREMIUM_STATEMENT: 'premium_statement',
  POLICY_BUNDLE: 'policy_bundle',
} as const;

export type ConditionalRenewalNoticeRequestSchema = {
  conditions: string;
  display_premium: boolean;
};

export type RatingWorksheetEnum =
  | 'PROPERTY_PREMIUM'
  | 'PL_PREMIUM'
  | 'OTHER_LIABILITY_PREMIUM';

export const RatingWorksheetEnum = {
  PROPERTY_PREMIUM: 'PROPERTY_PREMIUM',
  PL_PREMIUM: 'PL_PREMIUM',
  OTHER_LIABILITY_PREMIUM: 'OTHER_LIABILITY_PREMIUM',
} as const;

export type DownloadLookerDashboard = {
  with_reserves?: boolean;
  with_claimant_name?: boolean;
  selected_dentists?: Array<string>;
};

export type FileDocumentSchema = {
  transactionNumber: number;
  status: TransactionStatus;
  effectiveDate: Date | null;
  documentWarehouse: Array<FileDocument>;
};

export type UpdateDocumentRequest = {
  filename: string;
  description: string;
  category: AttachedDocumentType;
  subcategory: string;
};

export type DocumentStatusResponse = {
  status: number;
  message?: string | null;
};

export type UnderwriterNoteSchema = {
  createdByEmail: string;
  id?: string | null;
  note?: string;
  createdAt: Date;
};

export type UnderwriterNoteRequest = {
  note: string;
};

export type PolicyPendingCancellationSchema = {
  notice_generation_date: Date;
  cancellation_process_date: Date;
  cancellation_reason: CancellationReasonEnum;
  cancel_type: CancelTypeEnum;
  effective_date: Date;
};

export type ObjectSummaryTypeEnum =
  | 'practice_locations'
  | 'dentists'
  | 'commercial_property_locations'
  | 'owned_entities';

export const ObjectSummaryTypeEnum = {
  PRACTICE_LOCATIONS: 'practice_locations',
  DENTISTS: 'dentists',
  COMMERCIAL_PROPERTY_LOCATIONS: 'commercial_property_locations',
  OWNED_ENTITIES: 'owned_entities',
} as const;

export type CpLocationFrontend = {
  pk: string;
  effectiveDate?: Date | null;
  expirationDate?: Date | null;
  deletedOnTransactionNumber?: number | null;
  address?: UsAddress | null;
  primary: boolean;
  isDeleted: boolean;
};

export type DentistFrontend = {
  pk: string;
  effectiveDate?: Date | null;
  expirationDate?: Date | null;
  deletedOnTransactionNumber?: number | null;
  name: string;
  isDeleted: boolean;
};

export type OwnedEntityFrontend = {
  pk: string;
  effectiveDate?: Date | null;
  expirationDate?: Date | null;
  deletedOnTransactionNumber?: number | null;
  entityName?: string | null;
  isDeleted: boolean;
};

export type PracticeLocationFrontend = {
  pk: string;
  effectiveDate?: Date | null;
  expirationDate?: Date | null;
  deletedOnTransactionNumber?: number | null;
  address?: UsAddress | null;
  primary: boolean;
  isDeleted: boolean;
};

export type ErrorDetailDict = {
  detail: string;
};

export type TransactionSnapshotSchema = {
  transactionId: string;
  transactionNumber: number;
  sequenceNumber: number;
  stage: string;
  status: TransactionStatus;
  transactionType: TransactionType;
  effectiveDate: Date | null;
  transactionDate: Date;
  eventDate: Date;
  statusMessage: string;
};

export type TransactionDetailSchema = {
  transactionId: string;
  transactionNumber: number;
  sequenceNumber: number;
  stage: string;
  status: TransactionStatus;
  transactionType: TransactionType;
  effectiveDate: Date | null;
  transactionDate: Date;
  statusMessage: string;
  assignedUser?: string | null;
  attachedForms?: Array<{
    [key: string]: unknown;
  }>;
};

export type AttachedFormSchema = {
  id: string;
  version_number: number;
  name: string;
  description?: string;
  attachment_description?: string;
  form_id: string;
  is_template: boolean;
  is_template_complete: boolean;
  attached_by: 'system' | 'user';
  form_level: AllFormLevels;
  can_detach: boolean;
};

export type attached_by = 'system' | 'user';

export const attached_by = {
  SYSTEM: 'system',
  USER: 'user',
} as const;

export type FormsInputSchema = {
  document_id: string;
  version_number: number;
  user_variables?: {
    [key: string]: unknown;
  };
  object_id?: string | null;
  object_type?: 'POLICY' | 'DENTIST' | 'LOCATION' | 'ENTITY';
};

export type object_type = 'POLICY' | 'DENTIST' | 'LOCATION' | 'ENTITY';

export const object_type = {
  POLICY: 'POLICY',
  DENTIST: 'DENTIST',
  LOCATION: 'LOCATION',
  ENTITY: 'ENTITY',
} as const;

export type AvailableFormSchema = {
  id: string;
  version_number: number;
  name: string;
  description?: string;
  attachment_description?: string;
  form_id: string;
  is_template: boolean;
  form_level: AllFormLevels;
  multiple_occurrence: boolean;
};

export type RenderFormsInputSchema = {
  document_id: string;
  version_number: number;
  user_variables?: {
    [key: string]: unknown;
  };
  object_id?: string | null;
  object_type?: 'POLICY' | 'DENTIST' | 'LOCATION' | 'ENTITY';
  sequence_id?: number | null;
};

export type FrontendQuestionSchema = {
  question_key: string;
  question_label: string;
  required: boolean;
  read_only: boolean;
  question_type: QuestionTypeEnum;
  values: Array<{
    [key: string]: unknown;
  }>;
  default_answer: string | null;
  help_text: string | null;
  order?: number | null;
  answer: unknown;
  sub_questions?: Array<FrontendQuestionSchema>;
};

export type QuestionTypeEnum =
  | 'TEXT'
  | 'LONG_TEXT'
  | 'SELECT'
  | 'MULTI_SELECT'
  | 'DATE'
  | 'NUMBER'
  | 'CHECKBOX'
  | 'CURRENCY'
  | 'TIME'
  | 'ARRAY';

export const QuestionTypeEnum = {
  TEXT: 'TEXT',
  LONG_TEXT: 'LONG_TEXT',
  SELECT: 'SELECT',
  MULTI_SELECT: 'MULTI_SELECT',
  DATE: 'DATE',
  NUMBER: 'NUMBER',
  CHECKBOX: 'CHECKBOX',
  CURRENCY: 'CURRENCY',
  TIME: 'TIME',
  ARRAY: 'ARRAY',
} as const;

export type SaveQuestionsBody = {
  user_variables: {
    [key: string]: unknown;
  };
};

export type BindingConditionsSchema = {
  createdByEmail: string;
  id?: number | null;
  condition?: string;
  createdAt: Date;
};

export type BindingConditionRequest = {
  condition: string;
};

export type TermConditionsSchema = {
  createdByEmail: string;
  id?: number | null;
  condition?: string;
  pendingReview?: boolean;
  createdAt: Date;
};

export type TermConditionRequest = {
  condition: string;
  pendingReview: boolean;
};

export type PartialTermConditionRequest = {
  condition?: string | null;
  pendingReview?: boolean | null;
};

export type ErpEligibleDatesResponse = {
  eligibleDates: Array<string>;
};

/**
 * ERP Entity Kind
 */
export type ErpEntityKind =
  | 'dentist'
  | 'owned_entity'
  | 'epli_standard_coverage'
  | 'epli_enhanced_coverage'
  | 'epli_defense_only_coverage'
  | 'erisa_coverage';

/**
 * ERP Entity Kind
 */
export const ErpEntityKind = {
  DENTIST: 'dentist',
  OWNED_ENTITY: 'owned_entity',
  EPLI_STANDARD_COVERAGE: 'epli_standard_coverage',
  EPLI_ENHANCED_COVERAGE: 'epli_enhanced_coverage',
  EPLI_DEFENSE_ONLY_COVERAGE: 'epli_defense_only_coverage',
  ERISA_COVERAGE: 'erisa_coverage',
} as const;

export type ErpRow = {
  erpEnabled?: boolean;
  erpEffectiveDate?: Date | null;
  erpType?: ErpType | null;
  erpDuration?: ErpDuration | null;
  civilRegulatoryErpEnabled?: boolean | null;
  pk: string;
  entityType: ErpEntityKind | string;
  name: string;
  effectiveDate: Date;
  expirationDate?: Date | null;
  /**
   * Calculate ERP expiration date by adding erp_duration to erp_effective_date
   */
  readonly erpExpirationDate: Date | null;
};

export type ErpSection = {
  key: string;
  title: string;
  entityType: ErpEntityKind | string;
  hasCivilRegulatoryErp: boolean;
  erpTypeOptions: Array<SelectOption>;
  erpDurationOptions: Array<SelectOption>;
  rows: Array<ErpRow>;
};

export type SelectOption = {
  value: string;
  label: string;
};

export type ErpStartRequest = {
  effectiveDate: Date;
};

export type ErpSaveRequest = {
  sections: Array<ErpSaveSectionRequest>;
};

export type ErpSaveRowRequest = {
  erpEnabled?: boolean;
  erpEffectiveDate?: Date | null;
  erpType?: ErpType | null;
  erpDuration?: ErpDuration | null;
  civilRegulatoryErpEnabled?: boolean | null;
  pk: string;
  entityType: ErpEntityKind;
};

export type ErpSaveSectionRequest = {
  key: string;
  rows: Array<ErpSaveRowRequest>;
};

export type TokenSchema = {
  token: string;
};

export type Message = {
  message: string;
};

export type BulkPolicyResponse = {
  records: Array<PolicyDataResponse>;
  errors: Array<[string, string]>;
};

export type PolicyDataResponse = {
  mailing_city: string | null;
  mailing_zip: string | null;
  mailing_state: UsStateEnum | null;
  mailing_address: string | null;
  policy_number: string | null;
};

export type OneSchemaColumn = {
  sheet_column_name: string;
  template_column_name: string;
  template_column_key: string;
};

export type OneSchemaPolicyRequest = {
  embed_id: number;
  template_key?:
    | 'policy_renewal_v1'
    | 'dentist_renewal_v1'
    | 'property_renewal_v1';
  workspace_id: number;
  sheet_id: number;
  sheet_metadata: OneSchemaSheetMetadata;
  columns: Array<OneSchemaColumn>;
  count: number;
  records: Array<PolicyData>;
  error_records: Array<unknown>;
};

export type template_key =
  | 'policy_renewal_v1'
  | 'dentist_renewal_v1'
  | 'property_renewal_v1';

export const template_key = {
  POLICY_RENEWAL_V1: 'policy_renewal_v1',
  DENTIST_RENEWAL_V1: 'dentist_renewal_v1',
  PROPERTY_RENEWAL_V1: 'property_renewal_v1',
} as const;

export type OneSchemaSheetMetadata = {
  original_file_name: string;
  original_sheet_name: string;
};

export type PolicyData = {
  agency_name: string;
  policy_number?: string | null;
  agency_id: string;
  policy_expiration_date: Date;
  policy_type:
    | 'Monoline (PL/GL)'
    | 'Professional Liability Only'
    | 'Package (PL/GL/Property)'
    | 'Property with GL';
  policy_state: UsStateEnum;
  carrier: 'Aspen American Insurance Company';
  first_named_insured: string;
  first_named_insured_type:
    | 'Partnership'
    | 'CORPORATION'
    | 'INDIVIDUAL'
    | 'PC/PA'
    | 'LLC'
    | 'MULTI INDIVIDUAL';
  mailing_address?: string | null;
  mailing_city?: string | null;
  mailing_state?: UsStateEnum | null;
  mailing_zip?: string | null;
  gl_limits: LimitsEnum | null;
  erisa: 'Yes' | 'No' | null;
  epl_epli:
    | 'EPL - Defense Coverage Only'
    | 'EPLI - Defense & Indemnity enhanced 2019 form'
    | 'EPLI - All share one limit'
    | 'Not Applicable'
    | 'NA';
  number_employees: number | null;
  separate_aggregate?: 'Y' | 'N' | null;
  hiredauto_occurrence_limit?: string | null;
  hired_auto_damage?: 'Yes' | 'No' | null;
  fungi_occurrence_limit?: string | null;
  fungi_coverage_desired?: 'Yes' | 'No' | null;
  epli_occurrence_limit?: string | null;
  epli_deductible?: string | null;
  epli_onelimit_occurrence_limit?: string | null;
  epli_prior_acts_date: Date | null;
  erisa_occurrence_limit?:
    | '25000'
    | '100000'
    | '101000'
    | '250000'
    | '500000'
    | '750000'
    | '1000000'
    | null;
  faculty_policy_indicator?: 'Yes' | 'No' | null;
  volunteer_policy_indicator?: 'Yes' | 'No' | null;
  pl_sub_type?:
    | 'Non Large Group'
    | 'Large Group'
    | 'Faculty'
    | 'Volunteer'
    | 'Moonlighting'
    | null;
  renewal_indicator?: 'Yes' | 'No' | null;
  pl_coverage_type?: 'Claims Made' | 'Occurrence' | null;
};

export type policy_type =
  | 'Monoline (PL/GL)'
  | 'Professional Liability Only'
  | 'Package (PL/GL/Property)'
  | 'Property with GL';

export const policy_type = {
  MONOLINE__PL_GL_: 'Monoline (PL/GL)',
  PROFESSIONAL_LIABILITY_ONLY: 'Professional Liability Only',
  PACKAGE__PL_GL_PROPERTY_: 'Package (PL/GL/Property)',
  PROPERTY_WITH_GL: 'Property with GL',
} as const;

export type first_named_insured_type =
  | 'Partnership'
  | 'CORPORATION'
  | 'INDIVIDUAL'
  | 'PC/PA'
  | 'LLC'
  | 'MULTI INDIVIDUAL';

export const first_named_insured_type = {
  PARTNERSHIP: 'Partnership',
  CORPORATION: 'CORPORATION',
  INDIVIDUAL: 'INDIVIDUAL',
  PC_PA: 'PC/PA',
  LLC: 'LLC',
  MULTI_INDIVIDUAL: 'MULTI INDIVIDUAL',
} as const;

export type epl_epli =
  | 'EPL - Defense Coverage Only'
  | 'EPLI - Defense & Indemnity enhanced 2019 form'
  | 'EPLI - All share one limit'
  | 'Not Applicable'
  | 'NA';

export const epl_epli = {
  EPL___DEFENSE_COVERAGE_ONLY: 'EPL - Defense Coverage Only',
  EPLI___DEFENSE___INDEMNITY_ENHANCED_2019_FORM:
    'EPLI - Defense & Indemnity enhanced 2019 form',
  EPLI___ALL_SHARE_ONE_LIMIT: 'EPLI - All share one limit',
  NOT_APPLICABLE: 'Not Applicable',
  NA: 'NA',
} as const;

export type BulkDentistResponse = {
  records: Array<DentistResponse>;
  errors: Array<[string, string, string]>;
};

export type DentistResponse = {
  policy_number: string;
  first_name: string;
  middle_name: string;
  last_name: string;
  designation: Array<'BDS' | 'DDS' | 'DMD' | 'MD' | 'MS' | 'MSD' | 'DDM'>;
  email_address: string;
};

export type DentistData = {
  policy_number?: string | null;
  quote_number?: string | null;
  carrier: 'Aspen American Insurance Company';
  agency: string;
  agency_id: string;
  policy_state: UsStateEnum;
  policy_expiration_date: Date;
  optin_increase_limits_match_cap: 'Yes' | 'No';
  policy_type:
    | 'Monoline (PL/GL)'
    | 'Professional Liability Only'
    | 'Package (PL/GL/Property)'
    | 'Property with GL';
  first_name: string;
  middle_name: string;
  last_name: string;
  designation: Array<'BDS' | 'DDS' | 'DMD' | 'MD' | 'MS' | 'MSD' | 'DDM'>;
  first_named_insured_flag: 'Yes' | 'No';
  first_named_insured: string;
  first_named_insured_type:
    | 'Partnership'
    | 'CORPORATION'
    | 'INDIVIDUAL'
    | 'PC/PA'
    | 'LLC'
    | 'MULTI INDIVIDUAL';
  total_of_active_insureds_on_policy: number;
  practice_address: string;
  practice_address_2: string;
  practice_state: UsStateEnum;
  practice_city: string;
  practice_zip: string;
  email_address: string;
  practice_county: string;
  derived_practice_county: string;
  years_practice: number;
  derived_years_in_practice: number;
  pt_ft: 'Full Time' | 'Part Time' | 'Moonlighting';
  limits: LimitsEnum | null;
  prior_acts_date: Date | null;
  epl_prior_acts_date: Date | null;
  epli_prior_acts_date: Date | null;
  practice_speciality:
    | 'Pediatric Dentistry'
    | 'General Dentistry'
    | 'Periodontics'
    | 'Endodontics'
    | 'Full-time Faculty-Non-Intramural'
    | 'Orthodontics'
    | 'Oral Radiology'
    | 'Prosthodontics'
    | 'Oral/Maxillofacial Surgery';
  cosmetic_dermal: 'Y' | 'N';
  deep_sedation:
    | 'No'
    | 'Yes, Admin. in Office by another Dentist/Anesthesiologist/CRNA (Class 1)'
    | 'Yes, Administered in a Hospital (Class 1)'
    | 'Yes, Administered in the Office by the Named Insured (Class 3)';
  sda_member: 'Y' | 'N';
  derived_pl_subtype:
    | 'Non Large Group'
    | 'Large Group'
    | 'Faculty'
    | 'Volunteer'
    | 'Moonlighting';
  risk_management_date: Date | null;
  rm_duration: '3 Years' | '2 Years' | '1 Year' | 'N/A';
  years_claims_free: number | null;
  derived_years_claims_free: number | null;
  total_credits: number;
  rolling_debit: '25' | '20' | '15' | '10' | '5' | '0';
  years_with_cna: number;
  derived_years_cna: number;
  date_of_birth: Date;
  tmj: 'Y' | 'N';
  implant_placement: 'Y' | 'N';
  partially_impacted: 'Y' | 'N';
  fully_impacted: 'Y' | 'N';
  mini_implants: 'Y' | 'N';
  molar_endodontics: 'Y' | 'N';
  derived_claims_closed_in_last_five_years: 'Y' | 'N' | 'N/A';
  derived_num_years_since_last_claim: '2' | '3' | '4' | '5' | 'N/A';
  renewal_indicator?: 'Yes' | 'No' | null;
};

export type optin_increase_limits_match_cap = 'Yes' | 'No';

export const optin_increase_limits_match_cap = {
  YES: 'Yes',
  NO: 'No',
} as const;

export type first_named_insured_flag = 'Yes' | 'No';

export const first_named_insured_flag = {
  YES: 'Yes',
  NO: 'No',
} as const;

export type pt_ft = 'Full Time' | 'Part Time' | 'Moonlighting';

export const pt_ft = {
  FULL_TIME: 'Full Time',
  PART_TIME: 'Part Time',
  MOONLIGHTING: 'Moonlighting',
} as const;

export type practice_speciality =
  | 'Pediatric Dentistry'
  | 'General Dentistry'
  | 'Periodontics'
  | 'Endodontics'
  | 'Full-time Faculty-Non-Intramural'
  | 'Orthodontics'
  | 'Oral Radiology'
  | 'Prosthodontics'
  | 'Oral/Maxillofacial Surgery';

export const practice_speciality = {
  PEDIATRIC_DENTISTRY: 'Pediatric Dentistry',
  GENERAL_DENTISTRY: 'General Dentistry',
  PERIODONTICS: 'Periodontics',
  ENDODONTICS: 'Endodontics',
  FULL_TIME_FACULTY_NON_INTRAMURAL: 'Full-time Faculty-Non-Intramural',
  ORTHODONTICS: 'Orthodontics',
  ORAL_RADIOLOGY: 'Oral Radiology',
  PROSTHODONTICS: 'Prosthodontics',
  ORAL_MAXILLOFACIAL_SURGERY: 'Oral/Maxillofacial Surgery',
} as const;

export type cosmetic_dermal = 'Y' | 'N';

export const cosmetic_dermal = {
  Y: 'Y',
  N: 'N',
} as const;

export type deep_sedation =
  | 'No'
  | 'Yes, Admin. in Office by another Dentist/Anesthesiologist/CRNA (Class 1)'
  | 'Yes, Administered in a Hospital (Class 1)'
  | 'Yes, Administered in the Office by the Named Insured (Class 3)';

export const deep_sedation = {
  NO: 'No',
  YES__ADMIN__IN_OFFICE_BY_ANOTHER_DENTIST_ANESTHESIOLOGIST_CRNA__CLASS_1_:
    'Yes, Admin. in Office by another Dentist/Anesthesiologist/CRNA (Class 1)',
  YES__ADMINISTERED_IN_A_HOSPITAL__CLASS_1_:
    'Yes, Administered in a Hospital (Class 1)',
  YES__ADMINISTERED_IN_THE_OFFICE_BY_THE_NAMED_INSURED__CLASS_3_:
    'Yes, Administered in the Office by the Named Insured (Class 3)',
} as const;

export type sda_member = 'Y' | 'N';

export const sda_member = {
  Y: 'Y',
  N: 'N',
} as const;

export type derived_pl_subtype =
  | 'Non Large Group'
  | 'Large Group'
  | 'Faculty'
  | 'Volunteer'
  | 'Moonlighting';

export const derived_pl_subtype = {
  NON_LARGE_GROUP: 'Non Large Group',
  LARGE_GROUP: 'Large Group',
  FACULTY: 'Faculty',
  VOLUNTEER: 'Volunteer',
  MOONLIGHTING: 'Moonlighting',
} as const;

export type rm_duration = '3 Years' | '2 Years' | '1 Year' | 'N/A';

export const rm_duration = {
  _3_YEARS: '3 Years',
  _2_YEARS: '2 Years',
  _1_YEAR: '1 Year',
  N_A: 'N/A',
} as const;

export type rolling_debit = '25' | '20' | '15' | '10' | '5' | '0';

export const rolling_debit = {
  _25: '25',
  _20: '20',
  _15: '15',
  _10: '10',
  _5: '5',
  _0: '0',
} as const;

export type tmj = 'Y' | 'N';

export const tmj = {
  Y: 'Y',
  N: 'N',
} as const;

export type implant_placement = 'Y' | 'N';

export const implant_placement = {
  Y: 'Y',
  N: 'N',
} as const;

export type partially_impacted = 'Y' | 'N';

export const partially_impacted = {
  Y: 'Y',
  N: 'N',
} as const;

export type fully_impacted = 'Y' | 'N';

export const fully_impacted = {
  Y: 'Y',
  N: 'N',
} as const;

export type mini_implants = 'Y' | 'N';

export const mini_implants = {
  Y: 'Y',
  N: 'N',
} as const;

export type molar_endodontics = 'Y' | 'N';

export const molar_endodontics = {
  Y: 'Y',
  N: 'N',
} as const;

export type derived_claims_closed_in_last_five_years = 'Y' | 'N' | 'N/A';

export const derived_claims_closed_in_last_five_years = {
  Y: 'Y',
  N: 'N',
  N_A: 'N/A',
} as const;

export type derived_num_years_since_last_claim = '2' | '3' | '4' | '5' | 'N/A';

export const derived_num_years_since_last_claim = {
  _2: '2',
  _3: '3',
  _4: '4',
  _5: '5',
  N_A: 'N/A',
} as const;

export type OneSchemaDentistRequest = {
  embed_id: number;
  template_key?:
    | 'policy_renewal_v1'
    | 'dentist_renewal_v1'
    | 'property_renewal_v1';
  workspace_id: number;
  sheet_id: number;
  sheet_metadata: OneSchemaSheetMetadata;
  columns: Array<OneSchemaColumn>;
  count: number;
  records: Array<DentistData>;
  error_records: Array<unknown>;
};

export type BulkPropertyResponse = {
  records: Array<PropertyResponse>;
  errors: Array<[string, string, string]>;
};

export type PropertyResponse = {
  policy_number: string;
  location_address: string;
  location_city: string;
  location_county: string;
  location_state: UsStateEnum;
  location_zip: string;
};

export type OneSchemaPropertyRequest = {
  embed_id: number;
  template_key?:
    | 'policy_renewal_v1'
    | 'dentist_renewal_v1'
    | 'property_renewal_v1';
  workspace_id: number;
  sheet_id: number;
  sheet_metadata: OneSchemaSheetMetadata;
  columns: Array<OneSchemaColumn>;
  count: number;
  records: Array<PropertyData>;
  error_records: Array<unknown>;
};

export type PropertyData = {
  policy_number?: string | null;
  quote_number?: string | null;
  carrier: 'Aspen American Insurance Company';
  agency: string;
  agency_id: string;
  policy_state: UsStateEnum;
  policy_expiration_date: Date;
  first_named_insured: string;
  first_named_insured_type:
    | 'Partnership'
    | 'CORPORATION'
    | 'INDIVIDUAL'
    | 'PC/PA'
    | 'LLC'
    | 'MULTI INDIVIDUAL';
  location_address: string;
  practice_address_2?: string | null;
  location_city: string;
  location_state: UsStateEnum;
  location_zip: string;
  location_county: string;
  derived_county: string;
  blanket_limit: number;
  accounts_receivable_limit: number;
  property_dedbl: '$500' | '$1,000' | '$2,500' | '$5,000' | '$10,000';
  equipment_breakdown: 'Yes' | 'No';
  windstorm_exclusion: 'Y' | 'N';
  building_coverage: 'Y' | 'N';
  building_limit: number;
  valued_daily_limit: number;
  valued_daily_days: number;
  waiting_period:
    | '0 hours (0 day)'
    | '24 hours (1 day)'
    | '48 hours (2 days)'
    | '72 hours (3 days)'
    | '96 hours (4 days)';
  financials_received_yn: 'Y' | 'N';
  flood_limit: number;
  wind_deductible: 'N/A' | '1%' | '2%' | '5%' | '1' | '2' | '5';
  construction_type:
    | 'Joisted Masonry'
    | 'Frame'
    | 'Fire Resistive'
    | 'Masonry Non-Combustible'
    | 'Non-Combustible'
    | 'Modified Fire Resistive';
  sprinkler: 'Yes' | 'No';
  fire_alarm: 'Central' | 'Local' | 'None';
  smoke_alarm: 'Central' | 'Local' | 'None';
  automatic_valve: 'Yes' | 'No';
  irpm: number;
  derived_building_limit: number;
  derived_contents_limit: number;
  building_inflation_guard?:
    | '0.3'
    | '0.4'
    | '0.5'
    | '1.0'
    | '1.5'
    | '2.0'
    | '2.5'
    | '3.0'
    | '3.5'
    | '4.0'
    | '4.5'
    | '5.0'
    | 'N/A'
    | null;
  contents_inflation_guard?:
    | '0.3'
    | '0.4'
    | '0.5'
    | '1.0'
    | '1.5'
    | '2.0'
    | '2.5'
    | '3.0'
    | '3.5'
    | '4.0'
    | '4.5'
    | '5.0'
    | 'N/A'
    | null;
  earthquake_indicator?: 'Y' | 'N' | null;
  earthquake_coverage?: 'STANDARD' | 'HIGHER' | 'NOT_ELIGIBLE' | null;
  total_earthquake_limit?: string | null;
  earthquake_limit?: number | null;
  flood_indicator?: 'Y' | 'N' | null;
  flood_coverage?: 'STANDARD' | 'HIGHER' | 'NOT_ELIGIBLE' | null;
  total_flood_limit?: string | null;
  electronic_equip_surge_protectors?: 'Yes' | 'No' | null;
  total_electronic_equip_limit?: number | null;
  electronic_equip_coverage?: 'HIGHER' | 'STANDARD' | null;
  flood_zone?: string | null;
  flood_risk_score?: string | null;
  earthquake_risk_score?: string | null;
  sewer_limit?: string | null;
  sewer_backup_coverage?: 'HIGHER' | 'STANDARD' | null;
  total_sewer_backup_limit?: string | null;
  rents_limit?: string | null;
  building_leased_to_others?: 'Yes' | 'No' | null;
  rents_coverage_desired?: 'Yes' | 'No' | null;
  rents_limit_of_insurance?: string | null;
  building_leased_to_others_limit?: string | null;
  building_leased_to_others_coverage?: 'HIGHER' | 'STANDARD' | null;
  signs_limit?: string | null;
  signs_coverage?: 'HIGHER' | 'STANDARD' | null;
  total_signs_limit?: string | null;
  propertyop_limit?: string | null;
  off_prem_coverage?: 'HIGHER' | 'STANDARD' | 'NONE' | null;
  total_off_prem_limit?: string | null;
  loss_assessment_coverage?:
    | 'HIGHER'
    | 'No'
    | '1000'
    | '5000'
    | '10000'
    | '25000'
    | '50000'
    | '100000';
  total_loss_assessment_limit?: string | null;
  user_year_built?: number | null;
  renewal_indicator?: 'Yes' | 'No' | null;
};

export type property_dedbl =
  | '$500'
  | '$1,000'
  | '$2,500'
  | '$5,000'
  | '$10,000';

export const property_dedbl = {
  $500: '$500',
  $1_000: '$1,000',
  $2_500: '$2,500',
  $5_000: '$5,000',
  $10_000: '$10,000',
} as const;

export type equipment_breakdown = 'Yes' | 'No';

export const equipment_breakdown = {
  YES: 'Yes',
  NO: 'No',
} as const;

export type windstorm_exclusion = 'Y' | 'N';

export const windstorm_exclusion = {
  Y: 'Y',
  N: 'N',
} as const;

export type building_coverage = 'Y' | 'N';

export const building_coverage = {
  Y: 'Y',
  N: 'N',
} as const;

export type waiting_period =
  | '0 hours (0 day)'
  | '24 hours (1 day)'
  | '48 hours (2 days)'
  | '72 hours (3 days)'
  | '96 hours (4 days)';

export const waiting_period = {
  _0_HOURS__0_DAY_: '0 hours (0 day)',
  _24_HOURS__1_DAY_: '24 hours (1 day)',
  _48_HOURS__2_DAYS_: '48 hours (2 days)',
  _72_HOURS__3_DAYS_: '72 hours (3 days)',
  _96_HOURS__4_DAYS_: '96 hours (4 days)',
} as const;

export type financials_received_yn = 'Y' | 'N';

export const financials_received_yn = {
  Y: 'Y',
  N: 'N',
} as const;

export type wind_deductible = 'N/A' | '1%' | '2%' | '5%' | '1' | '2' | '5';

export const wind_deductible = {
  N_A: 'N/A',
  _1_: '1%',
  _2_: '2%',
  _5_: '5%',
  _1: '1',
  _2: '2',
  _5: '5',
} as const;

export type construction_type =
  | 'Joisted Masonry'
  | 'Frame'
  | 'Fire Resistive'
  | 'Masonry Non-Combustible'
  | 'Non-Combustible'
  | 'Modified Fire Resistive';

export const construction_type = {
  JOISTED_MASONRY: 'Joisted Masonry',
  FRAME: 'Frame',
  FIRE_RESISTIVE: 'Fire Resistive',
  MASONRY_NON_COMBUSTIBLE: 'Masonry Non-Combustible',
  NON_COMBUSTIBLE: 'Non-Combustible',
  MODIFIED_FIRE_RESISTIVE: 'Modified Fire Resistive',
} as const;

export type sprinkler = 'Yes' | 'No';

export const sprinkler = {
  YES: 'Yes',
  NO: 'No',
} as const;

export type fire_alarm = 'Central' | 'Local' | 'None';

export const fire_alarm = {
  CENTRAL: 'Central',
  LOCAL: 'Local',
  NONE: 'None',
} as const;

export type smoke_alarm = 'Central' | 'Local' | 'None';

export const smoke_alarm = {
  CENTRAL: 'Central',
  LOCAL: 'Local',
  NONE: 'None',
} as const;

export type automatic_valve = 'Yes' | 'No';

export const automatic_valve = {
  YES: 'Yes',
  NO: 'No',
} as const;

export type loss_assessment_coverage =
  | 'HIGHER'
  | 'No'
  | '1000'
  | '5000'
  | '10000'
  | '25000'
  | '50000'
  | '100000';

export const loss_assessment_coverage = {
  HIGHER: 'HIGHER',
  NO: 'No',
  _1000: '1000',
  _5000: '5000',
  _10000: '10000',
  _25000: '25000',
  _50000: '50000',
  _100000: '100000',
} as const;

/**
 * Schema for Writing Company
 */
export type WritingCompanySchema = {
  uuid?: string;
  name: string;
  shortName: string;
  minimumEarnedPremium?: string;
};

/**
 * Schema for the validated agency response.
 */
export type ValidatedAgencyResponse = {
  agencyUuid: string;
  agencyName: string;
  agencyOperatingStates: Array<UsStateEnum>;
  firstName: string;
  lastName: string;
  email: string;
  phone: string | null;
};

/**
 * Schema for validating the agency.
 */
export type ValidateAgencyRequest = {
  agencyUuid: string | null;
  practiceState: UsStateEnum | null;
};

export type AnswersResponse = {
  accountId: string;
  quoteNumber: string;
  boundPolicyNumber: string;
  status: TransactionStatus;
  transactionDate: Date;
  effectiveDate: Date | null;
  pages: PagesResponse;
};

/**
 * Schema for the second page of the form.
 */
export type CoverageQuestions = {
  policyEffectiveDate: Date;
  coverageBasis: CoverageBasis;
  priorActsDate: Date | null;
  limitsDesired: LimitsEnum;
};

export type PagesResponse = {
  yourInformation: YourInformation;
  coverageQuestions?: CoverageQuestions | null;
  representationsAndFraud?: RepresentationsAndFraud | null;
  summary?: Summary | null;
  payment?: Payment | null;
};

export type Payment = {
  available: boolean;
  paymentData: PaymentData | null;
};

/**
 * Schema for the pay and issue coverage page.
 */
export type PaymentData = {
  amount: number;
  checkoutUrl: string;
  paidAt: Date | null;
};

export type RepresentationsAndFraud = {
  agreedRepresentationsAndFraud: YesNoEnum;
  signature: string;
  signatureDate: Date;
};

/**
 * Schema for the summary page.
 */
export type Summary = {
  coverageEffectiveDate: Date;
  coverageBasis: CoverageBasis;
  priorActsDate: Date;
  limitsDesired: LimitsEnum;
  premium: number;
  taxes: number;
  total: number;
};

export type YourInformation = {
  agencyUuid: string;
  policyContractState: UsStateEnum;
  firstName: string;
  middleName: string | null;
  lastName: string;
  professionalDesignation: Array<
    'BDS' | 'DDS' | 'DMD' | 'MD' | 'MS' | 'MSD' | 'DDM'
  >;
  dateOfBirth: Date | null;
  emailAddress: string;
  postGraduationEmail: string | null;
  cellPhoneNumber: string;
  mailingAddress: UsAddress;
  memberOfSda: YesNoEnum;
  nameOfDentalSchool: string | null;
  yearMonthGraduation: YearMonth;
  practiceSpecialty: PracticeSpecialty;
  primaryPracticeAddress: UsAddress;
  firstTimePractice: YesNoEnum;
};

export type AnswersRequest = {
  accountId: string | null;
  pages: Pages;
};

export type Pages = {
  yourInformation: YourInformation;
  coverageQuestions?: CoverageQuestions | null;
  representationsAndFraud?: RepresentationsAndFraud | null;
};

export type GlacierUsersApiListUsersResponse = Array<UserSchema>;

export type GlacierUsersApiListUsersError = unknown;

export type GlacierUsersApiCurrentUserResponse = CurrentUserSchema;

export type GlacierUsersApiCurrentUserError = unknown;

export type GlacierUsersApiRelatedUsersResponse = RelatedAgentsSchema;

export type GlacierUsersApiRelatedUsersError = unknown;

export type GlacierUsersApiUnderwritersResponse = Array<UserSchema>;

export type GlacierUsersApiUnderwritersError = unknown;

export type GlacierUsersApiForgotPasswordEndpointData = {
  body: ForgotPasswordSchema;
};

export type GlacierUsersApiForgotPasswordEndpointResponse =
  ResetPasswordResponse;

export type GlacierUsersApiForgotPasswordEndpointError = unknown;

export type GlacierUsersApiResetPasswordEndpointData = {
  body: ResetPasswordSchema;
};

export type GlacierUsersApiResetPasswordEndpointResponse =
  ResetPasswordResponse;

export type GlacierUsersApiResetPasswordEndpointError = unknown;

export type GlacierPolicyApiListPoliciesResponse = Array<Policy>;

export type GlacierPolicyApiListPoliciesError = unknown;

export type GlacierPolicyApiCreatePolicyData = {
  body: CreatePolicyRequest;
};

export type GlacierPolicyApiCreatePolicyResponse = Policy;

export type GlacierPolicyApiCreatePolicyError = unknown;

export type GlacierPolicyApiGetPolicySummaryResponse = Array<PolicySummaryData>;

export type GlacierPolicyApiGetPolicySummaryError = unknown;

export type GlacierPolicyApiGetPrintQueueData = {
  query?: {
    downloaded?: boolean | null;
  };
};

export type GlacierPolicyApiGetPrintQueueResponse = Array<PolicyPrintQueueList>;

export type GlacierPolicyApiGetPrintQueueError = unknown;

export type GlacierPolicyApiDeletePrintQueueData = {
  body: Array<string>;
};

export type GlacierPolicyApiDeletePrintQueueResponse = unknown;

export type GlacierPolicyApiDeletePrintQueueError = unknown;

export type GlacierPolicyApiPrintQueueData = {
  body: AccountsToPrintRequest;
};

export type GlacierPolicyApiPrintQueueResponse = Blob | File;

export type GlacierPolicyApiPrintQueueError = unknown;

export type GlacierPolicyApiGetPolicyData = {
  path: {
    account_id: string;
  };
  query?: {
    version?: number | null;
  };
};

export type GlacierPolicyApiGetPolicyResponse = Policy | FastPolicy;

export type GlacierPolicyApiGetPolicyError = unknown;

export type GlacierPolicyApiGetLatestTransactionSummaryData = {
  path: {
    account_id: string;
  };
  query?: {
    version?: number | null;
  };
};

export type GlacierPolicyApiGetLatestTransactionSummaryResponse =
  TransactionSummaryData;

export type GlacierPolicyApiGetLatestTransactionSummaryError = unknown;

export type GlacierPolicyApiGetLatestTransactionLatestAttemptData = {
  path: {
    account_id: string;
  };
};

export type GlacierPolicyApiGetLatestTransactionLatestAttemptResponse =
  RatingAttempt | null;

export type GlacierPolicyApiGetLatestTransactionLatestAttemptError = unknown;

export type GlacierPolicyApiValidatePolicyFieldsData = {
  path: {
    account_id: string;
  };
  query?: {
    validator_type?: ValidatorTypeEnum | null;
  };
};

export type GlacierPolicyApiValidatePolicyFieldsResponse = Result;

export type GlacierPolicyApiValidatePolicyFieldsError = unknown;

export type GlacierPolicyApiAssignAgentData = {
  body: UserId;
  path: {
    account_id: string;
  };
};

export type GlacierPolicyApiAssignAgentResponse = unknown;

export type GlacierPolicyApiAssignAgentError = unknown;

export type GlacierPolicyApiAssignUnderwriterData = {
  body: UserId;
  path: {
    account_id: string;
  };
};

export type GlacierPolicyApiAssignUnderwriterResponse = unknown;

export type GlacierPolicyApiAssignUnderwriterError = unknown;

export type GlacierPolicyApiAssignData = {
  body: UserId;
  path: {
    account_id: string;
  };
};

export type GlacierPolicyApiAssignResponse = unknown;

export type GlacierPolicyApiAssignError = unknown;

export type GlacierPolicyApiAssignableData = {
  path: {
    account_id: string;
  };
};

export type GlacierPolicyApiAssignableResponse = Array<UserSchema2>;

export type GlacierPolicyApiAssignableError = unknown;

export type GlacierPolicyApiGetPolicyWithSummariesData = {
  path: {
    account_id: string;
  };
  query?: {
    version?: number | null;
  };
};

export type GlacierPolicyApiGetPolicyWithSummariesResponse =
  PolicyWithSummaries;

export type GlacierPolicyApiGetPolicyWithSummariesError = unknown;

export type GlacierPolicyApiGetPolicyPermissionsData = {
  path: {
    account_id: string;
  };
};

export type GlacierPolicyApiGetPolicyPermissionsResponse =
  | 'READ'
  | 'WRITE'
  | 'UNAUTHORIZED';

export type GlacierPolicyApiGetPolicyPermissionsError = unknown;

export type GlacierPolicyApiDeclineTransactionData = {
  body: DeclineReason;
  path: {
    account_id: string;
  };
};

export type GlacierPolicyApiDeclineTransactionResponse = 'ok';

export type GlacierPolicyApiDeclineTransactionError = 'unauthorized';

export type GlacierPolicyApiDiscardTransactionData = {
  path: {
    account_id: string;
  };
};

export type GlacierPolicyApiDiscardTransactionResponse = 'ok';

export type GlacierPolicyApiDiscardTransactionError = 'unauthorized';

export type GlacierPolicyApiReopenTransactionData = {
  path: {
    account_id: string;
  };
};

export type GlacierPolicyApiReopenTransactionResponse = 'ok';

export type GlacierPolicyApiReopenTransactionError = 'unauthorized';

export type GlacierPolicyApiAddLocationData = {
  body: AddLocationRequest;
  path: {
    account_id: string;
  };
};

export type GlacierPolicyApiAddLocationResponse = PracticeLocation;

export type GlacierPolicyApiAddLocationError = unknown;

export type GlacierPolicyApiUpdatePrimaryLocationData = {
  body: MakePrimarySchema;
  path: {
    account_id: string;
  };
};

export type GlacierPolicyApiUpdatePrimaryLocationResponse = PracticeLocation;

export type GlacierPolicyApiUpdatePrimaryLocationError = unknown;

export type GlacierPolicyApiGetLocationData = {
  path: {
    account_id: string;
    location_id: string;
  };
};

export type GlacierPolicyApiGetLocationResponse = PracticeLocation;

export type GlacierPolicyApiGetLocationError = unknown;

export type GlacierPolicyApiUpdateLocationData = {
  body: UpdateLocationRequest;
  path: {
    account_id: string;
    location_id: string;
  };
};

export type GlacierPolicyApiUpdateLocationResponse = PracticeLocation;

export type GlacierPolicyApiUpdateLocationError = unknown;

export type GlacierPolicyApiDeleteLocationData = {
  path: {
    account_id: string;
    location_id: string;
  };
};

export type GlacierPolicyApiDeleteLocationResponse = unknown;

export type GlacierPolicyApiDeleteLocationError = unknown;

export type GlacierPolicyApiGetDentistData = {
  path: {
    account_id: string;
    dentist_id: string;
  };
};

export type GlacierPolicyApiGetDentistResponse = Dentist;

export type GlacierPolicyApiGetDentistError = unknown;

export type GlacierPolicyApiAddDentistData = {
  body: CreateDentistRequestSchema;
  path: {
    account_id: string;
  };
};

export type GlacierPolicyApiAddDentistResponse = Dentist;

export type GlacierPolicyApiAddDentistError = unknown;

export type GlacierPolicyApiDeleteDentistData = {
  path: {
    account_id: string;
    dentist_id: string;
  };
};

export type GlacierPolicyApiDeleteDentistResponse = Policy;

export type GlacierPolicyApiDeleteDentistError = unknown;

export type GlacierPolicyApiUpdateBasicDentistData = {
  body: UpdateBasicDentistRequestSchema;
  path: {
    account_id: string;
    dentist_id: string;
  };
};

export type GlacierPolicyApiUpdateBasicDentistResponse = Dentist;

export type GlacierPolicyApiUpdateBasicDentistError = unknown;

export type GlacierPolicyApiUpdateDentistInformationData = {
  body: DentistInformationSchema;
  path: {
    account_id: string;
    dentist_id: string;
  };
};

export type GlacierPolicyApiUpdateDentistInformationResponse =
  DentistInformation;

export type GlacierPolicyApiUpdateDentistInformationError = unknown;

export type GlacierPolicyApiGetDentistInformationData = {
  path: {
    account_id: string;
    dentist_id: string;
  };
};

export type GlacierPolicyApiGetDentistInformationResponse = DentistInformation;

export type GlacierPolicyApiGetDentistInformationError = unknown;

export type GlacierPolicyApiUpdateDentistPricingData = {
  body: DentistAdditionalPricing;
  path: {
    account_id: string;
    dentist_id: string;
  };
};

export type GlacierPolicyApiUpdateDentistPricingResponse =
  DentistAdditionalPricing;

export type GlacierPolicyApiUpdateDentistPricingError = unknown;

export type GlacierPolicyApiGetDentistPricingData = {
  path: {
    account_id: string;
    dentist_id: string;
  };
};

export type GlacierPolicyApiGetDentistPricingResponse =
  DentistAdditionalPricing;

export type GlacierPolicyApiGetDentistPricingError = unknown;

export type GlacierPolicyApiUpdateDentistProceduresData = {
  body: DentistProcedures;
  path: {
    account_id: string;
    dentist_id: string;
  };
};

export type GlacierPolicyApiUpdateDentistProceduresResponse = DentistProcedures;

export type GlacierPolicyApiUpdateDentistProceduresError = unknown;

export type GlacierPolicyApiGetDentistProceduresData = {
  path: {
    account_id: string;
    dentist_id: string;
  };
};

export type GlacierPolicyApiGetDentistProceduresResponse = DentistProcedures;

export type GlacierPolicyApiGetDentistProceduresError = unknown;

export type GlacierPolicyApiUpdatePlPracticeOwnerData = {
  body: PracticeOwnerSchema;
  path: {
    account_id: string;
  };
};

export type GlacierPolicyApiUpdatePlPracticeOwnerResponse = PracticeOwner;

export type GlacierPolicyApiUpdatePlPracticeOwnerError = unknown;

export type GlacierPolicyApiGetPracticeOwnersData = {
  path: {
    account_id: string;
  };
};

export type GlacierPolicyApiGetPracticeOwnersResponse = PracticeOwner;

export type GlacierPolicyApiGetPracticeOwnersError = unknown;

export type GlacierPolicyApiUpdatePlCoverageData = {
  body: ProfessionalLiabilityCoverageSectionRequestSchema;
  path: {
    account_id: string;
  };
};

export type GlacierPolicyApiUpdatePlCoverageResponse =
  ProfessionalLiabilityCoverageSection;

export type GlacierPolicyApiUpdatePlCoverageError = unknown;

export type GlacierPolicyApiGetPlCoverageData = {
  path: {
    account_id: string;
  };
};

export type GlacierPolicyApiGetPlCoverageResponse =
  ProfessionalLiabilityCoverageSection;

export type GlacierPolicyApiGetPlCoverageError = unknown;

export type GlacierPolicyApiUpdatePolicyDetailsData = {
  body: PolicyDetailsSchema;
  path: {
    account_id: string;
  };
};

export type GlacierPolicyApiUpdatePolicyDetailsResponse = PolicyDetails;

export type GlacierPolicyApiUpdatePolicyDetailsError = unknown;

export type GlacierPolicyApiGetPolicyDetailsData = {
  path: {
    account_id: string;
  };
};

export type GlacierPolicyApiGetPolicyDetailsResponse = PolicyDetails;

export type GlacierPolicyApiGetPolicyDetailsError = unknown;

export type GlacierPolicyApiRefreshCommercialPropertyWithVeriskData = {
  path: {
    account_id: string;
    location_id: string;
  };
};

export type GlacierPolicyApiRefreshCommercialPropertyWithVeriskResponse =
  CommercialProperty;

export type GlacierPolicyApiRefreshCommercialPropertyWithVeriskError = unknown;

export type GlacierPolicyApiRefreshCommercialPropertyWithCorelogicData = {
  path: {
    account_id: string;
    location_id: string;
  };
};

export type GlacierPolicyApiRefreshCommercialPropertyWithCorelogicResponse =
  CommercialProperty;

export type GlacierPolicyApiRefreshCommercialPropertyWithCorelogicError =
  unknown;

export type GlacierPolicyApiAddCommercialPropertyCoverageData = {
  body: AddPropertyCoverageSchema;
  path: {
    account_id: string;
  };
};

export type GlacierPolicyApiAddCommercialPropertyCoverageResponse =
  CommercialProperty;

export type GlacierPolicyApiAddCommercialPropertyCoverageError = unknown;

export type GlacierPolicyApiUpdateCommercialPropertyCoverageData = {
  body: UpdateLocationSchema;
  path: {
    account_id: string;
    location_id: string;
  };
};

export type GlacierPolicyApiUpdateCommercialPropertyCoverageResponse =
  CommercialProperty;

export type GlacierPolicyApiUpdateCommercialPropertyCoverageError = unknown;

export type GlacierPolicyApiDeleteCommercialPropertyCoverageData = {
  path: {
    account_id: string;
    location_id: string;
  };
};

export type GlacierPolicyApiDeleteCommercialPropertyCoverageResponse =
  CommercialProperty;

export type GlacierPolicyApiDeleteCommercialPropertyCoverageError = unknown;

export type GlacierPolicyApiGetCommercialPropertyLocationData = {
  path: {
    account_id: string;
    location_id: string;
  };
};

export type GlacierPolicyApiGetCommercialPropertyLocationResponse = Location;

export type GlacierPolicyApiGetCommercialPropertyLocationError = unknown;

export type GlacierPolicyApiUpdateCpCoverageData = {
  body: UpdateCoverageSchema;
  path: {
    account_id: string;
  };
};

export type GlacierPolicyApiUpdateCpCoverageResponse = Coverage;

export type GlacierPolicyApiUpdateCpCoverageError = unknown;

export type GlacierPolicyApiGetCommercialPropertyCoverageData = {
  path: {
    account_id: string;
  };
  query: {
    location_id: string;
  };
};

export type GlacierPolicyApiGetCommercialPropertyCoverageResponse = Coverage;

export type GlacierPolicyApiGetCommercialPropertyCoverageError = unknown;

export type GlacierPolicyApiRatePolicyData = {
  path: {
    account_id: string;
  };
};

export type GlacierPolicyApiRatePolicyResponse = Policy;

export type GlacierPolicyApiRatePolicyError =
  | MultipleMissingRequiredFieldErrorTypedDict
  | FieldValidationErrors;

export type GlacierPolicyApiGetFormulasData = {
  path: {
    account_id: string;
  };
};

export type GlacierPolicyApiGetFormulasResponse = Array<FormulasForUi>;

export type GlacierPolicyApiGetFormulasError = unknown;

export type GlacierPolicyApiCreateOwnedEntitiesData = {
  body: OwnedEntityCreationSchema;
  path: {
    account_id: string;
  };
};

export type GlacierPolicyApiCreateOwnedEntitiesResponse = OwnedEntity;

export type GlacierPolicyApiCreateOwnedEntitiesError = unknown;

export type GlacierPolicyApiGetOwnedEntityData = {
  path: {
    account_id: string;
    entity_id: string;
  };
};

export type GlacierPolicyApiGetOwnedEntityResponse = OwnedEntity;

export type GlacierPolicyApiGetOwnedEntityError = unknown;

export type GlacierPolicyApiUpdatedOwnedEntityData = {
  body: OwnedEntityUpdateSchema;
  path: {
    account_id: string;
    entity_id: string;
  };
};

export type GlacierPolicyApiUpdatedOwnedEntityResponse = OwnedEntity;

export type GlacierPolicyApiUpdatedOwnedEntityError = unknown;

export type GlacierPolicyApiDeleteOwnedEntityData = {
  path: {
    account_id: string;
    entity_id: string;
  };
};

export type GlacierPolicyApiDeleteOwnedEntityResponse = Policy;

export type GlacierPolicyApiDeleteOwnedEntityError = unknown;

export type GlacierPolicyApiUpdateGeneralLiabilityData = {
  body: GeneralLiabilityRequestSchema;
  path: {
    account_id: string;
  };
};

export type GlacierPolicyApiUpdateGeneralLiabilityResponse = GeneralLiability;

export type GlacierPolicyApiUpdateGeneralLiabilityError = unknown;

export type GlacierPolicyApiUpdateEmploymentPracticesLiabilityData = {
  body: EmploymentPracticesLiabilityRequestSchema;
  path: {
    account_id: string;
  };
};

export type GlacierPolicyApiUpdateEmploymentPracticesLiabilityResponse =
  EmploymentPracticesLiability;

export type GlacierPolicyApiUpdateEmploymentPracticesLiabilityError = unknown;

export type GlacierPolicyApiUpdateErisaAndEmployeeBenefitsData = {
  body: ErisaAndEmployeeBenefitsSchema;
  path: {
    account_id: string;
  };
};

export type GlacierPolicyApiUpdateErisaAndEmployeeBenefitsResponse =
  ErisaAndEmployeeBenefits;

export type GlacierPolicyApiUpdateErisaAndEmployeeBenefitsError = unknown;

export type GlacierPolicyApiIssuePolicyData = {
  path: {
    account_id: string;
  };
};

export type GlacierPolicyApiIssuePolicyResponse = unknown;

export type GlacierPolicyApiIssuePolicyError = unknown;

export type GlacierPolicyApiCreateMidtermTransactionData = {
  body: CreateMidtermTransactionRequest;
  path: {
    account_id: string;
  };
};

export type GlacierPolicyApiCreateMidtermTransactionResponse = Policy;

export type GlacierPolicyApiCreateMidtermTransactionError = unknown;

export type GlacierPolicyApiSetReasonForChangeData = {
  body: SetReasonForChangeRequest;
  path: {
    account_id: string;
  };
};

export type GlacierPolicyApiSetReasonForChangeResponse = {
  [key: string]: string | boolean;
};

export type GlacierPolicyApiSetReasonForChangeError = unknown;

export type GlacierPolicyApiPricePreviewMidtermChangeData = {
  path: {
    account_id: string;
  };
};

export type GlacierPolicyApiPricePreviewMidtermChangeResponse =
  MidtermPreviewResponse;

export type GlacierPolicyApiPricePreviewMidtermChangeError = unknown;

export type GlacierPolicyApiGetAgentAuthorityData = {
  path: {
    account_id: string;
  };
};

export type GlacierPolicyApiGetAgentAuthorityResponse = AgentAuthorityResponse;

export type GlacierPolicyApiGetAgentAuthorityError = unknown;

export type GlacierPolicyApiFinalizeMidtermChangeData = {
  body: FinalizeMidtermChange;
  path: {
    account_id: string;
  };
};

export type GlacierPolicyApiFinalizeMidtermChangeResponse = Policy;

export type GlacierPolicyApiFinalizeMidtermChangeError = unknown;

export type GlacierPolicyApiCancelMidtermChangeData = {
  path: {
    account_id: string;
  };
};

export type GlacierPolicyApiCancelMidtermChangeResponse = Policy;

export type GlacierPolicyApiCancelMidtermChangeError = unknown;

export type GlacierPolicyApiRevertTransactionData = {
  path: {
    account_id: string;
    number: number;
  };
};

export type GlacierPolicyApiRevertTransactionResponse = Policy;

export type GlacierPolicyApiRevertTransactionError = unknown;

export type GlacierPolicyApiUpdateDentistUnderwritingQuestionsData = {
  body: DentistUnderwritingQuestionsSchema;
  path: {
    account_id: string;
    dentist_id: string;
  };
};

export type GlacierPolicyApiUpdateDentistUnderwritingQuestionsResponse =
  DentistUnderwritingQuestions;

export type GlacierPolicyApiUpdateDentistUnderwritingQuestionsError = unknown;

export type GlacierPolicyApiPremiumStatementData = {
  path: {
    account_id: string;
  };
};

export type GlacierPolicyApiPremiumStatementResponse = Blob | File;

export type GlacierPolicyApiPremiumStatementError = unknown;

export type GlacierPolicyApiGetSpecialFormsData = {
  path: {
    account_id: string;
  };
  query: {
    special_form:
      | 'quote_proposal'
      | 'policy_specimen'
      | 'premium_statement'
      | 'policy_bundle';
  };
};

export type GlacierPolicyApiGetSpecialFormsResponse = {
  [key: string]: string;
};

export type GlacierPolicyApiGetSpecialFormsError = unknown;

export type GlacierPolicyApiConditionalRenewalNoticeData = {
  body: ConditionalRenewalNoticeRequestSchema;
  path: {
    account_id: string;
  };
};

export type GlacierPolicyApiConditionalRenewalNoticeResponse = Blob | File;

export type GlacierPolicyApiConditionalRenewalNoticeError = unknown;

export type GlacierPolicyApiDownloadRatingWorksheetsData = {
  path: {
    account_id: string;
    worksheet_enum:
      | 'PROPERTY_PREMIUM'
      | 'PL_PREMIUM'
      | 'OTHER_LIABILITY_PREMIUM';
  };
};

export type GlacierPolicyApiDownloadRatingWorksheetsResponse = Blob | File;

export type GlacierPolicyApiDownloadRatingWorksheetsError = unknown;

export type GlacierPolicyApiPremiumRenewalNoticeData = {
  path: {
    account_id: string;
  };
};

export type GlacierPolicyApiPremiumRenewalNoticeResponse = Blob | File;

export type GlacierPolicyApiPremiumRenewalNoticeError = unknown;

export type GlacierPolicyApiDownloadLookerDashboardPdfData = {
  body: DownloadLookerDashboard;
  path: {
    account_id: string;
  };
};

export type GlacierPolicyApiDownloadLookerDashboardPdfResponse = Blob | File;

export type GlacierPolicyApiDownloadLookerDashboardPdfError = unknown;

export type GlacierPolicyApiDownloadLookerDashboardCsvData = {
  body: DownloadLookerDashboard;
  path: {
    account_id: string;
  };
};

export type GlacierPolicyApiDownloadLookerDashboardCsvResponse = Blob | File;

export type GlacierPolicyApiDownloadLookerDashboardCsvError = unknown;

export type GlacierPolicyApiSpecimenPreviewData = {
  path: {
    account_id: string;
  };
};

export type GlacierPolicyApiSpecimenPreviewResponse = Blob | File;

export type GlacierPolicyApiSpecimenPreviewError = unknown;

export type GlacierPolicyApiListDocumentsData = {
  path: {
    account_id: string;
  };
};

export type GlacierPolicyApiListDocumentsResponse = Array<FileDocumentSchema>;

export type GlacierPolicyApiListDocumentsError = unknown;

export type GlacierPolicyApiUploadDocumentData = {
  body: {
    file: Blob | File;
  };
  path: {
    account_id: string;
  };
};

export type GlacierPolicyApiUploadDocumentResponse = unknown;

export type GlacierPolicyApiUploadDocumentError = unknown;

export type GlacierPolicyApiDetachDocumentData = {
  path: {
    account_id: string;
    document_id: string;
  };
};

export type GlacierPolicyApiDetachDocumentResponse = unknown;

export type GlacierPolicyApiDetachDocumentError = unknown;

export type GlacierPolicyApiUpdateDocumentData = {
  body: UpdateDocumentRequest;
  path: {
    account_id: string;
    document_id: string;
  };
};

export type GlacierPolicyApiUpdateDocumentResponse = unknown;

export type GlacierPolicyApiUpdateDocumentError = unknown;

export type DocumentIsReadyData = {
  path: {
    document_id: string;
  };
};

export type DocumentIsReadyResponse = DocumentStatusResponse;

export type DocumentIsReadyError = DocumentStatusResponse;

export type GlacierPolicyApiDownloadDocumentData = {
  path: {
    document_id: string;
    policy_id: string;
  };
  query?: {
    download?: boolean;
    filename?: string | null;
  };
};

export type GlacierPolicyApiDownloadDocumentResponse = Blob | File;

export type GlacierPolicyApiDownloadDocumentError = unknown;

export type GlacierPolicyApiRegenerateDocumentData = {
  path: {
    document_id: string;
    policy_id: string;
  };
};

export type GlacierPolicyApiRegenerateDocumentResponse = unknown;

export type GlacierPolicyApiRegenerateDocumentError = unknown;

export type GlacierPolicyApiCommitTransactionTestData = {
  path: {
    account_id: string;
  };
};

export type GlacierPolicyApiCommitTransactionTestResponse = unknown;

export type GlacierPolicyApiCommitTransactionTestError = unknown;

export type GlacierPolicyApiListUnderwriterNotesData = {
  path: {
    account_id: string;
  };
};

export type GlacierPolicyApiListUnderwriterNotesResponse =
  Array<UnderwriterNoteSchema>;

export type GlacierPolicyApiListUnderwriterNotesError = unknown;

export type GlacierPolicyApiCreateUnderwriterNotesData = {
  body: UnderwriterNoteRequest;
  path: {
    account_id: string;
  };
};

export type GlacierPolicyApiCreateUnderwriterNotesResponse =
  UnderwriterNoteSchema;

export type GlacierPolicyApiCreateUnderwriterNotesError = unknown;

export type GlacierPolicyApiUpdateUnderwriterNotesData = {
  body: UnderwriterNoteRequest;
  path: {
    account_id: string;
    note_id: string;
  };
};

export type GlacierPolicyApiUpdateUnderwriterNotesResponse =
  UnderwriterNoteSchema;

export type GlacierPolicyApiUpdateUnderwriterNotesError = unknown;

export type GlacierPolicyApiDeleteUnderwriterNotesData = {
  path: {
    account_id: string;
    note_id: string;
  };
};

export type GlacierPolicyApiDeleteUnderwriterNotesResponse = void;

export type GlacierPolicyApiDeleteUnderwriterNotesError = unknown;

export type GlacierPolicyApiReopenUnlockedAccountData = {
  path: {
    account_id: string;
  };
};

export type GlacierPolicyApiReopenUnlockedAccountResponse = void;

export type GlacierPolicyApiReopenUnlockedAccountError = string;

export type GlacierPolicyApiCreatePolicyPendingCancellationTransactionData = {
  body: {
    notice_generation_date: Date;
    cancellation_process_date: Date;
    cancellation_reason:
      | 'due_to_non_payment'
      | 'requested_by_insured'
      | 'failure_to_renew'
      | 'requested_by_company';
    cancel_type: 'flat_cancel' | 'pro_rata' | 'short';
    effective_date: Date;
    file: Blob | File;
  };
  path: {
    account_id: string;
  };
};

export type GlacierPolicyApiCreatePolicyPendingCancellationTransactionResponse =
  Policy;

export type GlacierPolicyApiCreatePolicyPendingCancellationTransactionError =
  unknown;

export type GlacierPolicyApiListObjectSummariesData = {
  path: {
    account_id: string;
    object_type:
      | 'practice_locations'
      | 'dentists'
      | 'commercial_property_locations'
      | 'owned_entities';
  };
};

export type GlacierPolicyApiListObjectSummariesResponse =
  | Array<PracticeLocationFrontend>
  | Array<DentistFrontend>
  | Array<OwnedEntityFrontend>
  | Array<CpLocationFrontend>;

export type GlacierPolicyApiListObjectSummariesError = unknown;

export type GlacierPolicyApiGetObjectDetailsData = {
  path: {
    account_id: string;
    object_id: string;
    object_type:
      | 'practice_locations'
      | 'dentists'
      | 'commercial_property_locations'
      | 'owned_entities';
  };
};

export type GlacierPolicyApiGetObjectDetailsResponse =
  | PracticeLocation
  | Dentist
  | OwnedEntity
  | Location;

export type GlacierPolicyApiGetObjectDetailsError = unknown;

export type GlacierPolicyApiReferPolicyData = {
  path: {
    account_id: string;
  };
};

export type GlacierPolicyApiReferPolicyResponse = void;

export type GlacierPolicyApiReferPolicyError = ErrorDetailDict;

export type GlacierPolicyApiListTransactionsData = {
  path: {
    account_id: string;
  };
};

export type GlacierPolicyApiListTransactionsResponse =
  Array<TransactionSnapshotSchema>;

export type GlacierPolicyApiListTransactionsError = unknown;

export type GlacierPolicyApiGetTransactionDetailData = {
  path: {
    account_id: string;
    transaction_number: number;
  };
};

export type GlacierPolicyApiGetTransactionDetailResponse =
  TransactionDetailSchema;

export type GlacierPolicyApiGetTransactionDetailError = unknown;

export type GlacierPolicyFormsApiPolicyLevelAttachedEndorsementsData = {
  path: {
    account_id: string;
  };
};

export type GlacierPolicyFormsApiPolicyLevelAttachedEndorsementsResponse =
  Array<AttachedFormSchema>;

export type GlacierPolicyFormsApiPolicyLevelAttachedEndorsementsError = unknown;

export type GlacierPolicyFormsApiAttachFormToPolicyData = {
  body: FormsInputSchema;
  path: {
    account_id: string;
  };
};

export type GlacierPolicyFormsApiAttachFormToPolicyResponse = Policy;

export type GlacierPolicyFormsApiAttachFormToPolicyError = unknown;

export type GlacierPolicyFormsApiDetachFormFromPolicyData = {
  body: FormsInputSchema;
  path: {
    account_id: string;
  };
};

export type GlacierPolicyFormsApiDetachFormFromPolicyResponse = unknown;

export type GlacierPolicyFormsApiDetachFormFromPolicyError = unknown;

export type GlacierPolicyFormsApiGetAvailableEndorsementsData = {
  path: {
    account_id: string;
  };
};

export type GlacierPolicyFormsApiGetAvailableEndorsementsResponse =
  Array<AvailableFormSchema>;

export type GlacierPolicyFormsApiGetAvailableEndorsementsError = unknown;

export type GlacierPolicyFormsApiAttachFormToDentistData = {
  body: FormsInputSchema;
  path: {
    account_id: string;
    dentist_id: string;
  };
};

export type GlacierPolicyFormsApiAttachFormToDentistResponse =
  Array<AttachedFormSchema>;

export type GlacierPolicyFormsApiAttachFormToDentistError = unknown;

export type GlacierPolicyFormsApiDetachFormFromDentistData = {
  body: FormsInputSchema;
  path: {
    account_id: string;
    dentist_id: string;
  };
};

export type GlacierPolicyFormsApiDetachFormFromDentistResponse = unknown;

export type GlacierPolicyFormsApiDetachFormFromDentistError = unknown;

export type GlacierPolicyFormsApiGetDentistAttachedFormsData = {
  path: {
    account_id: string;
    dentist_id: string;
  };
};

export type GlacierPolicyFormsApiGetDentistAttachedFormsResponse =
  Array<AttachedFormSchema>;

export type GlacierPolicyFormsApiGetDentistAttachedFormsError = unknown;

export type GlacierPolicyFormsApiGetDentistAvailableEndorsementsData = {
  path: {
    account_id: string;
    dentist_id: string;
  };
};

export type GlacierPolicyFormsApiGetDentistAvailableEndorsementsResponse =
  Array<AvailableFormSchema>;

export type GlacierPolicyFormsApiGetDentistAvailableEndorsementsError = unknown;

export type GlacierPolicyFormsApiAttachFormToLocationData = {
  body: FormsInputSchema;
  path: {
    account_id: string;
    location_id: string;
  };
};

export type GlacierPolicyFormsApiAttachFormToLocationResponse =
  Array<AttachedFormSchema>;

export type GlacierPolicyFormsApiAttachFormToLocationError = unknown;

export type GlacierPolicyFormsApiDetachFormFromLocationData = {
  body: FormsInputSchema;
  path: {
    account_id: string;
    location_id: string;
  };
};

export type GlacierPolicyFormsApiDetachFormFromLocationResponse = unknown;

export type GlacierPolicyFormsApiDetachFormFromLocationError = unknown;

export type GlacierPolicyFormsApiGetLocationAttachedFormsData = {
  path: {
    account_id: string;
    location_id: string;
  };
};

export type GlacierPolicyFormsApiGetLocationAttachedFormsResponse =
  Array<AttachedFormSchema>;

export type GlacierPolicyFormsApiGetLocationAttachedFormsError = unknown;

export type GlacierPolicyFormsApiGetLocationAvailableEndorsementsData = {
  path: {
    account_id: string;
    location_id: string;
  };
};

export type GlacierPolicyFormsApiGetLocationAvailableEndorsementsResponse =
  Array<AvailableFormSchema>;

export type GlacierPolicyFormsApiGetLocationAvailableEndorsementsError =
  unknown;

export type GlacierPolicyFormsApiAttachFormToEntityData = {
  body: FormsInputSchema;
  path: {
    account_id: string;
    entity_id: string;
  };
};

export type GlacierPolicyFormsApiAttachFormToEntityResponse =
  Array<AttachedFormSchema>;

export type GlacierPolicyFormsApiAttachFormToEntityError = unknown;

export type GlacierPolicyFormsApiDetachFormFromEntityData = {
  body: FormsInputSchema;
  path: {
    account_id: string;
    entity_id: string;
  };
};

export type GlacierPolicyFormsApiDetachFormFromEntityResponse = unknown;

export type GlacierPolicyFormsApiDetachFormFromEntityError = unknown;

export type GlacierPolicyFormsApiGetEntityAttachedFormsData = {
  path: {
    account_id: string;
    entity_id: string;
  };
};

export type GlacierPolicyFormsApiGetEntityAttachedFormsResponse =
  Array<AttachedFormSchema>;

export type GlacierPolicyFormsApiGetEntityAttachedFormsError = unknown;

export type GlacierPolicyFormsApiGetEntityAvailableEndorsementsData = {
  path: {
    account_id: string;
    entity_id: string;
  };
};

export type GlacierPolicyFormsApiGetEntityAvailableEndorsementsResponse =
  Array<AvailableFormSchema>;

export type GlacierPolicyFormsApiGetEntityAvailableEndorsementsError = unknown;

export type GlacierPolicyFormsApiRenderFormData = {
  body: RenderFormsInputSchema;
  path: {
    account_id: string;
  };
};

export type GlacierPolicyFormsApiRenderFormResponse = Blob | File;

export type GlacierPolicyFormsApiRenderFormError = unknown;

export type GlacierPolicyFormsApiGetQuestionsByPolicyData = {
  path: {
    account_id: string;
    attached_form_id: string;
  };
};

export type GlacierPolicyFormsApiGetQuestionsByPolicyResponse =
  Array<FrontendQuestionSchema>;

export type GlacierPolicyFormsApiGetQuestionsByPolicyError = unknown;

export type GlacierPolicyFormsApiPostSaveQuestionsAnswersPolicyData = {
  body: SaveQuestionsBody;
  path: {
    account_id: string;
    attached_form_id: string;
  };
};

export type GlacierPolicyFormsApiPostSaveQuestionsAnswersPolicyResponse =
  unknown;

export type GlacierPolicyFormsApiPostSaveQuestionsAnswersPolicyError = unknown;

export type GlacierPolicyFormsApiGetQuestionsByDentistData = {
  path: {
    account_id: string;
    attached_form_id: string;
    dentist_id: string;
  };
};

export type GlacierPolicyFormsApiGetQuestionsByDentistResponse =
  Array<FrontendQuestionSchema>;

export type GlacierPolicyFormsApiGetQuestionsByDentistError = unknown;

export type GlacierPolicyFormsApiPostSaveQuestionsAnswersDentistData = {
  body: SaveQuestionsBody;
  path: {
    account_id: string;
    attached_form_id: string;
    dentist_id: string;
  };
};

export type GlacierPolicyFormsApiPostSaveQuestionsAnswersDentistResponse =
  unknown;

export type GlacierPolicyFormsApiPostSaveQuestionsAnswersDentistError = unknown;

export type GlacierPolicyFormsApiGetQuestionsByLocationData = {
  path: {
    account_id: string;
    attached_form_id: string;
    location_id: string;
  };
};

export type GlacierPolicyFormsApiGetQuestionsByLocationResponse =
  Array<FrontendQuestionSchema>;

export type GlacierPolicyFormsApiGetQuestionsByLocationError = unknown;

export type GlacierPolicyFormsApiPostSaveQuestionsAnswersLocationData = {
  body: SaveQuestionsBody;
  path: {
    account_id: string;
    attached_form_id: string;
    location_id: string;
  };
};

export type GlacierPolicyFormsApiPostSaveQuestionsAnswersLocationResponse =
  unknown;

export type GlacierPolicyFormsApiPostSaveQuestionsAnswersLocationError =
  unknown;

export type GlacierPolicyFormsApiGetQuestionsByEntityData = {
  path: {
    account_id: string;
    attached_form_id: string;
    entity_id: string;
  };
};

export type GlacierPolicyFormsApiGetQuestionsByEntityResponse =
  Array<FrontendQuestionSchema>;

export type GlacierPolicyFormsApiGetQuestionsByEntityError = unknown;

export type GlacierPolicyFormsApiPostSaveQuestionsAnswersEntityData = {
  body: SaveQuestionsBody;
  path: {
    account_id: string;
    attached_form_id: string;
    entity_id: string;
  };
};

export type GlacierPolicyFormsApiPostSaveQuestionsAnswersEntityResponse =
  unknown;

export type GlacierPolicyFormsApiPostSaveQuestionsAnswersEntityError = unknown;

export type GlacierPolicyConditionsApiListBindingConditionsData = {
  path: {
    account_id: string;
  };
};

export type GlacierPolicyConditionsApiListBindingConditionsResponse =
  Array<BindingConditionsSchema>;

export type GlacierPolicyConditionsApiListBindingConditionsError = unknown;

export type GlacierPolicyConditionsApiCreateBindingConditionData = {
  body: BindingConditionRequest;
  path: {
    account_id: string;
  };
};

export type GlacierPolicyConditionsApiCreateBindingConditionResponse =
  BindingConditionsSchema;

export type GlacierPolicyConditionsApiCreateBindingConditionError = unknown;

export type GlacierPolicyConditionsApiUpdateBindingConditionData = {
  body: BindingConditionRequest;
  path: {
    account_id: string;
    condition_id: string;
  };
};

export type GlacierPolicyConditionsApiUpdateBindingConditionResponse =
  BindingConditionsSchema;

export type GlacierPolicyConditionsApiUpdateBindingConditionError = unknown;

export type GlacierPolicyConditionsApiDeleteBindingConditionData = {
  path: {
    account_id: string;
    condition_id: string;
  };
};

export type GlacierPolicyConditionsApiDeleteBindingConditionResponse = void;

export type GlacierPolicyConditionsApiDeleteBindingConditionError = unknown;

export type GlacierPolicyConditionsApiListTermsConditionsData = {
  path: {
    account_id: string;
  };
};

export type GlacierPolicyConditionsApiListTermsConditionsResponse =
  Array<TermConditionsSchema>;

export type GlacierPolicyConditionsApiListTermsConditionsError = unknown;

export type GlacierPolicyConditionsApiCreateTermsConditionData = {
  body: TermConditionRequest;
  path: {
    account_id: string;
  };
};

export type GlacierPolicyConditionsApiCreateTermsConditionResponse =
  TermConditionsSchema;

export type GlacierPolicyConditionsApiCreateTermsConditionError = unknown;

export type GlacierPolicyConditionsApiUpdateTermsConditionData = {
  body: PartialTermConditionRequest;
  path: {
    account_id: string;
    term_id: string;
  };
};

export type GlacierPolicyConditionsApiUpdateTermsConditionResponse =
  TermConditionsSchema;

export type GlacierPolicyConditionsApiUpdateTermsConditionError = unknown;

export type GlacierPolicyConditionsApiDeleteTermsConditionData = {
  path: {
    account_id: string;
    term_id: string;
  };
};

export type GlacierPolicyConditionsApiDeleteTermsConditionResponse = void;

export type GlacierPolicyConditionsApiDeleteTermsConditionError = unknown;

export type GlacierPolicyErpApiGetErpEligibleDatesData = {
  path: {
    policy_id: string;
  };
};

export type GlacierPolicyErpApiGetErpEligibleDatesResponse =
  ErpEligibleDatesResponse;

export type GlacierPolicyErpApiGetErpEligibleDatesError = unknown;

export type GlacierPolicyErpApiGetErpSectionsData = {
  path: {
    policy_id: string;
  };
};

export type GlacierPolicyErpApiGetErpSectionsResponse = Array<ErpSection>;

export type GlacierPolicyErpApiGetErpSectionsError = unknown;

export type GlacierPolicyErpApiStartErpEndorsementData = {
  body: ErpStartRequest;
  path: {
    policy_id: string;
  };
};

export type GlacierPolicyErpApiStartErpEndorsementResponse = Policy;

export type GlacierPolicyErpApiStartErpEndorsementError = unknown;

export type GlacierPolicyErpApiSaveErpSelectionsData = {
  body: ErpSaveRequest;
  path: {
    policy_id: string;
  };
};

export type GlacierPolicyErpApiSaveErpSelectionsResponse = Array<ErpSection>;

export type GlacierPolicyErpApiSaveErpSelectionsError = unknown;

export type GlacierOneschemaApiGetJwtTokenResponse = TokenSchema;

export type GlacierOneschemaApiGetJwtTokenError = Message;

export type GlacierOneschemaApiBulkUploadPoliciesData = {
  body: OneSchemaPolicyRequest;
};

export type GlacierOneschemaApiBulkUploadPoliciesResponse = BulkPolicyResponse;

export type GlacierOneschemaApiBulkUploadPoliciesError = Message;

export type GlacierOneschemaApiBulkUploadDentistsData = {
  body: OneSchemaDentistRequest;
};

export type GlacierOneschemaApiBulkUploadDentistsResponse = BulkDentistResponse;

export type GlacierOneschemaApiBulkUploadDentistsError = Message;

export type GlacierOneschemaApiBulkUploadLocationsData = {
  body: OneSchemaPropertyRequest;
};

export type GlacierOneschemaApiBulkUploadLocationsResponse =
  BulkPropertyResponse;

export type GlacierOneschemaApiBulkUploadLocationsError = Message;

export type GlacierAgenciesApiListWritingCompanyResponse =
  Array<WritingCompanySchema>;

export type GlacierAgenciesApiListWritingCompanyError = unknown;

export type GlacierNewGradApiValidateAgencyData = {
  body: ValidateAgencyRequest;
};

export type GlacierNewGradApiValidateAgencyResponse = ValidatedAgencyResponse;

export type GlacierNewGradApiValidateAgencyError = string;

export type GlacierNewGradApiSaveAnswersData = {
  body: AnswersRequest;
};

export type GlacierNewGradApiSaveAnswersResponse = AnswersResponse;

export type GlacierNewGradApiSaveAnswersError = unknown;

export type GlacierNewGradApiGetAnswersData = {
  path: {
    account_id: string;
  };
};

export type GlacierNewGradApiGetAnswersResponse = AnswersResponse;

export type GlacierNewGradApiGetAnswersError = unknown;

export type GlacierNewGradApiPollPaymentData = {
  path: {
    account_id: string;
  };
};

export type GlacierNewGradApiPollPaymentResponse = Payment | null;

export type GlacierNewGradApiPollPaymentError = unknown;

export type GlacierNewGradApiDownloadQuoteData = {
  path: {
    account_id: string;
  };
};

export type GlacierNewGradApiDownloadQuoteResponse = Blob | File;

export type GlacierNewGradApiDownloadQuoteError = unknown;

export type GlacierNewGradApiDownloadPolicyData = {
  path: {
    account_id: string;
  };
};

export type GlacierNewGradApiDownloadPolicyResponse = Blob | File;

export type GlacierNewGradApiDownloadPolicyError = unknown;

export type GlacierPolicyApiListPoliciesResponseTransformer = (
  data: any
) => Promise<GlacierPolicyApiListPoliciesResponse>;

export type PolicyModelResponseTransformer = (data: any) => Policy;

export type TransactionModelResponseTransformer = (data: any) => Transaction;

export type FormulasForUiModelResponseTransformer = (
  data: any
) => FormulasForUi;

export const FormulasForUiModelResponseTransformer: FormulasForUiModelResponseTransformer =
  (data) => {
    if (data?.effective_date) {
      data.effective_date = new Date(data.effective_date);
    }
    if (data?.expiration_date) {
      data.expiration_date = new Date(data.expiration_date);
    }
    return data;
  };

export const TransactionModelResponseTransformer: TransactionModelResponseTransformer =
  (data) => {
    if (data?.createdAt) {
      data.createdAt = new Date(data.createdAt);
    }
    if (Array.isArray(data?.formulasForUi)) {
      data.formulasForUi.forEach(FormulasForUiModelResponseTransformer);
    }
    return data;
  };

export type FileDocumentModelResponseTransformer = (data: any) => FileDocument;

export const FileDocumentModelResponseTransformer: FileDocumentModelResponseTransformer =
  (data) => {
    if (data?.createdAt) {
      data.createdAt = new Date(data.createdAt);
    }
    return data;
  };

export const PolicyModelResponseTransformer: PolicyModelResponseTransformer = (
  data
) => {
  if (Array.isArray(data?.transactions)) {
    data.transactions.forEach(TransactionModelResponseTransformer);
  }
  if (Array.isArray(data?.documentWarehouse)) {
    data.documentWarehouse.forEach(FileDocumentModelResponseTransformer);
  }
  if (data?.latestTransaction) {
    TransactionModelResponseTransformer(data.latestTransaction);
  }
  if (Array.isArray(data?.formulasForUi)) {
    data.formulasForUi.forEach(FormulasForUiModelResponseTransformer);
  }
  return data;
};

export const GlacierPolicyApiListPoliciesResponseTransformer: GlacierPolicyApiListPoliciesResponseTransformer =
  async (data) => {
    if (Array.isArray(data)) {
      data.forEach(PolicyModelResponseTransformer);
    }
    return data;
  };

export type GlacierPolicyApiCreatePolicyResponseTransformer = (
  data: any
) => Promise<GlacierPolicyApiCreatePolicyResponse>;

export const GlacierPolicyApiCreatePolicyResponseTransformer: GlacierPolicyApiCreatePolicyResponseTransformer =
  async (data) => {
    PolicyModelResponseTransformer(data);
    return data;
  };

export type GlacierPolicyApiValidatePolicyFieldsResponseTransformer = (
  data: any
) => Promise<GlacierPolicyApiValidatePolicyFieldsResponse>;

export type ResultModelResponseTransformer = (data: any) => Result;

export const ResultModelResponseTransformer: ResultModelResponseTransformer = (
  data
) => {
  if (data?.timestamp) {
    data.timestamp = new Date(data.timestamp);
  }
  return data;
};

export const GlacierPolicyApiValidatePolicyFieldsResponseTransformer: GlacierPolicyApiValidatePolicyFieldsResponseTransformer =
  async (data) => {
    ResultModelResponseTransformer(data);
    return data;
  };

export type GlacierPolicyApiDeleteDentistResponseTransformer = (
  data: any
) => Promise<GlacierPolicyApiDeleteDentistResponse>;

export const GlacierPolicyApiDeleteDentistResponseTransformer: GlacierPolicyApiDeleteDentistResponseTransformer =
  async (data) => {
    PolicyModelResponseTransformer(data);
    return data;
  };

export type GlacierPolicyApiRatePolicyResponseTransformer = (
  data: any
) => Promise<GlacierPolicyApiRatePolicyResponse>;

export const GlacierPolicyApiRatePolicyResponseTransformer: GlacierPolicyApiRatePolicyResponseTransformer =
  async (data) => {
    PolicyModelResponseTransformer(data);
    return data;
  };

export type GlacierPolicyApiGetFormulasResponseTransformer = (
  data: any
) => Promise<GlacierPolicyApiGetFormulasResponse>;

export const GlacierPolicyApiGetFormulasResponseTransformer: GlacierPolicyApiGetFormulasResponseTransformer =
  async (data) => {
    if (Array.isArray(data)) {
      data.forEach(FormulasForUiModelResponseTransformer);
    }
    return data;
  };

export type GlacierPolicyApiDeleteOwnedEntityResponseTransformer = (
  data: any
) => Promise<GlacierPolicyApiDeleteOwnedEntityResponse>;

export const GlacierPolicyApiDeleteOwnedEntityResponseTransformer: GlacierPolicyApiDeleteOwnedEntityResponseTransformer =
  async (data) => {
    PolicyModelResponseTransformer(data);
    return data;
  };

export type GlacierPolicyApiCreateMidtermTransactionResponseTransformer = (
  data: any
) => Promise<GlacierPolicyApiCreateMidtermTransactionResponse>;

export const GlacierPolicyApiCreateMidtermTransactionResponseTransformer: GlacierPolicyApiCreateMidtermTransactionResponseTransformer =
  async (data) => {
    PolicyModelResponseTransformer(data);
    return data;
  };

export type GlacierPolicyApiPricePreviewMidtermChangeResponseTransformer = (
  data: any
) => Promise<GlacierPolicyApiPricePreviewMidtermChangeResponse>;

export type MidtermPreviewResponseModelResponseTransformer = (
  data: any
) => MidtermPreviewResponse;

export const MidtermPreviewResponseModelResponseTransformer: MidtermPreviewResponseModelResponseTransformer =
  (data) => {
    if (Array.isArray(data?.formulasForUi)) {
      data.formulasForUi.forEach(FormulasForUiModelResponseTransformer);
    }
    return data;
  };

export const GlacierPolicyApiPricePreviewMidtermChangeResponseTransformer: GlacierPolicyApiPricePreviewMidtermChangeResponseTransformer =
  async (data) => {
    MidtermPreviewResponseModelResponseTransformer(data);
    return data;
  };

export type GlacierPolicyApiFinalizeMidtermChangeResponseTransformer = (
  data: any
) => Promise<GlacierPolicyApiFinalizeMidtermChangeResponse>;

export const GlacierPolicyApiFinalizeMidtermChangeResponseTransformer: GlacierPolicyApiFinalizeMidtermChangeResponseTransformer =
  async (data) => {
    PolicyModelResponseTransformer(data);
    return data;
  };

export type GlacierPolicyApiCancelMidtermChangeResponseTransformer = (
  data: any
) => Promise<GlacierPolicyApiCancelMidtermChangeResponse>;

export const GlacierPolicyApiCancelMidtermChangeResponseTransformer: GlacierPolicyApiCancelMidtermChangeResponseTransformer =
  async (data) => {
    PolicyModelResponseTransformer(data);
    return data;
  };

export type GlacierPolicyApiRevertTransactionResponseTransformer = (
  data: any
) => Promise<GlacierPolicyApiRevertTransactionResponse>;

export const GlacierPolicyApiRevertTransactionResponseTransformer: GlacierPolicyApiRevertTransactionResponseTransformer =
  async (data) => {
    PolicyModelResponseTransformer(data);
    return data;
  };

export type GlacierPolicyApiListDocumentsResponseTransformer = (
  data: any
) => Promise<GlacierPolicyApiListDocumentsResponse>;

export type FileDocumentSchemaModelResponseTransformer = (
  data: any
) => FileDocumentSchema;

export const FileDocumentSchemaModelResponseTransformer: FileDocumentSchemaModelResponseTransformer =
  (data) => {
    if (Array.isArray(data?.documentWarehouse)) {
      data.documentWarehouse.forEach(FileDocumentModelResponseTransformer);
    }
    return data;
  };

export const GlacierPolicyApiListDocumentsResponseTransformer: GlacierPolicyApiListDocumentsResponseTransformer =
  async (data) => {
    if (Array.isArray(data)) {
      data.forEach(FileDocumentSchemaModelResponseTransformer);
    }
    return data;
  };

export type GlacierPolicyApiListUnderwriterNotesResponseTransformer = (
  data: any
) => Promise<GlacierPolicyApiListUnderwriterNotesResponse>;

export type UnderwriterNoteSchemaModelResponseTransformer = (
  data: any
) => UnderwriterNoteSchema;

export const UnderwriterNoteSchemaModelResponseTransformer: UnderwriterNoteSchemaModelResponseTransformer =
  (data) => {
    if (data?.createdAt) {
      data.createdAt = new Date(data.createdAt);
    }
    return data;
  };

export const GlacierPolicyApiListUnderwriterNotesResponseTransformer: GlacierPolicyApiListUnderwriterNotesResponseTransformer =
  async (data) => {
    if (Array.isArray(data)) {
      data.forEach(UnderwriterNoteSchemaModelResponseTransformer);
    }
    return data;
  };

export type GlacierPolicyApiCreateUnderwriterNotesResponseTransformer = (
  data: any
) => Promise<GlacierPolicyApiCreateUnderwriterNotesResponse>;

export const GlacierPolicyApiCreateUnderwriterNotesResponseTransformer: GlacierPolicyApiCreateUnderwriterNotesResponseTransformer =
  async (data) => {
    UnderwriterNoteSchemaModelResponseTransformer(data);
    return data;
  };

export type GlacierPolicyApiUpdateUnderwriterNotesResponseTransformer = (
  data: any
) => Promise<GlacierPolicyApiUpdateUnderwriterNotesResponse>;

export const GlacierPolicyApiUpdateUnderwriterNotesResponseTransformer: GlacierPolicyApiUpdateUnderwriterNotesResponseTransformer =
  async (data) => {
    UnderwriterNoteSchemaModelResponseTransformer(data);
    return data;
  };

export type GlacierPolicyApiCreatePolicyPendingCancellationTransactionResponseTransformer =
  (
    data: any
  ) => Promise<GlacierPolicyApiCreatePolicyPendingCancellationTransactionResponse>;

export const GlacierPolicyApiCreatePolicyPendingCancellationTransactionResponseTransformer: GlacierPolicyApiCreatePolicyPendingCancellationTransactionResponseTransformer =
  async (data) => {
    PolicyModelResponseTransformer(data);
    return data;
  };

export type GlacierPolicyApiListTransactionsResponseTransformer = (
  data: any
) => Promise<GlacierPolicyApiListTransactionsResponse>;

export type TransactionSnapshotSchemaModelResponseTransformer = (
  data: any
) => TransactionSnapshotSchema;

export const TransactionSnapshotSchemaModelResponseTransformer: TransactionSnapshotSchemaModelResponseTransformer =
  (data) => {
    if (data?.transactionDate) {
      data.transactionDate = new Date(data.transactionDate);
    }
    if (data?.eventDate) {
      data.eventDate = new Date(data.eventDate);
    }
    return data;
  };

export const GlacierPolicyApiListTransactionsResponseTransformer: GlacierPolicyApiListTransactionsResponseTransformer =
  async (data) => {
    if (Array.isArray(data)) {
      data.forEach(TransactionSnapshotSchemaModelResponseTransformer);
    }
    return data;
  };

export type GlacierPolicyApiGetTransactionDetailResponseTransformer = (
  data: any
) => Promise<GlacierPolicyApiGetTransactionDetailResponse>;

export type TransactionDetailSchemaModelResponseTransformer = (
  data: any
) => TransactionDetailSchema;

export const TransactionDetailSchemaModelResponseTransformer: TransactionDetailSchemaModelResponseTransformer =
  (data) => {
    if (data?.transactionDate) {
      data.transactionDate = new Date(data.transactionDate);
    }
    return data;
  };

export const GlacierPolicyApiGetTransactionDetailResponseTransformer: GlacierPolicyApiGetTransactionDetailResponseTransformer =
  async (data) => {
    TransactionDetailSchemaModelResponseTransformer(data);
    return data;
  };

export type GlacierPolicyFormsApiAttachFormToPolicyResponseTransformer = (
  data: any
) => Promise<GlacierPolicyFormsApiAttachFormToPolicyResponse>;

export const GlacierPolicyFormsApiAttachFormToPolicyResponseTransformer: GlacierPolicyFormsApiAttachFormToPolicyResponseTransformer =
  async (data) => {
    PolicyModelResponseTransformer(data);
    return data;
  };

export type GlacierPolicyFormsApiGetQuestionsByPolicyResponseTransformer = (
  data: any
) => Promise<GlacierPolicyFormsApiGetQuestionsByPolicyResponse>;

export type FrontendQuestionSchemaModelResponseTransformer = (
  data: any
) => FrontendQuestionSchema;

export const FrontendQuestionSchemaModelResponseTransformer: FrontendQuestionSchemaModelResponseTransformer =
  (data) => {
    if (Array.isArray(data?.sub_questions)) {
      data.sub_questions.forEach(
        FrontendQuestionSchemaModelResponseTransformer
      );
    }
    return data;
  };

export const GlacierPolicyFormsApiGetQuestionsByPolicyResponseTransformer: GlacierPolicyFormsApiGetQuestionsByPolicyResponseTransformer =
  async (data) => {
    if (Array.isArray(data)) {
      data.forEach(FrontendQuestionSchemaModelResponseTransformer);
    }
    return data;
  };

export type GlacierPolicyFormsApiGetQuestionsByDentistResponseTransformer = (
  data: any
) => Promise<GlacierPolicyFormsApiGetQuestionsByDentistResponse>;

export const GlacierPolicyFormsApiGetQuestionsByDentistResponseTransformer: GlacierPolicyFormsApiGetQuestionsByDentistResponseTransformer =
  async (data) => {
    if (Array.isArray(data)) {
      data.forEach(FrontendQuestionSchemaModelResponseTransformer);
    }
    return data;
  };

export type GlacierPolicyFormsApiGetQuestionsByLocationResponseTransformer = (
  data: any
) => Promise<GlacierPolicyFormsApiGetQuestionsByLocationResponse>;

export const GlacierPolicyFormsApiGetQuestionsByLocationResponseTransformer: GlacierPolicyFormsApiGetQuestionsByLocationResponseTransformer =
  async (data) => {
    if (Array.isArray(data)) {
      data.forEach(FrontendQuestionSchemaModelResponseTransformer);
    }
    return data;
  };

export type GlacierPolicyFormsApiGetQuestionsByEntityResponseTransformer = (
  data: any
) => Promise<GlacierPolicyFormsApiGetQuestionsByEntityResponse>;

export const GlacierPolicyFormsApiGetQuestionsByEntityResponseTransformer: GlacierPolicyFormsApiGetQuestionsByEntityResponseTransformer =
  async (data) => {
    if (Array.isArray(data)) {
      data.forEach(FrontendQuestionSchemaModelResponseTransformer);
    }
    return data;
  };

export type GlacierPolicyConditionsApiListBindingConditionsResponseTransformer =
  (
    data: any
  ) => Promise<GlacierPolicyConditionsApiListBindingConditionsResponse>;

export type BindingConditionsSchemaModelResponseTransformer = (
  data: any
) => BindingConditionsSchema;

export const BindingConditionsSchemaModelResponseTransformer: BindingConditionsSchemaModelResponseTransformer =
  (data) => {
    if (data?.createdAt) {
      data.createdAt = new Date(data.createdAt);
    }
    return data;
  };

export const GlacierPolicyConditionsApiListBindingConditionsResponseTransformer: GlacierPolicyConditionsApiListBindingConditionsResponseTransformer =
  async (data) => {
    if (Array.isArray(data)) {
      data.forEach(BindingConditionsSchemaModelResponseTransformer);
    }
    return data;
  };

export type GlacierPolicyConditionsApiCreateBindingConditionResponseTransformer =
  (
    data: any
  ) => Promise<GlacierPolicyConditionsApiCreateBindingConditionResponse>;

export const GlacierPolicyConditionsApiCreateBindingConditionResponseTransformer: GlacierPolicyConditionsApiCreateBindingConditionResponseTransformer =
  async (data) => {
    BindingConditionsSchemaModelResponseTransformer(data);
    return data;
  };

export type GlacierPolicyConditionsApiUpdateBindingConditionResponseTransformer =
  (
    data: any
  ) => Promise<GlacierPolicyConditionsApiUpdateBindingConditionResponse>;

export const GlacierPolicyConditionsApiUpdateBindingConditionResponseTransformer: GlacierPolicyConditionsApiUpdateBindingConditionResponseTransformer =
  async (data) => {
    BindingConditionsSchemaModelResponseTransformer(data);
    return data;
  };

export type GlacierPolicyConditionsApiListTermsConditionsResponseTransformer = (
  data: any
) => Promise<GlacierPolicyConditionsApiListTermsConditionsResponse>;

export type TermConditionsSchemaModelResponseTransformer = (
  data: any
) => TermConditionsSchema;

export const TermConditionsSchemaModelResponseTransformer: TermConditionsSchemaModelResponseTransformer =
  (data) => {
    if (data?.createdAt) {
      data.createdAt = new Date(data.createdAt);
    }
    return data;
  };

export const GlacierPolicyConditionsApiListTermsConditionsResponseTransformer: GlacierPolicyConditionsApiListTermsConditionsResponseTransformer =
  async (data) => {
    if (Array.isArray(data)) {
      data.forEach(TermConditionsSchemaModelResponseTransformer);
    }
    return data;
  };

export type GlacierPolicyConditionsApiCreateTermsConditionResponseTransformer =
  (
    data: any
  ) => Promise<GlacierPolicyConditionsApiCreateTermsConditionResponse>;

export const GlacierPolicyConditionsApiCreateTermsConditionResponseTransformer: GlacierPolicyConditionsApiCreateTermsConditionResponseTransformer =
  async (data) => {
    TermConditionsSchemaModelResponseTransformer(data);
    return data;
  };

export type GlacierPolicyConditionsApiUpdateTermsConditionResponseTransformer =
  (
    data: any
  ) => Promise<GlacierPolicyConditionsApiUpdateTermsConditionResponse>;

export const GlacierPolicyConditionsApiUpdateTermsConditionResponseTransformer: GlacierPolicyConditionsApiUpdateTermsConditionResponseTransformer =
  async (data) => {
    TermConditionsSchemaModelResponseTransformer(data);
    return data;
  };

export type GlacierPolicyErpApiGetErpSectionsResponseTransformer = (
  data: any
) => Promise<GlacierPolicyErpApiGetErpSectionsResponse>;

export type ErpSectionModelResponseTransformer = (data: any) => ErpSection;

export type ErpRowModelResponseTransformer = (data: any) => ErpRow;

export const ErpRowModelResponseTransformer: ErpRowModelResponseTransformer = (
  data
) => {
  if (data?.effectiveDate) {
    data.effectiveDate = new Date(data.effectiveDate);
  }
  return data;
};

export const ErpSectionModelResponseTransformer: ErpSectionModelResponseTransformer =
  (data) => {
    if (Array.isArray(data?.rows)) {
      data.rows.forEach(ErpRowModelResponseTransformer);
    }
    return data;
  };

export const GlacierPolicyErpApiGetErpSectionsResponseTransformer: GlacierPolicyErpApiGetErpSectionsResponseTransformer =
  async (data) => {
    if (Array.isArray(data)) {
      data.forEach(ErpSectionModelResponseTransformer);
    }
    return data;
  };

export type GlacierPolicyErpApiStartErpEndorsementResponseTransformer = (
  data: any
) => Promise<GlacierPolicyErpApiStartErpEndorsementResponse>;

export const GlacierPolicyErpApiStartErpEndorsementResponseTransformer: GlacierPolicyErpApiStartErpEndorsementResponseTransformer =
  async (data) => {
    PolicyModelResponseTransformer(data);
    return data;
  };

export type GlacierPolicyErpApiSaveErpSelectionsResponseTransformer = (
  data: any
) => Promise<GlacierPolicyErpApiSaveErpSelectionsResponse>;

export const GlacierPolicyErpApiSaveErpSelectionsResponseTransformer: GlacierPolicyErpApiSaveErpSelectionsResponseTransformer =
  async (data) => {
    if (Array.isArray(data)) {
      data.forEach(ErpSectionModelResponseTransformer);
    }
    return data;
  };

export type GlacierNewGradApiSaveAnswersResponseTransformer = (
  data: any
) => Promise<GlacierNewGradApiSaveAnswersResponse>;

export type AnswersResponseModelResponseTransformer = (
  data: any
) => AnswersResponse;

export const AnswersResponseModelResponseTransformer: AnswersResponseModelResponseTransformer =
  (data) => {
    if (data?.transactionDate) {
      data.transactionDate = new Date(data.transactionDate);
    }
    return data;
  };

export const GlacierNewGradApiSaveAnswersResponseTransformer: GlacierNewGradApiSaveAnswersResponseTransformer =
  async (data) => {
    AnswersResponseModelResponseTransformer(data);
    return data;
  };

export type GlacierNewGradApiGetAnswersResponseTransformer = (
  data: any
) => Promise<GlacierNewGradApiGetAnswersResponse>;

export const GlacierNewGradApiGetAnswersResponseTransformer: GlacierNewGradApiGetAnswersResponseTransformer =
  async (data) => {
    AnswersResponseModelResponseTransformer(data);
    return data;
  };
